import React from "react";
import { setNull, toNumber, ConvertListToString, DegreesToRadians, GetColourArray, Cos } from "../components/Common";
import { BASIC_SPECS_SECTIONS, SITE_PARAMETER_SECTIONS } from "./jobState_Schemas";
import { UPDATE_AREA_SPECIFICATION } from "./jobState";
import * as CONFIG from "./configState";
import * as COMMON from "../components/Common";
import {
    GetAreaDescription,
    GetDesignStringShort,
    GetNumberofSkylightsSummaryArea,
} from "../components_designer/main_drawer/QuotePage";
import { jobReadyStateErrorPopups, jobStateErrorPopups, jobWarningPopups } from "./jobStateWarningPopups";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import { GetShapeUpdateString } from "../components_designer/layout/PaperFunctionHelper";
import { GetBeamHeight } from "../components_designer/main_drawer/BracketDesignerHelper";
import {
    getOffsets,
    getRoofAlignmentFromRef,
    adjustOffsetForSide,
} from "../components_designer/context_options/SpecModifyAttachmentHelper";
import { showDialog } from "./appState";

const { find_join_angle_extension } = require("../components/Common_Conversions");

// 2D Designer Actions
export const SHOW_DESIGNER_MESSAGE = "SHOW_DESIGNER_MESSAGE";
export const CLEAR_DESIGNER_MESSAGE = "CLEAR_DESIGNER_MESSAGE";
export const APPEND_DESIGNER_MESSAGE = "APPEND_DESIGNER_MESSAGE";

export const GetItems = (parameters) => {
    if (window.svg && window.paper) {
        return window.paper.project.getItems(parameters);
    }
    return null;
};

export const validateJob = (job, config, dispatch) => {
    job = COMMON.deepCopy(job);

    if (config) {
        // VALIDATEA AREAS
        job.ErrorMap.AreaSpecifications = [];
        job.AreaSpecifications.forEach(function (area, index) {
            let area_design_options = config?.design_options?.[area.SHAPE.DesignType];
            let result = validateAreaSpecification(job, area, index, setNull(area), area_design_options, dispatch);
            area = result.area;
            job.ErrorMap.AreaSpecifications.push(result.errorMap);
        });
    }

    job = validateCustomerDistributorData(job);

    return job;
};

const validateAreaSpecification = (job, area, index, errorMap, area_design_options, dispatch) => {
    // VALIDATE SHAPE SETUP
    errorMap.SHAPE.Height = { name: "Height", range: COMMON.replaceVariables(area, area_design_options.height_range) };

    //check values
    errorMap.SHAPE.Height = validateNumberRange(area.SHAPE.Height, errorMap.SHAPE.Height);
    area.SHAPE.Height = errorMap.SHAPE.Height.value;

    if (errorMap.SHAPE.Height.message) {
        dispatch({
            type: SHOW_DESIGNER_MESSAGE,
            message: errorMap.SHAPE.Height.message,
        });
    }

    return {
        area: area,
        errorMap: errorMap,
    };
};

export const validateFullJob = (config, job, areaIndex = -1, app = null) => {
    // always set areaa meta, espcially to update origin base variables from SVG
    for (let index in job.AreaSpecifications) {
        let areaIndex = Number(index);
        job = setAreaMeta(config, job, areaIndex);
    }

    let this_hash = COMMON.hashCode(
        JSON.stringify(job.AreaSpecifications) +
            JSON.stringify(job.DesignParameters) +
            JSON.stringify(job.SiteParameters)
    );
    if (window.last_validateFullJob_hash === this_hash) {
        return job;
    }
    window.last_validateFullJob_hash = this_hash;
    let region = job?.Distributor?.Offer?.Regions?.[0];

    if (job?.App?.temp_POA) region = job?.App?.temp_POA;
    if (region && config?.region?.id !== region) {
        let poa_region_key = config?.region?.id + "," + region;
        if (window.debug && window.POAMismatchWarning !== poa_region_key) {
            window.POAMismatchWarning = poa_region_key;
            alert("cannot validate as config is not matching..." + config?.region?.id + " vs " + region);
        }
        return job;
    }

    job = validateCustomerDistributorData(job, app);

    if (areaIndex < 0) {
        for (let index in job.AreaSpecifications) {
            let areaIndex = Number(index);
            job.AreaSpecifications[areaIndex].AreaIndex = areaIndex;
            job = setAreaMeta(config, job, areaIndex);
        }
    }
    job = AddMetaDataDesignParameters(job);
    job = validateSiteData(job, config);

    if (job?.UNDO_ACTION?.config) {
        job.UNDO_ACTION.config = null;
    }

    job.QuoteParameters.ShowFlatPostDimensions = 1;
    if (job?.AreaSpecifications?.[0]?.SHAPE?.DesignType === "Flat Deck") {
        job.DesignParameters.DeckMode = 1;
    }
    if (job?.AreaSpecifications?.[0]?.SHAPE?.DesignType === "Louvre Roof") {
        job.DesignParameters.LouvreMode = 1;
    }

    if (areaIndex < 0) {
        for (let index in job.AreaSpecifications) {
            let areaIndex = Number(index);
            let this_area_data = job.AreaSpecifications[areaIndex];

            job = validateAreaShape(config, job, areaIndex, false);

            job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.ROOF_SHEETING] = validateRoofSheetData(
                config,
                job,
                areaIndex
            );
            job = validateAreaShape_Overhangs(config, job, areaIndex, false);
            job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.ATTACHMENTS] = validateAreaAttachmentData(
                config,
                job,
                areaIndex
            );

            job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS] = validateBeamPostData(
                config,
                job,
                areaIndex
            );
            job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES] = validateGutterDownpipeData(
                config,
                job,
                areaIndex
            );
            if (
                this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
                this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
            ) {
                job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.GABLE_PARAMETERS] = validateGableParameters(
                    config,
                    job,
                    areaIndex
                );
            }
            job = validateOptions(config, job, areaIndex);
            job = validateEngineeringAndDesign(config, job, areaIndex);
            job = validateDecks(config, job, areaIndex);
            job = setAreaMeta(config, job, areaIndex);
            job = validateAreaShape(config, job, areaIndex, true); // done twice in case of changed to materials affect the shape

            // other settings
            if (
                (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT ||
                    this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) &&
                job.DesignParameters.Freestanding
            ) {
                if (job?.Distributor?.Brand === "Lysaght") {
                } else {
                    job.AreaSpecifications[areaIndex]["Footings"] = [];
                }
            }
        }
    } else {
        let this_area_data = job.AreaSpecifications[areaIndex];
        job = setAreaMeta(config, job, areaIndex);

        job = validateAreaShape(config, job, areaIndex, false);
        job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.ROOF_SHEETING] = validateRoofSheetData(
            config,
            job,
            areaIndex
        );
        job = validateAreaShape_Overhangs(config, job, areaIndex);
        job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS] = validateBeamPostData(
            config,
            job,
            areaIndex
        );
        job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES] = validateGutterDownpipeData(
            config,
            job,
            areaIndex
        );
        if (
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
        ) {
            job.AreaSpecifications[areaIndex][BASIC_SPECS_SECTIONS.GABLE_PARAMETERS] = validateGableParameters(
                config,
                job,
                areaIndex
            );
        }
        job = validateOptions(config, job, areaIndex);
        job = setAreaMeta(config, job, areaIndex);
        job = validateAreaShape(config, job, areaIndex, false);
    }

    job.SupplementaryEngineering = checkSupplementaryEngineering(config, job, areaIndex);

    if (app?.user && !job.App.Locked && !app?.user?.id.includes("diego.portela")) {
        const user_data = app?.user;
        if (job?.LastEditor?.id) {
            if (job?.LastEditor?.id !== user_data.id) {
                if (!job?.LastEditorHistory) job.LastEditorHistory = [];
                job.LastEditorHistory.push(job.LastEditor);
            }
        }
        job.LastEditor = {
            id: user_data.id,
            DisplayName: user_data.DisplayName,
            UserCode: user_data.UserCode,
            _session_id: window?.session_id,
            _ts: Date.now(),
        };
    }

    return job;
};

export const AddMetaDataDesignParameters = (job) => {
    job.DesignParameters.Freestanding = true;
    job.DesignParameters.NumAreas = job?.AreaSpecifications?.length;
    job.DesignParameters.NumFlat = 0;
    job.DesignParameters.HasFlat = false;
    job.DesignParameters.NumGable = 0;
    job.DesignParameters.HasGable = false;
    job.DesignParameters.NumDeck = 0;
    job.DesignParameters.HasBondor = false;
    job.DesignParameters.HasVersiclad = false;
    job.DesignParameters.USE_BOM_SPLICING = true;
    job.DesignParameters.TotalLength = 0;

    let total_height = 0;
    for (let area of job.AreaSpecifications) {
        let area_freestanding = true;
        if (area?.META?.IsFreestanding != undefined) {
            area_freestanding = area?.META?.IsFreestanding;
        } else {
            if (area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentLeft === 1) {
                area_freestanding = false;
            } else if (area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentRight === 1) {
                area_freestanding = false;
            } else if (area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentTop === 1) {
                area_freestanding = false;
            } else if (area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentBottom === 1) {
                area_freestanding = false;
            } else if (
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-CutoutType"] !== "None" &&
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Attachment"] === 1
            ) {
                area_freestanding = false;
            } else if (
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-CutoutType"] !== "None" &&
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Attachment"] === 1
            ) {
                area_freestanding = false;
            } else if (
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-CutoutType"] !== "None" &&
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Attachment"] === 1
            ) {
                area_freestanding = false;
            } else if (
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-CutoutType"] !== "None" &&
                area[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Attachment"] === 1
            ) {
                area_freestanding = false;
            }
        }
        if (!area_freestanding) job.DesignParameters.Freestanding = false;
        area[BASIC_SPECS_SECTIONS.ATTACHMENTS].Freestanding = area_freestanding;

        area.HasDutchGable =
            area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
            (area[BASIC_SPECS_SECTIONS.SHAPE].RoofType1 == "Dutch Gable" ||
                area[BASIC_SPECS_SECTIONS.SHAPE].RoofType2 == "Dutch Gable");

        if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
            job.DesignParameters.HasGable = true;
            job.DesignParameters.NumGable++;
        } else if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) {
            job.DesignParameters.HasGable = true;
            job.DesignParameters.NumGable++;
        } else if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
            job.DesignParameters.HasFlat = true;
            job.DesignParameters.NumFlat++;
        } else if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
            job.DesignParameters.HasFlat = true;
            job.DesignParameters.NumDeck++;
        }
        if (area?.ROOF_SHEETING?.RoofGroupType) {
            if (area.ROOF_SHEETING.RoofGroupType.toUpperCase().includes("BONDOR"))
                job.DesignParameters.HasBondor = true;
            if (area.ROOF_SHEETING.RoofGroupType.toUpperCase().includes("VERSICLAD"))
                job.DesignParameters.HasVersiclad = true;
        }

        job.DesignParameters.TotalLength += area.SHAPE.Length;

        let height = area.SHAPE.Height;
        if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL)
            height = height + area.SHAPE.Depth * 0.5 * COMMON.Sin(area.SHAPE.RoofPitch);
        total_height += height;
    }

    job.DesignParameters.AverageRoofHeight = total_height / job.AreaSpecifications.length;

    for (let area of job.AreaSpecifications) {
        area.Description = GetAreaDescription(area);
    }
    job.DesignSummary = job.DesignParameters?.DesignTemplateName
        ? job.DesignParameters?.DesignTemplateName
        : GetDesignStringShort(job.AreaSpecifications);
    if (job?.OrderStatus) job.OrderStatus = job.OrderStatus.toUpperCase();

    job.QuoteParameters.FreeStanding = job.DesignParameters.Freestanding;

    if (job.DesignParameters.USE_BOM_SPLICING) {
        job.SiteParameters.CONST_GUTTER_MAX_LENGTH = 99999;
        job.SiteParameters.CONST_MAX_FLASHING_LENGTH = 99999;
    } else {
        job.SiteParameters.CONST_GUTTER_MAX_LENGTH = 8000;
        job.SiteParameters.CONST_MAX_FLASHING_LENGTH = 6100;
    }

    return job;
};

export const setAreaMeta = (config, job, areaIndex, secondCheck = false) => {
    let last_area_data = job.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job.AreaSpecifications[areaIndex];
    let next_area_data = job.AreaSpecifications?.[areaIndex + 1];
    if (job.DesignParameters.LoopAreas) {
        if (areaIndex === 0) {
            last_area_data = job.AreaSpecifications?.[job.AreaSpecifications.length - 1];
        }
        if (areaIndex === job.AreaSpecifications.length - 1) {
            next_area_data = job.AreaSpecifications?.[0];
        }
    }

    const GetAreaMeta = (job, this_area_data, side) => {
        let meta_state = {
            HasGutter: false,
            HasBoxGutter: false,
            IsWaterShed: false,
            HasAttachment: false,
            AttachmentType: "None",
            AttachmentVariation: "None",
            IsPartiallyAttached: false,
            PartiallyAttachedHasGutter: false,
            ActualSheetOverhang: 0,
            IsAttachedToBeamOrFascia: function () {
                return (
                    this?.HasAttachment &&
                    this?.AttachmentType &&
                    (this?.AttachmentType.includes("Fascia") || this?.AttachmentType.includes("Beam"))
                );
            },
            IsOnlyHouseGutter: function () {
                return this.IsWaterShed && !this.HasGutter && this.IsAttachedToBeamOrFascia();
            },
            HasBoxGutterToFascia: function () {
                return this.HasBoxGutter && this.IsAttachedToBeamOrFascia();
            },
            HasBeam: function () {
                if (!this?.AttachmentType) return true;
                if (this.AttachmentType === "None") return true;
                if (this.IsPartiallyAttached) return true;
                if (this?.AttachmentType?.includes("Riser")) return true;
                if (this?.AttachmentType?.includes("Beam")) return true;
                if (this?.AttachmentType?.includes("Wall")) {
                    if (this?.AttachmentVariation?.includes("Beam")) return true;
                    return false;
                }
                if (this?.AttachmentType?.includes("Flyover")) return true;
                if (this?.AttachmentType?.includes("Fascia")) return false;
                return true;
            },
        };

        let is_flat = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT;

        let attachmentKey = "Attachment" + side;
        if (side === "Front") attachmentKey = "AttachmentBottom";
        if (side === "Back") attachmentKey = "AttachmentTop";

        if (this_area_data.ATTACHMENTS[attachmentKey] == 1) {
            meta_state.HasAttachment = true;
            meta_state.AttachmentType = job.SiteParameters.ExistingStructure.AttachmentType;
        }

        let gutterKey = "GutterB";
        if (attachmentKey === "AttachmentBottom") gutterKey = "GutterF";
        if (attachmentKey === "AttachmentLeft") gutterKey = "GutterL";
        if (attachmentKey === "AttachmentRight") gutterKey = "GutterR";

        if (this_area_data.GUTTERS_AND_DOWNPIPES[gutterKey] >= 1) {
            meta_state.HasGutter = true;
            if (this_area_data.GUTTERS_AND_DOWNPIPES[gutterKey] === 2) {
                meta_state.HasBoxGutter = true;
            }
        }

        let paats = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS;
        if (paats && paats.length > 0) {
            let paat = paats.filter((obj) => {
                return obj.Name.includes(side);
            });
            if (paat && paat.length > 0) {
                meta_state.IsPartiallyAttached = true;
                meta_state.PartiallyAttachedHasGutter = paat.HasGutter;
            }
        }

        let mod_items = [];
        if (this_area_data?.ATTACHMENTS?.AttachmentModifications?.filter)
            mod_items = this_area_data?.ATTACHMENTS?.AttachmentModifications?.filter((obj) => {
                return obj?.Name ? obj?.Name?.includes(side) : false;
            });
        if (mod_items && mod_items.length > 0) {
            if (mod_items[0]?.FasciaType && meta_state.HasAttachment) {
                meta_state.AttachmentType = mod_items[0]?.AttachmentType;
                meta_state.AttachmentVariation = mod_items[0]?.AttachmentVariation;
            }
        }

        if (is_flat) {
            if (side === "Front") {
                if (this_area_data.SHAPE.SheetDirection === "Front") meta_state.IsWaterShed = true;
            } else if (side === "Back") {
                if (this_area_data.SHAPE.SheetDirection === "Back") meta_state.IsWaterShed = true;
            } else if (side === "Left") {
                if (this_area_data.SHAPE.SheetDirection === "Left") meta_state.IsWaterShed = true;
            } else if (side === "Right") {
                if (this_area_data.SHAPE.SheetDirection === "Right") meta_state.IsWaterShed = true;
            }
        } else if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
            if (side === "Front") {
                meta_state.IsWaterShed = true;
            } else if (side === "Back") {
                meta_state.IsWaterShed = true;
            } else if (side === "Left") {
                if (this_area_data.SHAPE.RoofType1 === "Hip" || this_area_data.SHAPE.RoofType1 === "Dutch Gable")
                    meta_state.IsWaterShed = true;
            } else if (side === "Right") {
                if (this_area_data.SHAPE.RoofType2 === "Hip" || this_area_data.SHAPE.RoofType2 === "Dutch Gable")
                    meta_state.IsWaterShed = true;
            }
        }

        if (is_flat) {
            if (side === "Front") {
                if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-WidthX"]) >=
                        this_area_data.SHAPE.Length - 50
                    ) {
                        meta_state.IsFullTaper = true;
                        meta_state.HasAttachment = false;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-WidthX"]) >=
                        this_area_data.SHAPE.Length - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                }
            }
            if (side === "Back") {
                if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-WidthX"]) >=
                        this_area_data.SHAPE.Length - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-WidthX"]) >=
                        this_area_data.SHAPE.Length - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                }
            }
            if (side === "Left") {
                if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-WidthY"]) >=
                        this_area_data.SHAPE.Depth - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-WidthY"]) >=
                        this_area_data.SHAPE.Depth - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                }
            }
            if (side === "Right") {
                if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-WidthY"]) >=
                        this_area_data.SHAPE.Depth - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-CutoutType"] === "Angle") {
                    if (
                        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-WidthY"]) >=
                        this_area_data.SHAPE.Depth - 50
                    ) {
                        meta_state.IsFullTaper = true;
                    }
                    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Attachment"] === 1) {
                        if (meta_state.IsFullTaper) meta_state.HasAttachment = true;
                        else meta_state.IsPartiallyAttached = true;
                    }
                }
            }
        }

        if (side === "Front") {
            meta_state.ActualSheetOverhang =
                (this_area_data.SHAPE.OH_Front || 0) + (this_area_data.SHAPE.OH_Front_Sheet || 0);
        } else if (side === "Back") {
            meta_state.ActualSheetOverhang =
                (this_area_data.SHAPE.OH_Back || 0) + (this_area_data.SHAPE.OH_Back_Sheet || 0);
        } else if (side === "Left") {
            meta_state.ActualSheetOverhang =
                (this_area_data.SHAPE.OH_Left || 0) + (this_area_data.SHAPE.OH_Left_Sheet || 0);
        } else if (side === "Right") {
            meta_state.ActualSheetOverhang =
                (this_area_data.SHAPE.OH_Right || 0) + (this_area_data.SHAPE.OH_Right_Sheet || 0);
        }

        if (meta_state.HasAttachment && !meta_state.IsPartiallyAttached) {
            if (meta_state.AttachmentType.includes("Fascia") || meta_state.AttachmentType.includes("Wall")) {
                meta_state.ActualSheetOverhang = 0;
            }
        }

        return meta_state;
    };

    let meta = {
        ...this_area_data.META,
        HasBoxGutterToFascia: function () {
            return (
                meta.FrontState.HasBoxGutterToFascia() ||
                meta.BackState.HasBoxGutterToFascia() ||
                meta.LeftState.HasBoxGutterToFascia() ||
                meta.RightState.HasBoxGutterToFascia()
            );
        },
        HasIsOnlyHouseGutter: function () {
            return (
                meta.FrontState.IsOnlyHouseGutter() ||
                meta.BackState.IsOnlyHouseGutter() ||
                meta.LeftState.IsOnlyHouseGutter() ||
                meta.RightState.IsOnlyHouseGutter()
            );
        },
        HasFullTaperWaterShed: function () {
            return (
                ((meta.FrontState.IsWaterShed || meta.BackState.IsWaterShed) && meta.FrontState.IsFullTaper) ||
                ((meta.FrontState.IsWaterShed || meta.BackState.IsWaterShed) && meta.BackState.IsFullTaper) ||
                ((meta.LeftState.IsWaterShed || meta.RightState.IsWaterShed) && meta.LeftState.IsFullTaper) ||
                ((meta.LeftState.IsWaterShed || meta.RightState.IsWaterShed) && meta.RightState.IsFullTaper)
            );
        },
    };

    meta.FrontState = GetAreaMeta(job, this_area_data, "Front");
    meta.BackState = GetAreaMeta(job, this_area_data, "Back");
    meta.LeftState = GetAreaMeta(job, this_area_data, "Left");
    meta.RightState = GetAreaMeta(job, this_area_data, "Right");

    const roofType = this_area_data?.ROOF_SHEETING?.RoofGroupType?.toUpperCase() ?? "";

    // reset each time
    meta.HasBondor = false;
    meta.HasVersiclad = false;
    meta.HasApollo = false;
    meta.HasInsulatedPanel = false;

    if (roofType.includes("BONDOR")) {
        meta.HasBondor = true;
    }
    if (roofType.includes("VERSICLAD")) {
        meta.HasVersiclad = true;
    }
    if (roofType.includes("APOLLO")) {
        meta.HasApollo = true;
    }
    if (
        meta.HasBondor ||
        meta.HasVersiclad ||
        meta.HasApollo ||
        this_area_data?.ROOF_SHEETING?.RoofSheetData?.insulated_panel
    ) {
        meta.HasInsulatedPanel = true;
    }

    let is_flat = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT;
    let is_Gable = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;

    let flat2DRoofArea = this_area_data.SHAPE.Length * this_area_data.SHAPE.Depth;
    meta.AreaBoundarySize = (flat2DRoofArea / Cos(this_area_data.SHAPE.RoofPitch) / 1000000).toFixed(2);
    if (is_flat) {
        let cutout2DArea = CutoutArea(this_area_data);
        meta.CutoutArea = (cutout2DArea / Cos(this_area_data.SHAPE.RoofPitch) / 1000000).toFixed(2);
        flat2DRoofArea = flat2DRoofArea - cutout2DArea;
    }

    meta.RoofArea = (flat2DRoofArea / Cos(this_area_data.SHAPE.RoofPitch) / 1000000).toFixed(2);

    let origin = GetItems({ typeQQ: "origin" });
    meta.IsFreestanding = this_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].Freestanding;

    if (origin && origin[0]) {
        if (origin[0]?.roof_areas && origin[0]?.roof_areas.split) {
            let roof_areas = origin[0]?.roof_areas.split("/");
            if (roof_areas[areaIndex]) {
                let roofArea = toNumber(roof_areas[areaIndex]);
                if (roofArea > 0) {
                    meta.RoofArea = toNumber(roof_areas[areaIndex]);
                }
            }
        }
        if (origin[0]?.perimeters && origin[0]?.perimeters.split) {
            let perimeters = origin[0]?.perimeters.split("|");
            if (perimeters[areaIndex]) {
                let perimeters_split = perimeters[areaIndex].split("/");
                if (perimeters_split[0]) {
                    meta.PerimeterAttached = toNumber(perimeters_split[0]);
                    if (meta.PerimeterAttached !== undefined) {
                        if (meta.PerimeterAttached > 1) {
                            meta.IsFreestanding = false;
                        } else {
                            meta.IsFreestanding = true;
                        }
                    }
                }
                if (perimeters_split[1]) {
                    meta.Perimeter = toNumber(perimeters_split[1]);
                }
            }
        }
    }
    if (origin && origin[0] && origin[0]?.min_sheet_lengths && origin[0]?.min_sheet_lengths.split) {
        let roof_sheet_lengths = origin[0]?.min_sheet_lengths.split("/");
        let max_cutout_overhangs = {};
        for (let roof_sheet_length of roof_sheet_lengths) {
            if (roof_sheet_length.startsWith(areaIndex + "_")) {
                let roof_sheet_length_split = roof_sheet_length.split("|");
                let side = roof_sheet_length_split[0].replace(areaIndex + "_", "");
                let length = toNumber(roof_sheet_length_split[1]);
                if (side.endsWith("A")) {
                    let cutout = "";
                    if (side.includes("CFL")) cutout = "FrontLeft";
                    else if (side.includes("CFR")) cutout = "FrontRight";
                    else if (side.includes("CBL")) cutout = "BackLeft";
                    else if (side.includes("CBR")) cutout = "BackRight";
                    if (cutout) {
                        let cutout_length = this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[cutout + "-WidthX"];
                        let cutout_depth = this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[cutout + "-WidthY"];
                        let angle_radians = Math.atan(cutout_depth / cutout_length);
                        let ratio = Math.cos(angle_radians);
                        max_cutout_overhangs[side.split(" ")[0]] = Math.floor(
                            length * ratio * (meta.HasInsulatedPanel ? 0.25 : 0.5)
                        );
                        console.log(
                            cutout,
                            length,
                            cutout_depth,
                            COMMON.radiansToDegrees(angle_radians),
                            angle_radians,
                            ratio
                        );
                    }
                } else {
                    max_cutout_overhangs[side.split(" ")[0]] = Math.floor(
                        length * (meta.HasInsulatedPanel ? 0.25 : 0.5)
                    );
                }
            }
        }
        meta.MaxCutoutOverhangs = max_cutout_overhangs;
    }

    meta.HasHips = false;
    meta.HasDutchGables = false;

    if (is_Gable) {
        if (this_area_data.SHAPE.RoofType1 === "Dutch Gable" || this_area_data.SHAPE.RoofType2 === "Dutch Gable")
            meta.HasDutchGables = true;
        if (this_area_data.SHAPE.RoofType1 === "Hip" || this_area_data.SHAPE.RoofType2 === "Hip") meta.HasHips = true;
    }

    let half_beam_width = (window.LYSAGHT ? 50 : 65) * 0.5;
    let roof_sheet_span = this_area_data.SHAPE.Depth - half_beam_width;
    if (is_flat) {
        if (this_area_data.SHAPE.SheetDirection === "Left" || this_area_data.SHAPE.SheetDirection === "Right") {
            roof_sheet_span = this_area_data.SHAPE.Length;
            if (meta.LeftState.HasBeam()) roof_sheet_span -= half_beam_width;
            if (meta.RightState.HasBeam()) roof_sheet_span -= half_beam_width;
        } else {
            roof_sheet_span = this_area_data.SHAPE.Depth;
            if (meta.FrontState.HasBeam()) roof_sheet_span -= half_beam_width;
            if (meta.BackState.HasBeam()) roof_sheet_span -= half_beam_width;
        }
    } else if (is_Gable) {
        roof_sheet_span =
            this_area_data.SHAPE.Depth / 2 - half_beam_width * 2 - this_area_data.BEAMS_AND_POSTS.GableTopPurlinOffset;
    }
    roof_sheet_span = roof_sheet_span / Cos(this_area_data.SHAPE.RoofPitch);
    meta.RoofSheetSpan = roof_sheet_span;

    meta.LengthDepthRotated = false;
    if (this_area_data.SHAPE.SheetDirection === "Left" || this_area_data.SHAPE.SheetDirection === "Right") {
        meta.LengthDepthRotated = true;
    }

    this_area_data.META = meta;

    return job;
};

const CUTOUT_BACK_LEFT = "BackLeft";
const CUTOUT_BACK_MID = "BackMid";
const CUTOUT_BACK_RIGHT = "BackRight";
const CUTOUT_FRONT_LEFT = "FrontLeft";
const CUTOUT_FRONT_RIGHT = "FrontRight";

const CutoutArea = (this_area_data) => {
    let area_roof = 0;
    area_roof += CutoutAreaSide(this_area_data, CUTOUT_BACK_LEFT);
    area_roof += CutoutAreaSide(this_area_data, CUTOUT_BACK_MID);
    area_roof += CutoutAreaSide(this_area_data, CUTOUT_BACK_RIGHT);
    area_roof += CutoutAreaSide(this_area_data, CUTOUT_FRONT_LEFT);
    area_roof += CutoutAreaSide(this_area_data, CUTOUT_FRONT_RIGHT);
    return area_roof;
};
const CutoutAreaSide = (this_area_data, side) => {
    let area_roof = 0;
    if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-CutoutType"] !== "None") {
        area_roof =
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-WidthX"] *
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-WidthY"];
        if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-CutoutType"] === "Angle") {
            area_roof = area_roof / 2;
        } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-CutoutType"] === "CornerBay") {
            area_roof =
                area_roof -
                (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-WidthD"] *
                    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-WidthD"]) /
                    2;
        } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-CutoutType"] === "Bay") {
            area_roof =
                area_roof -
                this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-WidthD"] *
                    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-WidthD"];
        }
    }
    return area_roof;
};

export const validateAreaShape = (config, job, areaIndex, secondCheck = false) => {
    let last_area_data = job.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job.AreaSpecifications[areaIndex];
    let next_area_data = job.AreaSpecifications?.[areaIndex + 1];

    if (job.DesignParameters.LoopAreas) {
        if (areaIndex === 0) {
            last_area_data = job.AreaSpecifications?.[job.AreaSpecifications.length - 1];
        }
        if (areaIndex === job.AreaSpecifications.length - 1) {
            next_area_data = job.AreaSpecifications[0];
        }
    }

    let design_option = config?.design_options?.[this_area_data.SHAPE.DesignType];
    let this_area_data_SHAPE = this_area_data[BASIC_SPECS_SECTIONS.SHAPE];

    if (this_area_data_SHAPE?.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
        this_area_data.SHAPE.LouvreMode = 1;
        this_area_data_SHAPE.DesignSubType = "Type 4";
        this_area_data_SHAPE.SheetDirection = "Front";
        this_area_data_SHAPE.RotateArea = 0;
    } else {
        this_area_data.SHAPE.LouvreMode = 0;
    }

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
        if (["Parallel", "Projection"].includes(this_area_data_SHAPE.DesignSubType)) {
            this_area_data_SHAPE.DesignSubType = "Type 4";
            this_area_data_SHAPE.SheetDirection = "Front";
        }
        if (this_area_data_SHAPE.DesignSubType === "Type 4") {
            if (this_area_data_SHAPE.RoofPitch < 0) this_area_data_SHAPE.SheetDirection = "Back";
            else this_area_data_SHAPE.SheetDirection = "Front";
        }
        if (this_area_data_SHAPE.DesignSubType === "Type 3") {
            this_area_data_SHAPE.OH_Front = 0;
            this_area_data_SHAPE.OH_Back = 0;
            if (this_area_data_SHAPE.RoofPitch < 0)
                this_area_data_SHAPE.RoofPitch = Math.abs(this_area_data_SHAPE.RoofPitch);
        }

        this_area_data_SHAPE.RotateArea = 0;
    }
    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) {
        this_area_data_SHAPE.DesignSubType = "Type 4";
        this_area_data_SHAPE.SheetDirection = "Front";
        this_area_data_SHAPE.RotateArea = 0;
    }
    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
        if (!["Projection", "Parallel"].includes(this_area_data_SHAPE.DesignSubType)) {
            this_area_data_SHAPE.DesignSubType = "Parallel";
        }
        this_area_data_SHAPE.SheetDirection = "Front";

        this_area_data_SHAPE.RoofPitch = Math.abs(this_area_data_SHAPE.RoofPitch);
    }

    if (job.DesignParameters.DeckMode === 1) {
        this_area_data_SHAPE.RotateArea = 1;

        let maxPostHeight = 3000;
        if (maxPostHeight && this_area_data_SHAPE.Height > maxPostHeight) this_area_data_SHAPE.Height = maxPostHeight;
    }

    //PARTIAL ATTACHMENTS
    if (this_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].PARTIAL_ATTACHMENTS) {
        for (let paat of this_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].PARTIAL_ATTACHMENTS) {
            if (paat.HasBeam === undefined) paat.HasBeam = 1;
        }
    }

    // set 'shearing' fall
    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) {
        let set_to_flat = false;
        if (
            last_area_data &&
            last_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
            last_area_data.SHAPE.DesignSubType === "Type 3"
        ) {
            set_to_flat = true;
        } else if (
            next_area_data &&
            next_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
            next_area_data.SHAPE.DesignSubType === "Type 3"
        ) {
            set_to_flat = true;
        }

        if (set_to_flat) this_area_data.SHAPE.PitchedRoofShear = 0;
        else this_area_data.SHAPE.PitchedRoofShear = "";
    }

    // validate JOIN
    if (last_area_data) {
        let has_flat = false;
        let has_pitched = false;
        let has_portal = false;

        if (
            last_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT
        )
            has_flat = true;
        if (
            last_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
        )
            has_pitched = true;
        if (
            last_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL
        )
            has_portal = true;

        let join_type = "flat_to_flat";
        if (has_flat && has_pitched) join_type = "flat_to_gable";
        if (has_flat && has_portal) join_type = "flat_to_portal";
        if (!has_flat && !has_pitched && has_portal) join_type = "portal_to_portal";
        if (!has_flat) join_type = "portal_to_portal";

        let last_join_type = CONFIG?.JOIN_TYPES?.[last_area_data.SHAPE.AREAJOIN.JoinType];
        if (last_join_type && last_join_type[join_type] === true) {
        } else {
            last_area_data.SHAPE.AREAJOIN.JoinType = "Offset";
        }
    }

    if (next_area_data) {
        let has_flat = false;
        let has_pitched = false;
        let has_portal = false;

        if (
            next_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT
        )
            has_flat = true;
        if (
            next_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
        )
            has_pitched = true;
        if (
            next_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL
        )
            has_portal = true;

        let join_type = "flat_to_flat";
        if (has_flat && has_pitched) join_type = "flat_to_gable";
        if (has_flat && has_portal) join_type = "flat_to_portal";
        if (!has_flat && !has_pitched && has_portal) join_type = "portal_to_portal";

        let this_join_type = CONFIG?.JOIN_TYPES?.[this_area_data.SHAPE.AREAJOIN.JoinType];
        if (this_join_type && this_join_type[join_type] === true) {
        } else {
            this_area_data.SHAPE.AREAJOIN.JoinType = "Offset";
        }

        this_area_data.SHAPE.AREAJOIN.JoinDoubleHipBeam = false;
        if (
            this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetData.double_beam_hip_required ||
            next_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetData.double_beam_hip_required
        ) {
            this_area_data.SHAPE.AREAJOIN.JoinDoubleHipBeam = true;
        }
    }

    this_area_data.SHAPE.AREAJOIN.OmitJoinPost = 1;
    this_area_data.SHAPE.AREAJOIN.JoinOffsetGlobal = this_area_data.SHAPE.AREAJOIN.JoinType === "None" ? 1 : 0;

    if (next_area_data && this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Gable") {
        let diff = Math.abs(
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth - next_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth
        );

        if (diff > 1 && diff <= 120) {
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType = "Offset";
        } else if (diff < 1 || diff >= 120) {
            if (diff >= 120) {
                if (
                    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth > next_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth
                ) {
                    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.HipJunctionDir = 0;
                } else {
                    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.HipJunctionDir = 1;
                }
            }
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType2 = "Gable";
            next_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType1 = "Gable";
            next_area_data.SHAPE.Height = this_area_data.SHAPE.Height;
            next_area_data.SHAPE.RoofPitch = this_area_data.SHAPE.RoofPitch;
        }
    }
    if (last_area_data && last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Gable") {
        let diff = Math.abs(
            last_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth - this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth
        );

        if (diff > 1 && diff <= 120) {
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType = "Offset";
        } else if (diff < 1 || diff >= 120) {
            if (diff >= 120) {
                if (
                    last_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth > this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth
                ) {
                    last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.HipJunctionDir = 0;
                } else {
                    last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.HipJunctionDir = 1;
                }
            }
            last_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType2 = "Gable";
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType1 = "Gable";
            last_area_data.SHAPE.Height = this_area_data.SHAPE.Height;
            last_area_data.SHAPE.RoofPitch = this_area_data.SHAPE.RoofPitch;
        }
    }

    if (next_area_data && this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip") {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType2 = "Gable";
        next_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType1 = "Gable";
        next_area_data.SHAPE.Height = this_area_data.SHAPE.Height;
        next_area_data.SHAPE.Depth = this_area_data.SHAPE.Depth;
        next_area_data.SHAPE.RoofPitch = this_area_data.SHAPE.RoofPitch;
    }

    if (last_area_data && last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip") {
        last_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType2 = "Gable";
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType1 = "Gable";
        last_area_data.SHAPE.Height = this_area_data.SHAPE.Height;
        last_area_data.SHAPE.Depth = this_area_data.SHAPE.Depth;
        last_area_data.SHAPE.RoofPitch = this_area_data.SHAPE.RoofPitch;
    }

    if (design_option?.length_range)
        this_area_data_SHAPE.Length = validateNumberRange_old(
            this_area_data_SHAPE.Length,
            COMMON.replaceVariables(
                this_area_data,
                this_area_data.META.LengthDepthRotated ? design_option.depth_range : design_option.length_range
            )
        );
    if (design_option?.depth_range)
        this_area_data_SHAPE.Depth = validateNumberRange_old(
            this_area_data_SHAPE.Depth,
            COMMON.replaceVariables(
                this_area_data,
                this_area_data.META.LengthDepthRotated ? design_option.length_range : design_option.depth_range
            )
        );
    if (design_option?.height_range)
        this_area_data_SHAPE.Height = validateNumberRange_old(
            this_area_data_SHAPE.Height,
            COMMON.replaceVariables(this_area_data, design_option.height_range)
        );
    if (design_option?.pitch_range) {
        // Min pitch with Skylights updated to 3 instead of 2.
        let min_pitch = Number(this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_pitch);
        if (
            (this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofType.includes("TL5") ||
                this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofType.includes("TRIMDEK")) &&
            this_area_data[BASIC_SPECS_SECTIONS.SKYLIGHTS].length > 0
        ) {
            min_pitch = 3;
        }

        const is_neg = this_area_data_SHAPE.RoofPitch < 0;
        let designPitch = COMMON.replaceVariables(this_area_data, design_option.pitch_range);

        // validateNumberRange_old expects a object
        if (typeof design_option.pitch_range === "string")
            designPitch = { [design_option.pitch_range.split(": ")[0]]: design_option.pitch_range.split(": ")[1] };

        this_area_data_SHAPE.RoofPitch = validateNumberRange_old(Math.abs(this_area_data_SHAPE.RoofPitch), designPitch);

        if (min_pitch && Math.abs(this_area_data_SHAPE.RoofPitch) < min_pitch)
            this_area_data_SHAPE.RoofPitch = Number(min_pitch);
        if (is_neg) this_area_data_SHAPE.RoofPitch = -this_area_data_SHAPE.RoofPitch;
    }

    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitchMatched = false;

    if (
        last_area_data &&
        last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Angle" &&
        last_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.FLAT &&
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.FLAT
    ) {
        if (
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth <= last_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth ||
            last_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitchMatched
        ) {
            //match pitch to next area for hip flat joins
            let ratio =
                last_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth / this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth;
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitch =
                last_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitch * ratio;
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitchMatched = true;
        }
    }

    if (
        next_area_data &&
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Angle" &&
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.FLAT &&
        next_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignType === CONFIG.DESIGN_TYPES.FLAT
    ) {
        if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitchMatched) {
            //keep as matched
        } else if (
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth < next_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth
        ) {
            //match pitch to next area for hip flat joins
            let ratio =
                next_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth / this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth;
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitch =
                next_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitch * ratio;
            this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitchMatched = true;
        }
    }

    //validate Cutouts
    if (this_area_data_SHAPE.CUTOUTS["BackMid-CutoutType"] === "Box") {
        this_area_data_SHAPE.CUTOUTS["BackMid-WidthD"] = 0;
    } else if (
        this_area_data_SHAPE.CUTOUTS["BackMid-CutoutType"] === "Bay" &&
        this_area_data_SHAPE.CUTOUTS["BackMid-WidthD"] === 0
    ) {
        this_area_data_SHAPE.CUTOUTS["BackMid-WidthD"] = this_area_data_SHAPE.CUTOUTS["BackMid-WidthY"] / 2;
    }

    const areas = ["BackLeft", "BackMid", "BackRight", "FrontLeft", "FrontRight"];
    for (let area of areas) {
        let this_cutout = this_area_data_SHAPE.CUTOUTS[area + "-CutoutType"];
        if (this_cutout && this_cutout === "Custom") {
            if (!this_area_data_SHAPE?.CUTOUTS?.[area + "-CustomNumSegments"])
                this_area_data_SHAPE.CUTOUTS[area + "-CustomNumSegments"] = 3;
            let num_segments = toNumber(this_area_data_SHAPE.CUTOUTS[area + "-CustomNumSegments"]);
            for (var i = 1; i < num_segments + 1; i++) {
                let section = area + "-" + i;
                if (this_area_data_SHAPE?.CUTOUTS?.[section + "-CustomPoint"] === undefined) {
                    let default_x = 300;
                    let default_y = 100 * i;

                    if (area === "FrontLeft") default_y = -default_y;
                    if (area === "BackRight") default_y = -default_y;

                    this_area_data_SHAPE.CUTOUTS[section + "-CustomPoint"] = "(" + default_x + "," + default_y + ")";
                }
                if (this_area_data_SHAPE?.CUTOUTS?.[section + "-CustomHasBeam"] === undefined)
                    this_area_data_SHAPE.CUTOUTS[section + "-CustomHasBeam"] = 1;
                if (this_area_data_SHAPE?.CUTOUTS?.[section + "-CustomHasGutter"] === undefined)
                    this_area_data_SHAPE.CUTOUTS[section + "-CustomHasGutter"] = 1;
                if (this_area_data_SHAPE?.CUTOUTS?.[section + "-CustomHasPosts"] === undefined)
                    this_area_data_SHAPE.CUTOUTS[section + "-CustomHasPosts"] = 1;
            }
        }
        if (this_cutout && this_cutout !== "None") {
            //validate cutout overhangs
            let this_cutout_oh = this_area_data_SHAPE.CUTOUTS[area + "-Overhang"];

            //overhang_front_range is now used for BACK and FRONT
            if (design_option?.overhang_front_range)
                this_area_data_SHAPE.CUTOUTS[area + "-Overhang"] = validateNumberRange_old(
                    this_cutout_oh,
                    COMMON.replaceVariables(this_area_data, design_option.overhang_front_range)
                );

            let min_front_overhang =
                this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_front_overhang;

            if (min_front_overhang !== undefined && this_cutout_oh < min_front_overhang)
                this_area_data_SHAPE.CUTOUTS[area + "-Overhang"] = min_front_overhang;

            if (this_area_data_SHAPE.CUTOUTS[area + "-WidthX"] < 0)
                this_area_data_SHAPE.CUTOUTS[area + "-WidthX"] = 500;
            if (this_area_data_SHAPE.CUTOUTS[area + "-WidthY"] < 0)
                this_area_data_SHAPE.CUTOUTS[area + "-WidthY"] = 500;
            if (this_area_data_SHAPE.CUTOUTS[area + "-WidthD"] < 0)
                this_area_data_SHAPE.CUTOUTS[area + "-WidthD"] = 500;

            let min_side_overhang =
                this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_side_overhang;

            let this_cutout_side_oh = this_area_data_SHAPE.CUTOUTS[area + "-OverhangY"];
            if (min_side_overhang !== undefined && this_cutout_side_oh < min_side_overhang)
                this_area_data_SHAPE.CUTOUTS[area + "-OverhangY"] = min_side_overhang;

            let this_cutout_side2_oh = this_area_data_SHAPE.CUTOUTS[area + "-OverhangY2"];
            if (min_side_overhang !== undefined && this_cutout_side2_oh < min_side_overhang)
                this_area_data_SHAPE.CUTOUTS[area + "-OverhangY2"] = min_side_overhang;

            //max_overhang
            let cutout_name = "";
            if (area.startsWith("FrontLeft")) {
                cutout_name = "CFL";
            }
            if (area.startsWith("FrontRight")) {
                cutout_name = "CFR";
            }
            if (area.startsWith("BackLeft")) {
                cutout_name = "CBL";
            }
            if (area.startsWith("BackRight")) {
                cutout_name = "CBR";
            }
            if (cutout_name !== "") {
                let max_cutout_overhang = toNumber(this_area_data?.META?.MaxCutoutOverhangs?.[cutout_name]);
                if (max_cutout_overhang > 100 && this_cutout_oh > max_cutout_overhang) {
                    this_area_data_SHAPE.CUTOUTS[area + "-Overhang"] = max_cutout_overhang;
                }
            }
        }
    }

    this_area_data_SHAPE.HasFullTaperWaterShed = this_area_data?.META?.HasFullTaperWaterShed
        ? this_area_data?.META?.HasFullTaperWaterShed()
        : false;

    this_area_data[BASIC_SPECS_SECTIONS.SHAPE] = this_area_data_SHAPE;

    return job;
};

export const validateAreaShape_Overhangs = (config, job, areaIndex) => {
    let last_area_data = job.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job.AreaSpecifications[areaIndex];
    let this_area_data_SHAPE = this_area_data[BASIC_SPECS_SECTIONS.SHAPE];
    let next_area_data = job.AreaSpecifications?.[areaIndex + 1];

    if (job.DesignParameters.LoopAreas) {
        if (areaIndex === 0) {
            last_area_data = job.AreaSpecifications?.[job.AreaSpecifications.length - 1];
        }
        if (areaIndex === job.AreaSpecifications.length - 1) {
            next_area_data = job.AreaSpecifications?.[0];
        }
    }

    let design_option = config?.design_options?.[this_area_data.SHAPE.DesignType];

    let site = job?.SiteParameters;
    let ExistingStructure = site?.ExistingStructure;

    let is_flat = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT;
    let is_pitched = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED;
    let is_portal = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;

    // VALIDATE FOR DESIGN TYPE LEGACY ADJUSTMENTS
    if (is_flat) {
        if (this_area_data_SHAPE.OH_Front > 0 && this_area_data_SHAPE.OH_Front_Sheet === 0) {
            this_area_data_SHAPE.OH_Front_Sheet = this_area_data_SHAPE.OH_Front;
        }
        this_area_data_SHAPE.OH_Front = 0;

        if (this_area_data_SHAPE.OH_Back > 0 && this_area_data_SHAPE.OH_Back_Sheet === 0) {
            this_area_data_SHAPE.OH_Back_Sheet = this_area_data_SHAPE.OH_Back;
        }
        this_area_data_SHAPE.OH_Back = 0;

        if (this_area_data_SHAPE.OH_Left > 0 && this_area_data_SHAPE.OH_Left_Sheet === 0) {
            this_area_data_SHAPE.OH_Left_Sheet = this_area_data_SHAPE.OH_Left;
        }
        this_area_data_SHAPE.OH_Left = 0;

        if (this_area_data_SHAPE.OH_Right > 0 && this_area_data_SHAPE.OH_Right_Sheet === 0) {
            this_area_data_SHAPE.OH_Right_Sheet = this_area_data_SHAPE.OH_Right;
        }
        this_area_data_SHAPE.OH_Right = 0;
    }

    //MAX OFFERING BASE OVERHANG RANGE
    if (design_option?.overhang_left_range)
        this_area_data_SHAPE.OH_Left_Sheet = validateNumberRange_old(
            this_area_data_SHAPE.OH_Left_Sheet,
            COMMON.replaceVariables(this_area_data, design_option.overhang_left_range)
        );
    if (design_option?.overhang_right_range)
        this_area_data_SHAPE.OH_Right_Sheet = validateNumberRange_old(
            this_area_data_SHAPE.OH_Right_Sheet,
            COMMON.replaceVariables(this_area_data, design_option.overhang_right_range)
        );
    if (design_option?.overhang_front_range)
        this_area_data_SHAPE.OH_Front_Sheet = validateNumberRange_old(
            this_area_data_SHAPE.OH_Front_Sheet,
            COMMON.replaceVariables(this_area_data, design_option.overhang_front_range)
        );
    if (design_option?.overhang_back_range)
        this_area_data_SHAPE.OH_Back_Sheet = validateNumberRange_old(
            this_area_data_SHAPE.OH_Back_Sheet,
            COMMON.replaceVariables(this_area_data, design_option.overhang_back_range)
        );

    //MAX OFFERING ROOFSHEET OVERHANG
    let max_overhang_roofsheet_xy =
        this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_overhang_xy;
    if (max_overhang_roofsheet_xy !== undefined) {
        if (this_area_data.SHAPE.SheetDirection === "Left" || this_area_data.SHAPE.SheetDirection === "Right") {
            if (this_area_data_SHAPE.OH_Left_Sheet > max_overhang_roofsheet_xy)
                this_area_data_SHAPE.OH_Left_Sheet = max_overhang_roofsheet_xy;
            if (this_area_data_SHAPE.OH_Right_Sheet > max_overhang_roofsheet_xy)
                this_area_data_SHAPE.OH_Right_Sheet = max_overhang_roofsheet_xy;
        } else {
            if (this_area_data_SHAPE.OH_Front_Sheet > max_overhang_roofsheet_xy)
                this_area_data_SHAPE.OH_Front_Sheet = max_overhang_roofsheet_xy;
            if (this_area_data_SHAPE.OH_Back_Sheet > max_overhang_roofsheet_xy)
                this_area_data_SHAPE.OH_Back_Sheet = max_overhang_roofsheet_xy;
        }
    }

    //MIN FRONT OVERHANG
    let min_front_overhang = this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_front_overhang;
    let maxFrontBackEndSpan =
        this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_frontback_end_span;

    if (min_front_overhang !== undefined) {
        if (
            this_area_data.SHAPE.SheetDirection === "Front" ||
            this_area_data.SHAPE.SheetDirection === "Back" ||
            is_portal
        ) {
            if (this_area_data_SHAPE.OH_Front_Sheet < min_front_overhang)
                this_area_data_SHAPE.OH_Front_Sheet =
                    maxFrontBackEndSpan < min_front_overhang ? maxFrontBackEndSpan : min_front_overhang;
            if (this_area_data_SHAPE.OH_Back_Sheet < min_front_overhang)
                this_area_data_SHAPE.OH_Back_Sheet =
                    maxFrontBackEndSpan < min_front_overhang ? maxFrontBackEndSpan : min_front_overhang;
        } else if (this_area_data.SHAPE.SheetDirection === "Left" || this_area_data.SHAPE.SheetDirection === "Right") {
            if (this_area_data_SHAPE.OH_Left_Sheet < min_front_overhang)
                this_area_data_SHAPE.OH_Left_Sheet = min_front_overhang;

            if (this_area_data_SHAPE.OH_Right_Sheet < min_front_overhang)
                this_area_data_SHAPE.OH_Right_Sheet = min_front_overhang;
        }
    }

    // MIN SIDE OVERHANG
    let min_side_overhang = this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_side_overhang;

    if (min_side_overhang !== undefined) {
        if (
            this_area_data.SHAPE.SheetDirection === "Front" ||
            this_area_data.SHAPE.SheetDirection === "Back" ||
            is_portal
        ) {
            if (this_area_data_SHAPE.OH_Left_Sheet < min_side_overhang)
                this_area_data_SHAPE.OH_Left_Sheet = min_side_overhang;
            if (this_area_data_SHAPE.OH_Right_Sheet < min_side_overhang)
                this_area_data_SHAPE.OH_Right_Sheet = min_side_overhang;
        } else {
            if (this_area_data_SHAPE.OH_Front_Sheet < min_side_overhang)
                this_area_data_SHAPE.OH_Front_Sheet = min_side_overhang;
            if (this_area_data_SHAPE.OH_Back_Sheet < min_side_overhang)
                this_area_data_SHAPE.OH_Back_Sheet = min_side_overhang;
        }
    }

    // MAX SIDE OVERHANG
    let max_side_overhang = this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.max_side_overhang;
    let max_portal_gable_side_OH = design_option?.max_frame_overhang ? design_option?.max_frame_overhang : 1200;

    if (max_side_overhang !== undefined) {
        if (
            this_area_data.SHAPE.SheetDirection === "Front" ||
            this_area_data.SHAPE.SheetDirection === "Back" ||
            is_portal
        ) {
            if (is_portal) {
                if (this_area_data_SHAPE.OH_Left > max_portal_gable_side_OH)
                    this_area_data_SHAPE.OH_Left = max_portal_gable_side_OH;
                if (this_area_data_SHAPE.OH_Right > max_portal_gable_side_OH)
                    this_area_data_SHAPE.OH_Right = max_portal_gable_side_OH;
            }

            if (this_area_data_SHAPE.OH_Left_Sheet > max_side_overhang)
                this_area_data_SHAPE.OH_Left_Sheet = max_side_overhang;
            if (this_area_data_SHAPE.OH_Right_Sheet > max_side_overhang)
                this_area_data_SHAPE.OH_Right_Sheet = max_side_overhang;
        } else {
            if (this_area_data_SHAPE.OH_Front_Sheet > max_side_overhang)
                this_area_data_SHAPE.OH_Front_Sheet = max_side_overhang;
            if (this_area_data_SHAPE.OH_Back_Sheet > max_side_overhang)
                this_area_data_SHAPE.OH_Back_Sheet = max_side_overhang;
        }
    }

    //CUTOUT OVERHANGS - TAPERS
    if (this_area_data.META.FrontState.IsFullTaper) {
        this_area_data_SHAPE.OH_Front = 0;
        if (this_area_data.SHAPE.CUTOUTS["FrontLeft-CutoutType"] === "Angle") {
            this_area_data.SHAPE.CUTOUTS["FrontLeft-Overhang"] = this_area_data_SHAPE.OH_Front_Sheet;
        }
        if (this_area_data.SHAPE.CUTOUTS["FrontRight-CutoutType"] === "Angle") {
            this_area_data.SHAPE.CUTOUTS["FrontRight-Overhang"] = this_area_data_SHAPE.OH_Front_Sheet;
        }
        // this_area_data_SHAPE.OH_Front_Sheet = 0;
    }
    if (this_area_data.META.BackState.IsFullTaper) {
        this_area_data_SHAPE.OH_Back = 0;
        if (this_area_data.SHAPE.CUTOUTS["BackLeft-CutoutType"] === "Angle") {
            this_area_data.SHAPE.CUTOUTS["BackLeft-Overhang"] = this_area_data_SHAPE.OH_Back_Sheet;
        }
        if (this_area_data.SHAPE.CUTOUTS["BackRight-CutoutType"] === "Angle") {
            this_area_data.SHAPE.CUTOUTS["BackRight-Overhang"] = this_area_data_SHAPE.OH_Back_Sheet;
        }
        // this_area_data_SHAPE.OH_Back_Sheet = 0;
    }

    //CUTOUT OVERHANGS
    let cutout_min_front_overhang = min_front_overhang;
    let cutout_min_side_overhang = min_side_overhang;
    let cutout_max_overhang_roofsheet = max_overhang_roofsheet_xy;
    let cutout_max_side_overhang = max_side_overhang;

    if (
        is_flat &&
        (this_area_data.SHAPE.SheetDirection === "Left" || this_area_data.SHAPE.SheetDirection === "Right")
    ) {
        cutout_min_front_overhang = min_side_overhang;
        cutout_min_side_overhang = min_front_overhang;
        cutout_max_overhang_roofsheet = max_side_overhang;
        cutout_max_side_overhang = max_overhang_roofsheet_xy;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["FrontLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Overhang"]) < cutout_min_front_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Overhang"] = cutout_min_front_overhang;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["FrontRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Overhang"]) < cutout_min_front_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Overhang"] = cutout_min_front_overhang;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["BackLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Overhang"]) < cutout_min_front_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Overhang"] = cutout_min_front_overhang;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["BackRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Overhang"]) < cutout_min_front_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Overhang"] = cutout_min_front_overhang;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["FrontLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-OverhangY"]) < cutout_min_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-OverhangY"] = cutout_min_side_overhang;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["FrontRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-OverhangY"]) < cutout_min_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-OverhangY"] = cutout_min_side_overhang;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["BackLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-OverhangY"]) < cutout_min_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-OverhangY"] = cutout_min_side_overhang;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["BackRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-OverhangY"]) < cutout_min_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-OverhangY"] = cutout_min_side_overhang;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["FrontLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Overhang"]) >
            cutout_max_overhang_roofsheet
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-Overhang"] = cutout_max_overhang_roofsheet;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["FrontRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Overhang"]) >
            cutout_max_overhang_roofsheet
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-Overhang"] = cutout_max_overhang_roofsheet;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["BackLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Overhang"]) >
            cutout_max_overhang_roofsheet
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-Overhang"] = cutout_max_overhang_roofsheet;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["BackRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Overhang"]) >
            cutout_max_overhang_roofsheet
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-Overhang"] = cutout_max_overhang_roofsheet;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["FrontLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-OverhangY"]) > cutout_max_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontLeft-OverhangY"] = cutout_max_side_overhang;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["FrontRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-OverhangY"]) > cutout_max_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["FrontRight-OverhangY"] = cutout_max_side_overhang;
    }

    if (
        this_area_data.SHAPE.CUTOUTS["BackLeft-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-OverhangY"]) > cutout_max_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackLeft-OverhangY"] = cutout_max_side_overhang;
    }
    if (
        this_area_data.SHAPE.CUTOUTS["BackRight-CutoutType"] !== "None" &&
        toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-OverhangY"]) > cutout_max_side_overhang
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS["BackRight-OverhangY"] = cutout_max_side_overhang;
    }

    // custom cutout overhangs
    let sides = ["FrontRight", "BackRight", "FrontLeft", "BackLeft"];
    for (let side of sides) {
        if (
            this_area_data.SHAPE.CUTOUTS[side + "-CutoutType"] === "Custom" &&
            toNumber(this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-CustomNumSegments"]) > 0
        ) {
            let num_segments = toNumber(
                this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-CustomNumSegments"]
            );
            for (let i = 1; i < num_segments + 1; i++) {
                let overhang = toNumber(
                    this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-" + i + "-CustomOverhang"]
                );
                if (overhang < cutout_min_front_overhang) {
                    overhang = cutout_min_front_overhang;
                }
                if (overhang > cutout_max_overhang_roofsheet) {
                    overhang = cutout_max_overhang_roofsheet;
                }
                this_area_data[BASIC_SPECS_SECTIONS.SHAPE].CUTOUTS[side + "-" + i + "-CustomOverhang"] = overhang;
            }
        }
    }

    // validate overhangs vs attachments
    if (Number(this_area_data_SHAPE.OH_Back) > 0) {
        let back_attached = this_area_data?.ATTACHMENTS?.AttachmentTop === 1;
        let rear_paat = [];
        if (next_area_data && this_area_data?.SHAPE?.AREAJOIN?.JoinType === "Offset") {
            if (is_portal && this_area_data?.SHAPE?.RotateArea === 1) {
                if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset < 0) {
                    if (
                        this_area_data?.ATTACHMENTS?.AttachmentLeft === 1 &&
                        next_area_data?.ATTACHMENTS?.AttachmentTop === 1
                    )
                        back_attached = true;
                    rear_paat = ["PAAT"];
                }
                if (this_area_data?.SHAPE?.AREAJOIN?.JoinOffset >= 0) back_attached = false;
            }
        }

        if (back_attached) {
            let rear_attachment = ExistingStructure?.AttachmentType;
            if (this_area_data?.ATTACHMENTS?.AttachmentModifications) {
                let items = this_area_data?.ATTACHMENTS?.AttachmentModifications.filter((obj) => {
                    return obj.Name.includes("Back");
                });
                if (items.length > 0 && items[0]?.FasciaType) rear_attachment = items[0]?.FasciaType;
            }

            if (rear_attachment.includes("Fascia") && (is_pitched || is_portal)) rear_attachment = "Beam";

            if (this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS && rear_paat.length === 0) {
                rear_paat = this_area_data?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.filter((obj) => {
                    return obj.Name.includes("Back");
                });
            }

            if (
                is_flat &&
                (rear_attachment.includes("Fascia") ||
                    rear_attachment.includes("Wall") ||
                    rear_attachment.includes("Beam"))
            ) {
                this_area_data_SHAPE.OH_Back = 0;
            }
        }
    }

    // END VALIDATE FOR DESIGN TYPE
    if (is_portal) {
        if (this_area_data_SHAPE.OH_Front > 0) {
            this_area_data_SHAPE.OH_Front_Sheet = this_area_data_SHAPE.OH_Front;
            this_area_data_SHAPE.OH_Front = 0;
        } else {
            this_area_data_SHAPE.OH_Front = 0;
        }

        if (this_area_data_SHAPE.OH_Back > 0) {
            this_area_data_SHAPE.OH_Back_Sheet = this_area_data_SHAPE.OH_Back;
            this_area_data_SHAPE.OH_Back = 0;
        } else {
            this_area_data_SHAPE.OH_Back = 0;
        }
    }

    return job;
};

export const validateGableParameters = (config, job, areaIndex) => {
    let this_area_data = job.AreaSpecifications[areaIndex];
    let GABLE_PARAMETERS = this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS];

    let is_flat = false;
    let is_pitched = false;
    let is_portal = false;

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) is_flat = true;
    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) is_pitched = true;
    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) is_portal = true;

    const infill_types = config.infill_types;
    const colour_arrays = config.colour_arrays;

    let design_option = config?.design_options?.[this_area_data.SHAPE.DesignType];

    if (
        GABLE_PARAMETERS.TrussInfill1 !== "None" &&
        GABLE_PARAMETERS.TrussInfill1 !== "No Beams" &&
        !design_option?.infill_options.includes(GABLE_PARAMETERS.TrussInfill1)
    ) {
        if (design_option?.infill_default) GABLE_PARAMETERS.TrussInfill1 = design_option.infill_default;
        if (!design_option?.infill_options.includes(GABLE_PARAMETERS.TrussInfill1))
            GABLE_PARAMETERS.TrussInfill1 = "None";
    }

    if (
        GABLE_PARAMETERS.TrussInfill2 !== "None" &&
        GABLE_PARAMETERS.TrussInfill2 !== "No Beams" &&
        !design_option?.infill_options.includes(GABLE_PARAMETERS.TrussInfill2)
    ) {
        if (design_option?.infill_default) GABLE_PARAMETERS.TrussInfill2 = design_option.infill_default;
        if (!design_option?.infill_options.includes(GABLE_PARAMETERS.TrussInfill2))
            GABLE_PARAMETERS.TrussInfill2 = "None";
    }

    let selectedInfillFront = infill_types?.[GABLE_PARAMETERS.TrussInfill1];
    let selectedInfillBack = infill_types?.[GABLE_PARAMETERS.TrussInfill2];

    if (GABLE_PARAMETERS.InfillBeamType === "656508") GABLE_PARAMETERS.InfillBeamType = "656510";

    if (!selectedInfillFront) {
        for (let key in infill_types) {
            if (infill_types[key]?.alt_names)
                for (let alt_name of infill_types[key].alt_names) {
                    if (GABLE_PARAMETERS.TrussInfill1 === alt_name) {
                        GABLE_PARAMETERS.TrussInfill1 = key;
                        selectedInfillFront = infill_types[key];
                    }
                }
        }
    }

    if (!selectedInfillBack) {
        for (let key in infill_types) {
            if (infill_types[key]?.alt_names)
                for (let alt_name of infill_types[key].alt_names) {
                    if (GABLE_PARAMETERS.TrussInfill2 === alt_name) {
                        GABLE_PARAMETERS.TrussInfill2 = key;
                        selectedInfillBack = infill_types[key];
                    }
                }
        }
    }

    // TrussInfillColour1
    let valid_colours = COMMON.GetColourArray(selectedInfillFront?.colours, colour_arrays);
    if (
        valid_colours &&
        (!GABLE_PARAMETERS.TrussInfillColour1 || !valid_colours.includes(GABLE_PARAMETERS.TrussInfillColour1))
    ) {
        if (selectedInfillFront?.default_colour) {
            GABLE_PARAMETERS.TrussInfillColour1 = selectedInfillFront.default_colour;
        } else if (valid_colours.length === 1) {
            GABLE_PARAMETERS.TrussInfillColour1 = valid_colours[0];
        }
        if (!valid_colours.includes(GABLE_PARAMETERS.TrussInfillColour1))
            GABLE_PARAMETERS.TrussInfillColour1 = valid_colours[0];
    }

    if (!selectedInfillFront?.allow_display_colour) GABLE_PARAMETERS.TrussInfillDisplayColour1 = null;
    else if (GABLE_PARAMETERS.TrussInfillDisplayColour1 === null)
        GABLE_PARAMETERS.TrussInfillDisplayColour1 = "#ffffff";
    GABLE_PARAMETERS.TrussInfillTexture1 = selectedInfillFront?.texture ? selectedInfillFront?.texture : null;

    if (GABLE_PARAMETERS.TrussInfill1 === "No Beams") {
        GABLE_PARAMETERS.HasInfillBeam1 = 0;
        if (
            is_portal &&
            this_area_data.META?.LeftState?.HasAttachment &&
            this_area_data.META?.LeftState?.AttachmentType === "Wall"
        ) {
            if (this_area_data.META?.LeftState?.AttachmentVariation.includes("Timber")) {
                GABLE_PARAMETERS.HasInfillBeam1 = 1;
            } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth >= 5000) {
                GABLE_PARAMETERS.HasInfillBeam1 = 1;
            }
        }
    } else {
        GABLE_PARAMETERS.HasInfillBeam1 = 1;
    }

    // TrussInfillColour2
    valid_colours = COMMON.GetColourArray(selectedInfillBack?.colours, colour_arrays);
    if (
        valid_colours &&
        (!GABLE_PARAMETERS.TrussInfillColour2 || !valid_colours.includes(GABLE_PARAMETERS.TrussInfillColour2))
    ) {
        if (selectedInfillBack?.default_colour) {
            GABLE_PARAMETERS.TrussInfillColour2 = selectedInfillBack.default_colour;
        } else if (valid_colours.length === 1) {
            GABLE_PARAMETERS.TrussInfillColour2 = valid_colours[0];
        }
        if (!valid_colours.includes(GABLE_PARAMETERS.TrussInfillColour2))
            GABLE_PARAMETERS.TrussInfillColour2 = valid_colours[0];
    }
    if (!selectedInfillBack?.allow_display_colour) GABLE_PARAMETERS.TrussInfillDisplayColour2 = null;
    else if (GABLE_PARAMETERS.TrussInfillDisplayColour2 === null)
        GABLE_PARAMETERS.TrussInfillDisplayColour2 = "#ffffff";
    GABLE_PARAMETERS.TrussInfillTexture2 = selectedInfillBack?.texture ? selectedInfillBack?.texture : null;

    if (GABLE_PARAMETERS.TrussInfill2 === "No Beams") {
        GABLE_PARAMETERS.HasInfillBeam2 = 0;
        if (
            is_portal &&
            this_area_data.META?.RightState?.HasAttachment &&
            this_area_data.META?.RightState?.AttachmentType === "Wall"
        ) {
            if (this_area_data.META?.RightState?.AttachmentVariation.includes("Timber")) {
                GABLE_PARAMETERS.HasInfillBeam2 = 1;
            } else if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth >= 5000) {
                GABLE_PARAMETERS.HasInfillBeam2 = 1;
            }
        }
    } else {
        GABLE_PARAMETERS.HasInfillBeam2 = 1;
    }

    let colourMatch = {
        "Match Rafter": this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamCol1,
    };

    if (!GABLE_PARAMETERS.InfillFlashingColourMatch1)
        GABLE_PARAMETERS.InfillFlashingColourMatch1 = GABLE_PARAMETERS.InfillFlashingColour1;
    if (colourMatch && GABLE_PARAMETERS.InfillFlashingColourMatch1 in colourMatch) {
        GABLE_PARAMETERS.InfillFlashingColour1 = colourMatch[GABLE_PARAMETERS.InfillFlashingColourMatch1];
    } else {
        GABLE_PARAMETERS.InfillFlashingColour1 = GABLE_PARAMETERS.InfillFlashingColourMatch1;
    }

    if (!GABLE_PARAMETERS.InfillFlashingColourMatch2)
        GABLE_PARAMETERS.InfillFlashingColourMatch2 = GABLE_PARAMETERS.InfillFlashingColour2;
    if (colourMatch && GABLE_PARAMETERS.InfillFlashingColourMatch2 in colourMatch) {
        GABLE_PARAMETERS.InfillFlashingColour2 = colourMatch[GABLE_PARAMETERS.InfillFlashingColourMatch2];
    } else {
        GABLE_PARAMETERS.InfillFlashingColour2 = GABLE_PARAMETERS.InfillFlashingColourMatch2;
    }

    let infill_beam_options = ["656510", "1086510", "1586510"];
    if (design_option?.infill_beam?.options) {
        infill_beam_options = design_option?.infill_beam?.options;
    }
    if (
        design_option?.infill_beam?.section_default &&
        !infill_beam_options.includes(this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType)
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType =
            design_option?.infill_beam?.section_default;
    }

    if (this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType === "656510") {
        if (this_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterL > 0)
            this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType = "1086510";
        if (this_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterR > 0)
            this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType = "1086510";
        if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth >= 4500)
            this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType = "1086510";
    }
    GABLE_PARAMETERS.GableFanBracket = design_option?.gable_fan_code ? design_option?.gable_fan_code : "";
    GABLE_PARAMETERS.GableApexFanBracket = design_option?.gable_apex_fan_code ? design_option?.gable_apex_fan_code : "";

    if (window.LYSAGHT) {
        if (this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CollarTie === 1)
            GABLE_PARAMETERS.DownlightFlashing = 0;

        this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].InfillBeamType =
            this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3;

        GABLE_PARAMETERS.InfillOnTopBeam1 = "";
        GABLE_PARAMETERS.InfillOnTopBeam2 = "";
        GABLE_PARAMETERS.DutchGableBeamInset = 1;
        GABLE_PARAMETERS.DutchGablePosition = 0.2;
        GABLE_PARAMETERS.DutchGableBeamInsetPosition = 0.6;
        GABLE_PARAMETERS.DutchGableCollarTieBeam = "FL15015";
        if (this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.CollarTie === 1) {
            GABLE_PARAMETERS.DutchGableCollarTieBeam =
                this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.CollarTieBeam;
        }

        GABLE_PARAMETERS.GableRidgeBackChannel = false;
    } else {
        if (this_area_data.BEAMS_AND_POSTS.HasRidgeBeam === 0) {
        } else {
            GABLE_PARAMETERS.InfillEndAlign1 = 1;
            GABLE_PARAMETERS.InfillEndAlign2 = 1;
        }

        let job_attachment = job?.SiteParameters?.ExistingStructure?.AttachmentType;

        GABLE_PARAMETERS.InfillOnTopBeam1 = "";
        GABLE_PARAMETERS.InfillOnTopBeam2 = "";

        if (is_portal) {
            if (
                this_area_data.META?.LeftState?.HasAttachment &&
                this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].TrussInfill1 != "None" &&
                this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType1 == "Gable" &&
                (this_area_data.META?.LeftState?.AttachmentType.toUpperCase().includes("FASCIA") ||
                    this_area_data.META?.LeftState?.AttachmentType.toUpperCase().includes("BEAM"))
            ) {
                GABLE_PARAMETERS.InfillOnTopBeam1 = "656510";
            }
            if (
                this_area_data.META?.RightState?.HasAttachment &&
                this_area_data[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS].TrussInfill2 != "None" &&
                this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofType2 == "Gable" &&
                (this_area_data.META?.RightState?.AttachmentType.toUpperCase().includes("FASCIA") ||
                    this_area_data.META?.RightState?.AttachmentType.toUpperCase().includes("BEAM"))
            ) {
                GABLE_PARAMETERS.InfillOnTopBeam2 = "656510";
            }
        }

        GABLE_PARAMETERS.DutchGableBeamInset = 0;
        GABLE_PARAMETERS.DutchGablePosition = 0.25;
        if (GABLE_PARAMETERS.DownlightFlashing) {
            GABLE_PARAMETERS.GableRidgeBackChannel = false;
        } else {
            GABLE_PARAMETERS.GableRidgeBackChannel = true;
        }
    }

    let roofsheet_types = config.roofsheet_types;
    let roof_sheet_data = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING];
    let roofsheetgroup = roofsheet_types[roof_sheet_data["RoofGroupType"]];
    if (roofsheetgroup?.allow_gable_top_backchannel) {
        GABLE_PARAMETERS.GableRidgeBackChannel = true;
    }

    return GABLE_PARAMETERS;
};

export const validateCustomerDistributorData = (job, app = null) => {
    if (app !== null) {
        const user_data = app.user;
        if (job?.User.id === app.user.id) {
            job.User = {
                ...job.User,
                id: user_data?.id ? user_data.id : "",
                BusinessCode: user_data?.BusinessCode ? user_data.BusinessCode : "",
                Email: user_data?.Email ? user_data.Email : "",
                Phone: user_data?.Phone ? user_data.Phone : "",
                FirstName: user_data?.FirstName ? user_data.FirstName : "",
                LastName: user_data?.LastName ? user_data.LastName : "",
                DisplayName: user_data?.DisplayName ? user_data.DisplayName : "",
            };
        }
        if (job?.Distributor.id === app.user.BusinessDetails.id) {
            job.Distributor = COMMON.deepCopy(app.user.BusinessDetails);
        } else if (app.user.BusinessDetails.Children) {
            for (var child of app.user.BusinessDetails.Children) {
                if (job.Distributor.id === child.id) {
                    job.Distributor = COMMON.deepCopy(child);
                }
            }
        }
    }
    if (job?.Distributor?.SalesForceData) job.Distributor.SalesForceData = null;
    if (job?.Distributor?.Children) job.Distributor.Children = null;
    if (job?.Distributor?.Offer?.offerings) job.Distributor.Offer.offerings = null;

    if (job?.Distributor?.Offer?.Regions?.[0]) job.POA = job?.Distributor?.Offer?.Regions?.[0];

    let markup_structure = job?.Distributor?.MarkupStructure;
    if (
        markup_structure &&
        (!job.Customer.Type || !Object.keys(markup_structure.Markups).includes(job.Customer.Type))
    ) {
        if (markup_structure?.MarkupDefault) job.Customer.Type = markup_structure.MarkupDefault;
        else job.Customer.Type = Object.keys(markup_structure.Markups)[0];
    }
    return job;
};

function GetKPA(wind_data, annual_exceedance_prob) {
    let ms = wind_data["critical_result"]["values"][0]["ms"];
    let md = wind_data["critical_result"]["values"][0]["md"];
    let mzcat = wind_data["critical_result"]["values"][0]["mzcat"];
    let mt = wind_data["critical_result"]["values"][0]["mt"];

    let vr_adjustment_factor = 1;
    let annual_exceedance_prob_vr = "vr_" + annual_exceedance_prob;
    if (wind_data[annual_exceedance_prob_vr] == null && annual_exceedance_prob === 50) {
        // if 50 not found use 100
        annual_exceedance_prob_vr = "vr_100";
    }
    if (wind_data[annual_exceedance_prob_vr] == null && annual_exceedance_prob === 200) {
        //simulated as per DY instructions email  to KC Fri, Jul 26, 2019,
        vr_adjustment_factor = 0.956;
        annual_exceedance_prob_vr = "vr_500";
    }
    if (wind_data[annual_exceedance_prob_vr] == null && annual_exceedance_prob === 250) {
        vr_adjustment_factor = 0.956; // need to eventually get a new adjustment factor
        annual_exceedance_prob_vr = "vr_500";
    }

    return {
        kPa:
            ((0.6 * Math.pow(toNumber(wind_data[annual_exceedance_prob_vr]) * vr_adjustment_factor, 2)) / 1000) *
            ms *
            md *
            mzcat *
            mt,
        vr: toNumber(wind_data[annual_exceedance_prob_vr]) * vr_adjustment_factor,
    };
}

function GetWindZoneEquiv(Kpa, region, round_down = false) {
    let estimatedWZ = "N/A";
    let wz = "N/A";

    let upper = 999;
    let lower = 0;
    estimatedWZ = "N/A";

    if (Kpa > 4.44) {
        wz = "N/A";
    } else if (Kpa > 3.29) {
        // N6
        upper = 4.44;
        lower = 3.29;
        wz = 6;
    } else if (Kpa > 2.23) {
        // N5
        upper = 3.29;
        lower = 2.23;
        wz = 5;
    } else if (Kpa > 1.5) {
        // N4
        upper = 2.23;
        lower = 1.5;
        wz = 4;
    } else if (Kpa > 0.96) {
        // N3
        upper = 1.5;
        lower = 0.96;
        wz = 3;
    } else if (Kpa > 0.69) {
        // N2
        upper = 0.96;
        lower = 0.69;
        wz = 2;
    } else {
        // N1
        upper = 0.69;
        lower = 0.0;
        wz = 1;
    }

    if (upper >= 999) estimatedWZ = "N/A";
    else if (wz === "N1") estimatedWZ = "N1";
    else if (wz != "N/A") {
        let dec = ((Kpa - lower) * 10) / (upper - lower);
        if (dec > 9) dec = 9;
        if (dec < 1) dec = 1;

        if (region === "C" || region === "D") {
            wz -= 2;
            if (wz < 1) wz = 1;
            estimatedWZ = "C" + (wz - 1) + "." + dec.toFixed(0);
            if (wz === 1) estimatedWZ = "C1.0";
            // DES-1739 - allowance for rounding so that eg N2.5 = N2, N2.6 = N3
            if (round_down && wz > 1 && dec <= 5) {
                wz -= 1;
            }
        } else {
            estimatedWZ = "N" + (wz - 1) + "." + dec.toFixed(0);
            if (wz === 1) estimatedWZ = "N1.0";
            // DES-1739 - allowance for rounding so that eg N2.5 = N2, N2.6 = N3
            if (round_down && wz > 1 && dec <= 5) {
                wz -= 1;
            } else {
                //allowance for N2.0935 scenarios 1.01 kPa sencarios to be equiv N2 - DY 18/5/2021
                if (wz === 3 && dec <= 1) {
                    wz = 2;
                }
            }
        }
    }

    return [(region === "C" || region === "D" ? "C" : "N") + wz, estimatedWZ];
}

export function calculate_wind_data(wind_data, vr_mode = 0, round_down = false) {
    let impl1_annual_exceedance_prob = vr_mode ? vr_mode : 50;
    let impl1_calculation = GetKPA(wind_data, impl1_annual_exceedance_prob);
    let impl1_wz_equiv = GetWindZoneEquiv(impl1_calculation.kPa, wind_data?.region, round_down);
    let impl2_annual_exceedance_prob = vr_mode ? vr_mode : 250;
    let impl2_calculation = GetKPA(wind_data, impl2_annual_exceedance_prob);
    let impl2_wz_equiv = GetWindZoneEquiv(impl2_calculation.kPa, wind_data?.region, round_down);
    let impl3_annual_exceedance_prob = vr_mode ? vr_mode : 500;
    let impl3_calculation = GetKPA(wind_data, impl3_annual_exceedance_prob);
    let impl3_wz_equiv = GetWindZoneEquiv(impl3_calculation.kPa, wind_data?.region, round_down);

    return {
        importance_level_1: {
            base_pressure: impl1_calculation.kPa,
            windzone_equiv: impl1_wz_equiv[0],
            windzone_estimate: impl1_wz_equiv[1],
            annual_exceedance_prob: impl1_annual_exceedance_prob,
            vr: impl1_calculation.vr,
        },
        importance_level_2: {
            base_pressure: impl2_calculation.kPa,
            windzone_equiv: impl2_wz_equiv[0],
            windzone_estimate: impl2_wz_equiv[1],
            annual_exceedance_prob: impl2_annual_exceedance_prob,
            vr: impl2_calculation.vr,
        },
        importance_level_3: {
            base_pressure: impl3_calculation.kPa,
            windzone_equiv: impl3_wz_equiv[0],
            windzone_estimate: impl3_wz_equiv[1],
            annual_exceedance_prob: impl3_annual_exceedance_prob,
            vr: impl3_calculation.vr,
        },
    };
}

const states = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];

export const validateSiteData = (job, config) => {
    if (!job?.SiteParameters?.WindData?.WindZoneAS1170?.critical) {
        job.SiteParameters.WindData.WindZone_UseAS1170 = false;
    } else {
        const formattedAddress = job?.SiteParameters?.Address?.FormattedAddress;
        if (
            !formattedAddress ||
            formattedAddress.length < 8 ||
            (job?.SiteParameters?.Address?.Suburb && !formattedAddress.includes(job.SiteParameters.Address.Suburb)) ||
            (job?.SiteParameters?.Address?.Street && !formattedAddress.includes(job.SiteParameters.Address.Street))
        ) {
            // something not right about formatted address
            if (job?.SiteParameters?.Address?.Suburb && job?.SiteParameters?.Address?.Street) {
                // if there is a state and street, try to reconstruct formatted address
                let address = "";
                if (job?.SiteParameters?.Address?.StreetNumber) {
                    address += job.SiteParameters.Address.StreetNumber + " ";
                }
                if (job?.SiteParameters?.Address?.Street) {
                    address += job.SiteParameters.Address.Street + ", ";
                }
                if (job?.SiteParameters?.Address?.Suburb) {
                    address += job.SiteParameters.Address.Suburb + " ";
                }
                if (job?.SiteParameters?.Address?.State) {
                    address += job.SiteParameters.Address.State + " ";
                }
                job.SiteParameters.Address.FormattedAddress = address.trim();
            } else {
                //not valid, hence engineering wind data is not valid
                if (job?.SiteParameters?.WindData?.WindZoneAS1170) {
                    delete job.SiteParameters.WindData.WindZoneAS1170;
                }
                if (job.SiteParameters.Address) {
                    job.SiteParameters.Address.FormattedAddress = "";
                    job.SiteParameters.Address.StreetNumber = "";
                    job.SiteParameters.Address.Street = "";
                    job.SiteParameters.Address.Suburb = "";
                    job.SiteParameters.Address.State = "";
                    job.SiteParameters.Address.LatLng = null;
                }
            }
        }
        if (!job?.SiteParameters?.Address?.State) {
            //if state is not set, try set it from formatted string, mosy likely beacuse AddressAutoComplete PlacesService failed
            if (job?.SiteParameters?.Address?.FormattedAddress) {
                let address = job?.SiteParameters?.Address?.FormattedAddress;
                for (let state of states) {
                    if (address.toUpperCase().includes(" " + state + ",")) job.SiteParameters.Address.State = state;
                }
                let split = address.split(",");
                if (split[0]) {
                    //assume first bit is street and street num
                    job.SiteParameters.Address.Street = split[0].trim();
                }
                if (split[1]) {
                    //assume second bit is suburb / town and state
                    job.SiteParameters.Address.Suburb = split[1].replace(job.SiteParameters.Address.State, "").trim();
                }
            }
        }

        job.SiteParameters.WindData.WindZone_UseAS1170 = true;
        let vr_mode = job?.DesignParameters?.vr_mode ? job?.DesignParameters?.vr_mode : 0;

        job.SiteParameters.RoundDownWZ = config?.job_settings?.round_down_wz;

        job.SiteParameters.WindData.WindZoneAS1170.calculated = calculate_wind_data(
            job.SiteParameters.WindData.WindZoneAS1170,
            vr_mode,
            job.SiteParameters.RoundDownWZ
        );

        let importance_level = 2;
        if (!job?.SiteParameters?.ImportanceLevel || job?.SiteParameters?.ImportanceLevel === "") {
            if (
                job.DesignParameters.Freestanding &&
                job.SiteParameters.UseType === "Domestic" &&
                job?.SiteParameters?.WindData?.Blocking === 0
            )
                importance_level = 1;
            if (job.SiteParameters.UseType === "Major Structure") importance_level = 3;
            job.SiteParameters.WindData.importance_level = importance_level;
            job.SiteParameters.ImportanceLevel = importance_level;
        } else {
            importance_level = job.SiteParameters.ImportanceLevel;
        }

        if (job?.SiteParameters?.WindData?.Blocking > 0 && importance_level === 1) {
            importance_level = 2;
            job.SiteParameters.ImportanceLevel = 2;
        }

        let importance_level_data = job.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_2;
        if (importance_level === 1)
            importance_level_data = job.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_1;
        if (importance_level === 3)
            importance_level_data = job.SiteParameters?.WindData?.WindZoneAS1170?.calculated?.importance_level_3;

        if (importance_level_data) {
            job.SiteParameters.WindData.WindZone = importance_level_data?.windzone_equiv;
        }

        job.SiteParameters.WindData.importance_level = importance_level;

        if (job.SiteParameters?.WindData?.WindZoneAS1170) {
            if (job.SiteParameters.WindData.Blocking === 4) job.SiteParameters.WindData.Blocking = 3;

            job.SiteParameters.WindData.WindZoneAS1170.importance_level = importance_level;
            job.SiteParameters.WindData.WindZoneAS1170.blocking_factor = job.SiteParameters.WindData.Blocking;

            if (importance_level_data) {
                job.SiteParameters.WindData.WindZoneAS1170.base_pressure =
                    importance_level_data.base_pressure.toFixed(2);
                job.SiteParameters.WindData.WindZoneAS1170.annual_exceedance_prob =
                    importance_level_data.annual_exceedance_prob;
                job.SiteParameters.WindData.WindZoneAS1170.vr = importance_level_data.vr;
            }
        }
    }

    if (job.DesignParameters.DeckMode === 1) {
        job.SiteParameters.ExistingStructure.AttachmentType = "Wall";
        job.SiteParameters.ExistingStructure.JobSummaryAttachmentText = "Directly To Wall";
        job.SiteParameters.ExistingStructure.EaveDepth = 0;
    } else if (job.DesignParameters.USE_ATTACHMENTS_2) {
        job.SiteParameters.ExistingStructure.AttachmentType = "Timber Fascia Drop";

        // For Job Summary only (report-gen)
        let existingStructureAttachments = new Set();

        if (job?.AreaSpecifications) {
            for (let area of job?.AreaSpecifications) {
                if (area?.ATTACHMENTS?.AttachmentModifications) {
                    for (let mod of area?.ATTACHMENTS?.AttachmentModifications) {
                        if (
                            (mod.Ref.startsWith("Front") && area.ATTACHMENTS.AttachmentBottom === 1) ||
                            (mod.Ref.startsWith("Back") && area.ATTACHMENTS.AttachmentTop === 1) ||
                            (mod.Ref.startsWith("Left") && area.ATTACHMENTS.AttachmentLeft === 1) ||
                            (mod.Ref.startsWith("Right") && area.ATTACHMENTS.AttachmentRight === 1)
                        ) {
                            const newAttachment = {
                                AttachmentType: mod?.AttachmentType || "",
                                AttachmentVariation: mod?.AttachmentVariation || "",
                            };

                            let isDuplicate = false;
                            for (let attachment of existingStructureAttachments) {
                                if (
                                    attachment.AttachmentType === newAttachment.AttachmentType &&
                                    attachment.AttachmentVariation === newAttachment.AttachmentVariation
                                ) {
                                    isDuplicate = true;
                                    break;
                                }
                            }

                            if (!isDuplicate) {
                                existingStructureAttachments.add(newAttachment);
                            }
                        }
                    }
                }
            }
        }

        let attachmentText;
        let attachmentVariationText;

        if (existingStructureAttachments.size > 0) {
            if (existingStructureAttachments.size === 1) {
                const singleValue = existingStructureAttachments.values().next().value;
                attachmentText = singleValue.AttachmentType;
                attachmentVariationText = singleValue.AttachmentVariation;
            } else {
                attachmentText = "Mixed";
                attachmentVariationText = "";
            }
        } else {
            attachmentText = "Not Attached (freestanding)";
            attachmentVariationText = "";
        }

        job.SiteParameters.ExistingStructure.JobSummaryAttachmentText = attachmentText;
        job.SiteParameters.ExistingStructure.JobSummaryAttachmentVariationText = attachmentVariationText;
    }

    job.SiteParameters.ExistingStructure.FasciaType = job?.SiteParameters?.ExistingStructure?.AttachmentType;

    let spacing = job.SiteParameters?.ExistingStructure?.RoofType === "Tile" ? 1200 : 900;
    if (job.SiteParameters?.ExistingStructure?.RoofType === "Tile") {
        if (config?.attachment_types?.["Rafter Brackets supporting Beam"]?.bracket_spacing_tile)
            spacing = config?.attachment_types?.["Rafter Brackets supporting Beam"]?.bracket_spacing_tile;
    } else {
        if (config?.attachment_types?.["Rafter Brackets supporting Beam"]?.bracket_spacing_sheet)
            spacing = config?.attachment_types?.["Rafter Brackets supporting Beam"]?.bracket_spacing_sheet;
    }
    job.SiteParameters.RafterBracketSpacing = spacing;
    job.SiteParameters.RiserBracketSpacing = spacing;
    job.SiteParameters.CarportRiserBracketSpacing = spacing;

    let job_attachment = job?.SiteParameters?.[SITE_PARAMETER_SECTIONS?.ExistingStructure]?.AttachmentType;
    if (
        job_attachment &&
        (job_attachment.toUpperCase().includes("WALL") || job_attachment.toUpperCase().includes("FASCIA")) &&
        job.SiteParameters?.ExistingStructure?.RoofType === "Tile"
    ) {
        job.SiteParameters.RafterBracketSpacing = "600";
        if (config?.attachment_types?.["Fascia with Receiver Channel"]?.bracket_spacing_tile)
            job.SiteParameters.RafterBracketSpacing =
                config?.attachment_types?.["Fascia with Receiver Channel"]?.bracket_spacing_tile;
    }

    if (
        job.SiteParameters.ExistingStructure.FrameType === "Timber - Trussed" ||
        job.SiteParameters.ExistingStructure.FrameType === "Timber - Conventional"
    )
        job.SiteParameters.ExistingStructure.FrameType = "Timber Frame - Brick Veneer";

    job.SiteParameters.AutoExtendBeamsToWall = 1;

    // LYSAGHT SPECIFIC VALIDATIONS
    if (job?.Distributor?.Brand === "Lysaght") {
        job.SiteParameters.FasciaBracketDefault = "CON110";
        job.SiteParameters.RafterBracketDefault = "UCEG";
        job.SiteParameters.RiserBracketDefault = "UCB";
        job.SiteParameters.FlyoverBracketDefault = "JMBP1";
        job.SiteParameters.WallMountBracketDefault = "UCF";
        job.SiteParameters.RiserFullHeight = 1;
        job.SiteParameters.FlyoverFullHeight = 0;
        job.SiteParameters.SpliceOffset = 150;
        job.SiteParameters.CONST_STRUT_BEAM = "FL10011";
        job.SiteParameters.CONST_BEAM_CUT_EXTRA = 0;
        job.SiteParameters.CONST_FREESPAN_BEAM_CUT_EXTRA = 0;
        job.SiteParameters.CONST_POST_EXTRA = 0;
        job.SiteParameters.MergeBeamBefore = 1;
    } else {
        job.SiteParameters.FasciaBracketDefault = "BK26DEG";
        job.SiteParameters.RafterBracketDefault = "BK38";
        let region = job?.Distributor?.Offer?.Regions?.[0];
        if (job?.App?.temp_POA) region = job?.App?.temp_POA;
        job.SiteParameters.RiserBracketDefault = "BK39";
        job.SiteParameters.FlyoverBracketDefault = "BK50";
        job.SiteParameters.WallMountBracketDefault = "BK25";
        job.SiteParameters.RiserFullHeight = 1;
        job.SiteParameters.FlyoverFullHeight = 1;
        job.SiteParameters.SpliceOffset = 0;
        job.SiteParameters.CONST_STRUT_BEAM = "656510";
        job.SiteParameters.CONST_BEAM_CUT_EXTRA = 30;
        job.SiteParameters.CONST_FREESPAN_BEAM_CUT_EXTRA = 30;
        job.SiteParameters.CONST_POST_EXTRA = 100;
        job.SiteParameters.MergeBeamBefore = 1;
    }

    if (job.DesignParameters.DeckMode === 1) {
        job.SiteParameters.CONST_SET_INTO_FOOTING_DISTANCE = 300;
    } else {
        job.SiteParameters.CONST_SET_INTO_FOOTING_DISTANCE = 500;
    }

    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    //use attachment data
    if (config?.attachment_types?.["Fascia with Receiver Channel"]?.bracket_type_code?.default) {
        job.SiteParameters.FasciaBracketDefault =
            config?.attachment_types?.["Fascia with Receiver Channel"]?.bracket_type_code?.default;
    }
    if (is_cyclonic) {
        job.SiteParameters.FasciaBracketDefault = "BK26DEG";
        if (config?.attachment_types?.["Fascia with Receiver Channel"]?.bracket_type_code?.cyclonic) {
            job.SiteParameters.FasciaBracketDefault =
                config?.attachment_types?.["Fascia with Receiver Channel"]?.bracket_type_code?.cyclonic;
        }
    }
    if (config?.attachment_types?.["Rafter Brackets supporting Beam"]?.bracket_type_code?.default) {
        job.SiteParameters.RafterBracketDefault =
            config?.attachment_types?.["Rafter Brackets supporting Beam"]?.bracket_type_code?.default;
    }
    if (
        config?.attachment_types?.["Rafter Brackets supporting Beam"]?.variations?.["On Riser"]?.bracket_type_code
            ?.default
    ) {
        job.SiteParameters.RiserBracketDefault =
            config?.attachment_types?.["Rafter Brackets supporting Beam"]?.variations?.[
                "On Riser"
            ]?.bracket_type_code?.default;
    }

    job.SiteParameters.DefaultFasciaBracket = job.SiteParameters.FasciaBracketDefault;
    job.SiteParameters.DefaultRafterBracket = job.SiteParameters.RafterBracketDefault;

    job.SiteParameters.SizeAdjustment = 0;

    if (job.DesignParameters.SplicingLength === 8000) {
        job.DesignParameters.SplicingLength = 9000;
    }

    job.DesignParameters.MinRoofLoadArea = 250;

    //get flyover spacing
    if (job?.SiteParameters?.WindData?.WindZoneAS1170?.base_pressure) {
        let max_area_length = 0;
        let max_area_depth = 0;
        let max_area_pitch = 0;
        let max_area = 0;

        let total_height = 0;

        for (let area of job.AreaSpecifications) {
            let m2 = area.SHAPE.Length * area.SHAPE.Depth;
            if (m2 > max_area) {
                max_area = m2;
                max_area_length = area.SHAPE.Length;
                max_area_depth = area.SHAPE.Depth;
                max_area_pitch = area.SHAPE.RoofPitch;
            }
            let height = area.SHAPE.Height;
            if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL)
                height = height + area.SHAPE.Depth * 0.5 * COMMON.Sin(area.SHAPE.RoofPitch);
            total_height += height;
        }

        let average_height = total_height / job.AreaSpecifications.length;
        let wall_height = job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].WallHeight;
        let attachment_height = Math.max(wall_height, average_height) / 0.825;
        if (job.DesignParameters.Freestanding || attachment_height < 1000) {
            attachment_height = average_height;
        }

        if (max_area > 0) {
            let wu = getWuUpDown(
                attachment_height,
                job.SiteParameters.WindData.WindZoneAS1170.base_pressure,
                job.DesignParameters.TotalLength,
                average_height,
                job.SiteParameters.WindData.WindZoneAS1170.blocking_factor
            );

            job.SiteParameters.FlyoverBracketSpacing = GetFlyoverSpacing(
                max_area_length,
                max_area_depth,
                max_area_pitch,
                Math.max(Math.abs(wu.UP), Math.abs(wu.DOWN)),
                is_cyclonic
            );
        }
    }

    // set standrd site data....
    for (let this_area_data of job.AreaSpecifications) {
        this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType = "";
        this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight = "";
        this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_EaveWidth = "";

        if (job.DesignParameters.USE_ATTACHMENTS_2) {
            if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.DECK) {
                this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType = "Wall";
            } else if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType = "Beam";
                this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight = this_area_data.SHAPE.Height;
            } else {
                this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType = "Timber Fascia Drop";

                let up_fascia = job.SiteParameters?.ExistingStructure?.FasciaHeight
                    ? job.SiteParameters?.ExistingStructure?.FasciaHeight - 110
                    : 75;
                this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight =
                    this_area_data.SHAPE.Height - up_fascia;
            }

            if (this_area_data.areaIndex === 0)
                job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].WallHeight =
                    this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight;
        }
    }

    if (job?.DesignParameters?.DisableAddCoverSheet === undefined) {
        job.DesignParameters.DisableAddCoverSheet = window.FIELDERS ? false : true;
    }
    if (config?.job_settings?.disable_add_cover_sheet !== undefined) {
        job.DesignParameters.DisableAddCoverSheet = config.job_settings.disable_add_cover_sheet;
    }
    return job;
};

function getWuUpDown(existing_height, base_pressure, total_length, average_height, SIDES_ENCLOSED) {
    let h = existing_height;

    if (!base_pressure) return 0;
    let hc = average_height;
    let Hc_H = hc / h;
    let hc_total_length = hc / total_length;
    let CPN_UP_INTERPOLATION_ADJ = 0;
    if (Hc_H >= 1) {
        CPN_UP_INTERPOLATION_ADJ = 0;
    } else if (Hc_H >= 0.75) {
        CPN_UP_INTERPOLATION_ADJ =
            ((Hc_H - 0.75) / 0.25) *
            (Math.min(1.5, 0.3 + 0.6 * hc_total_length) - Math.min(1.5, 0.3 + 0.2 * hc_total_length));
    } else if (Hc_H >= 0.5) {
        CPN_UP_INTERPOLATION_ADJ = ((Hc_H - 0.5) / 0.25) * (Math.min(1.5, 0.3 + 0.2 * hc_total_length) - 0.3);
    } else if (Hc_H >= 0.2) {
        CPN_UP_INTERPOLATION_ADJ = ((Hc_H - 0.2) / 0.3) * 0.1;
    }

    let CPN_UP = -0.2;
    if (Hc_H >= 1) {
        CPN_UP = -Math.min(1.5, 0.3 + 0.6 * hc_total_length);
    } else if (Hc_H >= 0.75) {
        CPN_UP = -Math.min(1.5, 0.3 + 0.2 * hc_total_length);
    } else if (Hc_H >= 0.5) {
        CPN_UP = -0.3;
    } else if (Hc_H >= 0.2) {
        CPN_UP = -0.2;
    }

    CPN_UP = CPN_UP - CPN_UP_INTERPOLATION_ADJ;

    let CPN_UP_WU = -1.2;
    if (SIDES_ENCLOSED >= 3 && hc_total_length <= 0.5 && Hc_H < 0.8) {
        CPN_UP_WU = -1.2;
    } else if (SIDES_ENCLOSED === 2 && hc_total_length <= 0.5 && Hc_H < 0.8) {
        CPN_UP_WU = -1;
    } else {
        CPN_UP_WU = Math.min(CPN_UP, -0.4);
    }

    let qz_p = base_pressure;
    let Non_directional_wind_factor = 0.95;
    let Wu_UP = Non_directional_wind_factor * CPN_UP_WU * qz_p; // noo self weight of roof sheet weight

    let CPN_DOWN_INTERPOLATION_ADJ = 0;
    if (Hc_H >= 1) {
        CPN_DOWN_INTERPOLATION_ADJ = 0;
    } else if (Hc_H >= 0.75) {
        CPN_DOWN_INTERPOLATION_ADJ = ((Hc_H - 0.75) / 0.25) * 0.2;
    } else if (Hc_H >= 0.5) {
        CPN_DOWN_INTERPOLATION_ADJ = ((Hc_H - 0.5) / 0.25) * 0.1;
    } else if (Hc_H >= 0.2) {
        CPN_DOWN_INTERPOLATION_ADJ = ((Hc_H - 0.2) / 0.3) * 0.2;
    } else if (Hc_H >= 0.1) {
        CPN_DOWN_INTERPOLATION_ADJ = ((Hc_H - 0.1) / 0.1) * 0.5;
    }

    let CPN_DOWN = 1.2;
    if (Hc_H >= 1) {
        CPN_DOWN = 0.2;
    } else if (Hc_H >= 0.75) {
        CPN_DOWN = 0.4;
    } else if (Hc_H >= 0.5) {
        CPN_DOWN = 0.5;
    } else if (Hc_H >= 0.2) {
        CPN_DOWN = 0.7;
    }

    CPN_DOWN = CPN_DOWN - CPN_DOWN_INTERPOLATION_ADJ;

    let CPN_DOWN_WU = Math.max(CPN_DOWN, 0.4);
    let Wu_DOWN = Non_directional_wind_factor * CPN_DOWN_WU * qz_p; // noo self weight of roof sheet weight

    return { UP: Wu_UP, DOWN: Wu_DOWN };
}

function GetFlyoverSpacing(length, depth, pitch, wu, is_cyclonic) {
    let area = ((length / 1000) * depth) / 1000 / Cos(pitch);
    let area_estimate = area * 0.55;

    let area_pressure = wu * area_estimate;

    let bracket_capacity = 6.7;
    if (window.LYSAGHT) {
        bracket_capacity = 9.3;
        if (is_cyclonic) bracket_capacity = 10.3;
    }

    let est_num_brackets = Math.trunc(Math.abs(area_pressure) / bracket_capacity) + 1;
    let spacing = (length + 200) / (est_num_brackets - 1);
    if (est_num_brackets == 2) {
        spacing = length + 200;
    }

    // 6000mm
    // 4000 in cyclonic maxHeight: // house rafter spacing for the min.
    if (window.LYSAGHT) {
        if (spacing > 6100) spacing = 6100;
    } else {
        if (spacing > 3100) spacing = 3100;
    }

    if (is_cyclonic && spacing > 4000) spacing = 4000;
    return spacing;
}

function similarity(s1, s2) {
    if (s1?.length > 0 && s2?.length > 0) {
        var longer = s1;
        var shorter = s2;
        if (s1.length < s2.length) {
            longer = s2;
            shorter = s1;
        }
        var longerLength = longer.length;
        if (longerLength === 0) {
            return 1.0;
        }
        return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
    } else return 0;
}

function editDistance(s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    // eslint-disable-next-line no-array-constructor
    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i === 0) costs[j] = j;
            else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) !== s2.charAt(j - 1))
                        newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0) costs[s2.length] = lastValue;
    }
    return costs[s2.length];
}

export const validateRoofSheetData = (config, job, areaIndex) => {
    let this_area_data = job.AreaSpecifications[areaIndex];
    let this_area = this_area_data;
    let roof_sheet_data = { ...this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING] };
    let roofsheet_types = config.roofsheet_types;
    let design_option = config?.design_options?.[this_area_data.SHAPE.DesignType];
    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;

    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
        if (this_area_data.SHAPE.Depth <= 4000) {
            roof_sheet_data.RoofType = "Alushade SingleFin";
            roof_sheet_data.RoofGroupType = "Alspec Alushade";
            roof_sheet_data.RoofSubType = "Alushade SingleFin";
        } else {
            roof_sheet_data.RoofType = "Alushade MaxiFin";
            roof_sheet_data.RoofGroupType = "Alspec Alushade";
            roof_sheet_data.RoofSubType = "Alushade MaxiFin";
        }
        roof_sheet_data.FlashingColour = roof_sheet_data.RoofSheetColour;
        roof_sheet_data.FlashingColourMatchString = roof_sheet_data.RoofSheetColour;
    }

    if (!roof_sheet_data["RoofGroupType"] && roof_sheet_data.RoofType) {
        // reverse setup, mainly from imported job
        let roof_sheet_modified = roof_sheet_data.RoofType.replace("M-CLAD", "TL5").replace("(TL5) ", "");

        for (let group in roofsheet_types) {
            let subtypes = roofsheet_types[group].subtypes;
            for (let sub_type in subtypes) {
                if (
                    subtypes[sub_type].roofsheet_id === roof_sheet_data.RoofType ||
                    subtypes[sub_type].roofsheet_id === roof_sheet_modified
                ) {
                    roof_sheet_data["RoofGroupType"] = group;
                    roof_sheet_data["RoofSubType"] = sub_type;
                    roof_sheet_data["RoofSpan"] = "No Foot Traffic";
                } else if (
                    subtypes[sub_type]?.roofsheet_id_non_trafficable === roof_sheet_data.RoofType ||
                    subtypes[sub_type].roofsheet_id_non_trafficable === roof_sheet_modified
                ) {
                    roof_sheet_data["RoofGroupType"] = group;
                    roof_sheet_data["RoofSubType"] = sub_type;
                    roof_sheet_data["RoofSpan"] = "Non-Trafficable";
                } else if (
                    subtypes[sub_type]?.roofsheet_id + " - CYCLONIC SPANS" === roof_sheet_data.RoofType ||
                    subtypes[sub_type].roofsheet_id + " - CYCLONIC SPANS" === roof_sheet_modified
                ) {
                    roof_sheet_data["RoofGroupType"] = group;
                    roof_sheet_data["RoofSubType"] = sub_type;
                    roof_sheet_data["RoofSpan"] = "Cyclonic";
                }
            }
        }
    }

    // Roof grouptype doesn't exist and not null
    if (!roofsheet_types[roof_sheet_data["RoofGroupType"]] && roof_sheet_data["RoofGroupType"] !== ("" || null)) {
        let possible_rooftype = [];
        // Find likely match based on Levenshtein distance and roofsheet_id
        Object.keys(roofsheet_types).forEach(function (key, index) {
            Object.keys(roofsheet_types[key].subtypes).forEach(function (key2, index) {
                possible_rooftype.push({
                    group: key,
                    subtype: key2,
                    sheet: roofsheet_types[key].subtypes[key2].roofsheet_id,
                    value: similarity(roofsheet_types[key].subtypes[key2].roofsheet_id, roof_sheet_data["RoofType"]),
                });
            });
        });

        // If there is a greater than 38% string match to the top result
        // then use that roofsheet
        if (
            possible_rooftype.sort(function (a, b) {
                return b.value - a.value;
            })[0].value >= 0.38
        ) {
            roof_sheet_data["RoofGroupType"] = possible_rooftype[0].group;
            roof_sheet_data["RoofSubType"] = possible_rooftype[0].subtype;
            roof_sheet_data["RoofType"] = possible_rooftype[0].sheet;
        } else {
            // Hard coded for Versalink (id's are very unsimilar)
            if (roof_sheet_data["RoofType"] === "Versiclad Versalink 1000 Smooth 50mm") {
                roof_sheet_data["RoofGroupType"] = "Versiclad Versalink";
                roof_sheet_data["RoofSubType"] = "Versalink Smooth 50mm";
                roof_sheet_data["RoofType"] = "Versalink 1000 50mm (Non-trafficable)";
            } else if (roof_sheet_data["RoofType"] === "Versiclad Versalink 1000 Smooth 75mm") {
                roof_sheet_data["RoofGroupType"] = "Versiclad Versalink";
                roof_sheet_data["RoofSubType"] = "Versalink Smooth 75mm";
                roof_sheet_data["RoofType"] = "Versalink 1000 75mm (Non-trafficable)";
            } else if (roof_sheet_data["RoofType"] === "Versiclad Versalink 1000 Smooth 100mm") {
                roof_sheet_data["RoofGroupType"] = "Versiclad Versalink";
                roof_sheet_data["RoofSubType"] = "Versalink Smooth 100mm";
                roof_sheet_data["RoofType"] = "Versalink 1000 100mm (Non-trafficable)";
            }
        }
    }

    if (
        (!design_option?.roofsheet_groups?.includes(roof_sheet_data["RoofGroupType"]) ||
            !roofsheet_types[roof_sheet_data["RoofGroupType"]]) &&
        design_option?.roofsheet_default?.grouptype
    ) {
        roof_sheet_data["RoofGroupType"] = design_option?.roofsheet_default?.grouptype;
        roof_sheet_data["RoofSubType"] = design_option?.roofsheet_default?.subtype;
    }

    let roofsheetgroup = roofsheet_types[roof_sheet_data["RoofGroupType"]];

    if (is_cyclonic && !roofsheetgroup.allow_cyclonic) {
        for (let group_key of design_option?.roofsheet_groups) {
            let group = roofsheet_types[group_key];
            if (group.allow_cyclonic) {
                roof_sheet_data["RoofGroupType"] = group_key;
                roof_sheet_data["RoofSubType"] = group.default_subtype;
                roofsheetgroup = group;
                break;
            }
        }
    }

    // roof subtype
    if (roofsheetgroup?.subtypes[roof_sheet_data["RoofSubType"]] === undefined)
        roof_sheet_data.RoofSubType = roofsheetgroup.default_subtype;
    let subType = roofsheetgroup.subtypes[roof_sheet_data.RoofSubType];

    if (is_cyclonic && !subType.allow_cyclonic) {
        roof_sheet_data.RoofSubType = roofsheetgroup.default_subtype;
        subType = roofsheetgroup.subtypes[roof_sheet_data.RoofSubType];
        if (!subType?.allow_cyclonic) {
            for (let sub_key in roofsheetgroup.subtypes) {
                let sub = roofsheetgroup.subtypes[sub_key];
                if (sub.allow_cyclonic) {
                    roof_sheet_data.RoofSubType = sub_key;
                    subType = roofsheetgroup.subtypes[roof_sheet_data.RoofSubType];
                    break;
                }
            }
        }
    }

    if (roof_sheet_data) {
        if (roof_sheet_data["RoofSpan"].includes("Cyclonic") && !is_cyclonic) {
            roof_sheet_data["RoofSpan"] = "No Foot Traffic";
        }
        if (roof_sheet_data["RoofSpan"].includes("Non-Trafficable") && !subType?.allow_non_trafficable) {
            roof_sheet_data["RoofSpan"] = "No Foot Traffic";
        }
        if (roof_sheet_data["RoofSpan"].includes("No Foot Traffic") && subType?.allow_nofoot_traffic === false) {
            roof_sheet_data["RoofSpan"] = "Non-Trafficable";
        }

        if (!roof_sheet_data["RoofSpan"].includes("Cyclonic") && is_cyclonic) {
            roof_sheet_data["RoofSpan"] = roof_sheet_data["RoofSpan"] + " - Cyclonic";
        }
    }

    // roof sheet id
    let roofsheet_double_sided = false;
    if (roof_sheet_data["RoofSheetColour"].includes("/") && !roof_sheet_data["RoofSheetColour"].includes("/Grey")) {
        roofsheet_double_sided = true;
    }

    roof_sheet_data.RoofType = subType.roofsheet_id;
    if (roofsheet_double_sided && subType.roofsheet_id_ds) {
        roof_sheet_data.RoofType = subType.roofsheet_id_ds;
    }
    if (
        subType.allow_non_trafficable &&
        subType.roofsheet_id_non_trafficable &&
        roof_sheet_data.RoofSpan.includes("Non-Trafficable")
    ) {
        roof_sheet_data.RoofType = subType.roofsheet_id_non_trafficable;
        if (roofsheet_double_sided && subType.roofsheet_id_non_trafficable_ds) {
            roof_sheet_data.RoofType = subType.roofsheet_id_non_trafficable_ds;
        }
    }
    if (subType.allow_cyclonic && roof_sheet_data.RoofSpan.includes("Cyclonic")) {
        roof_sheet_data.RoofType += " - CYCLONIC SPANS";
    }

    // roof sheet colour
    let colourList = subType[CONFIG.ROOFSHEET_TYPE.COLOURS];

    if (typeof colourList === "object") {
        let region = job?.Distributor?.Offer?.Regions?.[0];
        if (job?.App?.temp_POA) region = job?.App?.temp_POA;

        let colours_list_to_use = colourList?.["DEFAULT"];
        if (colourList?.[region]) colours_list_to_use = colourList?.[region];
        colourList = colours_list_to_use ? colours_list_to_use : colourList;
    }

    const defaultColour = "TBA";
    let colours = COMMON.GetColourArray(colourList, config.colour_arrays);

    if (
        roof_sheet_data["RoofSheetColour"] &&
        !colours.includes(roof_sheet_data["RoofSheetColour"]) &&
        roof_sheet_data["RoofSheetColour"].includes("/")
    ) {
        let reversed_colour =
            roof_sheet_data["RoofSheetColour"].split("/")[1].trim() +
            "/" +
            roof_sheet_data["RoofSheetColour"].split("/")[0].trim();
        if (colours.includes(reversed_colour)) roof_sheet_data["RoofSheetColour"] = reversed_colour;
    }

    roof_sheet_data["RoofColourSelectionMade"] = true;
    if (colours.length === 1) {
        roof_sheet_data["RoofColourSelectionMade"] = true;
        roof_sheet_data["RoofSheetColour"] = colours[0];
    } else if (roof_sheet_data["RoofSheetColour"] === "TBA") {
        roof_sheet_data["RoofColourSelectionMade"] = false;
    } else if (!roof_sheet_data["RoofSheetColour"] || !colours.includes(roof_sheet_data["RoofSheetColour"])) {
        roof_sheet_data["RoofColourSelectionMade"] = false;
        if (colours.length === 1) {
            roof_sheet_data["RoofColourSelectionMade"] = true;
            roof_sheet_data["RoofSheetColour"] = colours[0];
        } else if (!roof_sheet_data["RoofSheetColour"]) roof_sheet_data["RoofSheetColour"] = defaultColour;
        if (!colours.includes(roof_sheet_data["RoofSheetColour"])) roof_sheet_data["RoofSheetColour"] = defaultColour;
    }

    if (roof_sheet_data["RoofSheetColour"].includes("/Grey") || !roof_sheet_data["RoofSheetColour"].includes("/")) {
        roof_sheet_data["RoofRolling"] = "Top Side";
        if (roof_sheet_data.ReverseRoll) roof_sheet_data["RoofRolling"] = "Under Side";
    } else if (roof_sheet_data["RoofSheetColour"].includes("/")) {
        roof_sheet_data.ReverseRoll = false;
        roof_sheet_data["RoofRolling"] = "Under Side";
    }

    // is skylight sheet valid?
    let skylight_list = subType.skylights
        ? subType.skylights
        : roofsheetgroup.skylights
        ? roofsheetgroup.skylights
        : {};

    if (!roof_sheet_data["SkylightSubType"] && roof_sheet_data.SkylightType) {
        // reverse setup, mainly from imported job
        for (let skylight_key in roofsheetgroup.skylights) {
            let skylight = roofsheetgroup.skylights[skylight_key];
            if (skylight.roofsheet_id === roof_sheet_data.SkylightType) {
                roof_sheet_data["SkylightSubType"] = skylight_key;
            }
        }
    }

    const defaultSkylight = subType[CONFIG.ROOFSHEET_TYPE.DEFAULT_SKYLIGHT]
        ? subType[CONFIG.ROOFSHEET_TYPE.DEFAULT_SKYLIGHT]
        : roofsheetgroup[CONFIG.ROOFSHEET_TYPE.DEFAULT_SKYLIGHT]
        ? roofsheetgroup[CONFIG.ROOFSHEET_TYPE.DEFAULT_SKYLIGHT]
        : "";

    if (skylight_list) {
        if (Array.isArray(skylight_list)) {
            if (!skylight_list.includes(roof_sheet_data["SkylightSubType"]))
                roof_sheet_data["SkylightSubType"] = defaultSkylight;
            if (skylight_list.length === 1) {
                roof_sheet_data["SkylightSubType"] = skylight_list[0];
            }
        } else {
            if (!(roof_sheet_data["SkylightSubType"] in skylight_list)) {
                roof_sheet_data["SkylightSubType"] = defaultSkylight;
            }
            if (Object.keys(skylight_list).length === 1) {
                roof_sheet_data["SkylightSubType"] = Object.keys(skylight_list)[0];
            }
        }
    }
    const skylight_sheet = roofsheetgroup?.skylights?.[roof_sheet_data.SkylightSubType]
        ? roofsheetgroup.skylights[roof_sheet_data.SkylightSubType]
        : {};

    if (skylight_sheet) roof_sheet_data.SkylightType = skylight_sheet.roofsheet_id;
    else roof_sheet_data.SkylightType = roof_sheet_data.RoofType;

    if (!skylight_sheet || (is_cyclonic && roofsheetgroup && roofsheetgroup?.allow_skylight_cyclonic === false)) {
        this_area.SKYLIGHTS = [];
    }

    //skylight colours
    const skylightColourList = skylight_sheet[CONFIG.ROOFSHEET_TYPE.COLOURS]
        ? skylight_sheet[CONFIG.ROOFSHEET_TYPE.COLOURS]
        : "Clear";
    const defaultSkylightColour = skylight_sheet?.[CONFIG.ROOFSHEET_TYPE.DEFAULT_COLOUR]
        ? skylight_sheet?.[CONFIG.ROOFSHEET_TYPE.DEFAULT_COLOUR]
        : "Opal";

    // Update job state with skylight selection
    roof_sheet_data["SkylightIsSelected"] = GetNumberofSkylightsSummaryArea(this_area_data);
    roof_sheet_data["SkylightColourSelectionMade"] = true;

    let skylight_colours = COMMON.GetColourArray(skylightColourList, config.colour_arrays);
    if (skylight_colours.length === 1) {
        roof_sheet_data["SkylightColour"] = skylight_colours[0];
    } else if (skylight_colours && !skylight_colours.includes(roof_sheet_data["SkylightColour"])) {
        if (skylight_colours.length === 1) {
            roof_sheet_data["SkylightColour"] = skylight_colours[0];
        } else if (!skylight_colours.includes(roof_sheet_data["SkylightColour"])) {
            if (skylight_colours.includes(defaultSkylightColour))
                roof_sheet_data["SkylightColour"] = defaultSkylightColour;
            else roof_sheet_data["SkylightColour"] = skylight_colours[0];
        }
    }

    let colourMatch = {
        "Match Roofsheet": roof_sheet_data["RoofSheetColour"],
        "Match Barge": roof_sheet_data.FlashingColour,
    };

    // VALIDATE FLASHING / BARGE COLOUR
    let valid_barge_colours = config.colour_arrays?.["Colorbond Single & Double Sided"];
    if (design_option?.flashing_colours)
        valid_barge_colours = GetColourArray(design_option?.flashing_colours, config.colour_arrays);

    if (!valid_barge_colours.includes([roof_sheet_data.FlashingColour])) {
        if (valid_barge_colours.includes(roof_sheet_data.FlashingColour + "/Grey"))
            roof_sheet_data.FlashingColour = roof_sheet_data.FlashingColour + "/Grey";
        else if (roof_sheet_data["FlashingColour"].includes("/")) {
            let reversed_colour =
                roof_sheet_data["FlashingColour"].split("/")[1].trim() +
                "/" +
                roof_sheet_data["FlashingColour"].split("/")[0].trim();
            if (valid_barge_colours.includes(reversed_colour)) roof_sheet_data["FlashingColour"] = reversed_colour;
        }
    }

    if (!roof_sheet_data.FlashingColourMatchString)
        roof_sheet_data.FlashingColourMatchString = roof_sheet_data.FlashingColour;
    roof_sheet_data.FlashingColour = roof_sheet_data.FlashingColourMatchString;

    if (roof_sheet_data.FlashingColourMatchString in colourMatch) {
        if (valid_barge_colours.includes(colourMatch[roof_sheet_data.FlashingColourMatchString])) {
            roof_sheet_data.FlashingColour = colourMatch[roof_sheet_data.FlashingColourMatchString];
        } else if (colourMatch[roof_sheet_data.FlashingColourMatchString].includes("/")) {
            let single_colour = colourMatch[roof_sheet_data.FlashingColourMatchString].split("/")[0];

            if (valid_barge_colours.includes(single_colour)) {
                roof_sheet_data.FlashingColour = single_colour;
            } else {
                single_colour = colourMatch[roof_sheet_data.FlashingColourMatchString].split("/")[1];
                if (valid_barge_colours.includes(single_colour)) {
                    roof_sheet_data.FlashingColour = single_colour;
                } else {
                    roof_sheet_data.FlashingColour = "TBA";
                }
            }
        } else {
            roof_sheet_data.FlashingColour = "TBA";
        }
    }

    colourMatch["Match Barge"] = roof_sheet_data.FlashingColour;

    // VALIDATE RIDGE COLOUR
    let valid_ridge_colours = config.colour_arrays?.["Colorbond Single & Double Sided"];
    if (design_option.ridge_colours)
        valid_ridge_colours = GetColourArray(design_option?.ridge_colours, config.colour_arrays);

    if (!valid_ridge_colours.includes(roof_sheet_data.RidgeColour)) {
        if (valid_ridge_colours.includes(roof_sheet_data.RidgeColour + "/Grey"))
            roof_sheet_data.RidgeColour = roof_sheet_data.RidgeColour + "/Grey";
        else if (roof_sheet_data["RidgeColour"].includes("/")) {
            let reversed_colour =
                roof_sheet_data["RidgeColour"].split("/")[1].trim() +
                "/" +
                roof_sheet_data["RidgeColour"].split("/")[0].trim();
            if (valid_ridge_colours.includes(reversed_colour)) roof_sheet_data["RidgeColour"] = reversed_colour;
        }
    }

    if (!roof_sheet_data.RidgeColourMatchString) roof_sheet_data.RidgeColourMatchString = roof_sheet_data.RidgeColour;
    roof_sheet_data.RidgeColour = roof_sheet_data.RidgeColourMatchString;

    const ridgeColourMatch = {
        "Match Roofsheet": roof_sheet_data.RoofSheetColour.split("/")[0],
        "Match Barge": roof_sheet_data.RoofSheetColour.split("/")[0],
    };

    if (roof_sheet_data.RidgeColourMatchString in ridgeColourMatch) {
        if (valid_ridge_colours.includes(ridgeColourMatch[roof_sheet_data.RidgeColourMatchString])) {
            roof_sheet_data.RidgeColour = ridgeColourMatch[roof_sheet_data.RidgeColourMatchString];
        } else if (ridgeColourMatch[roof_sheet_data.RidgeColourMatchString].includes("/")) {
            let single_colour = ridgeColourMatch[roof_sheet_data.RidgeColourMatchString].split("/")[0];
            if (valid_ridge_colours.includes(single_colour)) {
                roof_sheet_data.RidgeColour = single_colour;
            }
        } else {
            roof_sheet_data.RidgeColour = ridgeColourMatch[roof_sheet_data.RidgeColourMatchString];
        }
    }

    // ridges
    if (roof_sheet_data?.RoofGroupType !== "CUSTOM ORB") roof_sheet_data.RollTopRidge = false;
    if (
        roof_sheet_data.RollTopRidge &&
        design_option?.allow_roll_top_ridge &&
        design_option?.flashing_codes?.["Ridge Roll Top Flashing"]
    ) {
        roof_sheet_data.RidgeCappingCode = design_option?.flashing_codes?.["Ridge Roll Top Flashing"];
    } else if (
        this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.CollarTie &&
        design_option?.flashing_codes?.["Ridge with Collar Tie"]
    ) {
        roof_sheet_data.RidgeCappingCode = design_option?.flashing_codes?.["Ridge with Collar Tie"];
    } else {
        roof_sheet_data.RidgeCappingCode = "";
    }

    //valley code:
    if (window.LYSAGHT) {
        roof_sheet_data.ValleyFlashingCode = "";
    } else {
        roof_sheet_data.ValleyFlashingCode = "CFL19";
    }

    //Wall Flashing
    roof_sheet_data.WallFlashingCode = design_option?.flashing_codes?.["Wall Flashing"];

    // Gutter Kissing cap code
    roof_sheet_data.GutterCapCode = design_option?.flashing_codes?.["Gutter Cap for Kissing Gutters"];

    //append roofsheet basic data
    if (!roof_sheet_data.RoofSheetData) roof_sheet_data.RoofSheetData = {};

    roof_sheet_data.RoofSheetData.texture_filename = subType.texture_filename
        ? subType.texture_filename
        : roofsheetgroup.texture_filename;
    roof_sheet_data.RoofSheetData.bottomside_texture_filename = subType.bottomside_texture_filename
        ? subType.bottomside_texture_filename
        : roofsheetgroup.bottomside_texture_filename;

    roof_sheet_data.RoofSheetData.skylight_texture_filename = skylight_sheet.texture_filename
        ? skylight_sheet.texture_filename
        : roofsheetgroup.skylight_texture_filename;
    if (!roof_sheet_data.RoofSheetData.skylight_texture_filename)
        roof_sheet_data.RoofSheetData.skylight_texture_filename = roof_sheet_data.RoofSheetData.texture_filename;
    roof_sheet_data.RoofSheetData.min_pitch = Number(subType.min_pitch ? subType.min_pitch : roofsheetgroup.min_pitch);

    let max_overhang = roofsheetgroup.max_overhang;

    // Get max span based on span table and pressure table

    roof_sheet_data.MaxEndSheetSpan = 0;
    roof_sheet_data.MaxInternalSheetSpan = 0;

    // Start with adding max spans from span tables
    let max_internal_span = roofsheetgroup?.max_internal_span;
    let max_end_span = roofsheetgroup?.max_end_span;
    let backspan_ratio = 0.33;

    if (roofsheetgroup?.overhang_backspan_ratio) backspan_ratio = roofsheetgroup?.overhang_backspan_ratio;

    roof_sheet_data.RoofSheetData.roofsheet_display_name = subType?.name ? subType?.name : "";

    if (subType.max_overhang !== undefined) max_overhang = subType.max_overhang;
    if (subType.max_internal_span !== undefined) max_internal_span = subType.max_internal_span;
    if (subType.max_end_span !== undefined) max_end_span = subType.max_end_span;
    if (subType.spans) {
        if (subType.spans.MaxOverhang !== undefined) max_overhang = subType.spans.MaxOverhang;
        if (subType.spans.MaxInternalSpan !== undefined) max_internal_span = subType.spans.MaxInternalSpan;
        if (subType.spans.MaxEndSpan !== undefined) max_end_span = subType.spans.MaxEndSpan;

        let n_t_spans = subType.spans.non_trafficable;
        let wz_spans = subType.spans?.[job.SiteParameters.WindData.WindZone];

        if (n_t_spans && roof_sheet_data["RoofSpan"].includes("Non-Trafficable")) {
            if (n_t_spans.MaxOverhang !== undefined) max_overhang = n_t_spans.MaxOverhang;
            if (n_t_spans.MaxInternalSpan !== undefined) max_internal_span = n_t_spans.MaxInternalSpan;
            if (n_t_spans.MaxEndSpan !== undefined) max_end_span = n_t_spans.MaxEndSpan;
            wz_spans = n_t_spans?.[job.SiteParameters.WindData.WindZone];
        }

        if (wz_spans) {
            if (wz_spans?.MaxOverhang !== undefined) max_overhang = wz_spans?.MaxOverhang;
            if (wz_spans?.MaxInternalSpan !== undefined) max_internal_span = wz_spans?.MaxInternalSpan;
            if (wz_spans?.MaxEndSpan !== undefined) max_end_span = wz_spans?.MaxEndSpan;
            if (wz_spans?.["MaxOverhang_" + job.SiteParameters.WindData.Blocking + "Sides"] !== undefined)
                max_overhang = wz_spans?.["MaxOverhang_" + job.SiteParameters.WindData.Blocking + "Sides"];
            if (wz_spans?.["MaxInternalSpan_" + job.SiteParameters.WindData.Blocking + "Sides"] !== undefined)
                max_internal_span = wz_spans?.["MaxInternalSpan_" + job.SiteParameters.WindData.Blocking + "Sides"];
            if (wz_spans?.["MaxEndSpan_" + job.SiteParameters.WindData.Blocking + "Sides"] !== undefined)
                max_end_span = wz_spans?.["MaxEndSpan_" + job.SiteParameters.WindData.Blocking + "Sides"];
        }

        function processSpanTable(pressure_spans, pressure_spans_values, spanType, w) {
            // Check if spanType is valid and pressure_spans[spanType] exists
            const spanTable = pressure_spans?.[spanType];
            if (!spanTable || !Array.isArray(spanTable)) {
                return { pressureValue: 0, spanMm: 0 };
            }

            // Ensure that subType is defined and has pressure_spans with SpanValues
            const SpanValues = pressure_spans_values;
            if (!SpanValues || !Array.isArray(SpanValues)) {
                return { pressureValue: 0, spanMm: 0 };
            }

            let pressureValue = 99.99;
            let spanMm = 0;

            // Iterate over spanTable to find the appropriate pressureValue and spanMm
            for (let i = spanTable.length - 1; i >= 0; i--) {
                if (spanTable[i] >= Math.abs(w)) {
                    pressureValue = spanTable[i];
                    spanMm = SpanValues[i] * 1000;
                    break; // Exit the loop after finding the first matching value
                }
            }

            return { pressureValue, spanMm };
        }
        this_area.BEAMS_AND_POSTS.NumPurlins = -1;
        roof_sheet_data.RoofSheetData["SkylightSpanReductionFactor"] = null;

        if (this_area.META.HasInsulatedPanel && this_area.SKYLIGHTS && this_area.SKYLIGHTS.length > 0) {
            this_area.BEAMS_AND_POSTS.NumPurlins = 0;
            roof_sheet_data.RoofSheetData["PressureTableMaxSpanSingle"] = 0;
            roof_sheet_data.RoofSheetData["PressureTableMaxSpanDouble"] = 0;

            let indexes = [];

            for (let skylight of this_area.SKYLIGHTS) {
                if (skylight.Index != undefined) indexes.push(skylight.Index);
            }
            indexes.sort();

            let factor = 10;
            let last_index = -99999;
            for (let index of indexes) {
                if (index - last_index <= 2) {
                    factor = 25;
                    break;
                }
                last_index = index;
            }
            roof_sheet_data.RoofSheetData["SkylightSpanReductionFactor"] = factor;

            factor = factor / 100 + 1;
            max_end_span = Math.round(max_end_span / factor);
            max_internal_span = Math.round(max_internal_span / factor);
            roof_sheet_data.MaxEndSheetSpan = max_end_span;
            roof_sheet_data.MaxInternalSheetSpan = max_internal_span;
        }
        // If there are pressure spans for product, modify the max spans || Note: Only impacting Insulated Products for now.
        else if (
            subType?.pressure_spans &&
            job?.SiteParameters?.WindData?.WindZoneAS1170?.region &&
            job?.SiteParameters?.WindData?.WindZoneAS1170?.base_pressure
        ) {
            let windRegion = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
            if (windRegion.length > 1) windRegion = windRegion[0]; // Just get the first letter. i.e A1 = A.

            let AreaMaxResults = job.QuoteParameters?.ENGINEERING?.EngineeringResults?.AreaMaxResults?.[areaIndex];
            let is_multispan = AreaMaxResults?.NumPurlins > 0;

            let average_height = job?.DesignParameters?.AverageRoofHeight || this_area.SHAPE.Height;

            let wall_height = job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].WallHeight;
            let attachment_height = Math.max(wall_height, average_height) / 0.825;
            if (job.DesignParameters.Freestanding || attachment_height < 1000) {
                attachment_height = average_height;
            }

            wall_height = job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].WallHeight;
            attachment_height = Math.max(wall_height, average_height) / 0.825;
            if (job.DesignParameters.Freestanding || attachment_height < 1000) {
                attachment_height = average_height;
            }

            let wu_data = getWuUpDown(
                attachment_height,
                job.SiteParameters.WindData.WindZoneAS1170.base_pressure,
                job.DesignParameters.TotalLength,
                average_height,
                job.SiteParameters.WindData.WindZoneAS1170.blocking_factor
            );

            let wu = wu_data.UP; // TODO: Wind Down
            let wd = wu_data.DOWN; // TODO: Wind Down

            // Get pressure span table
            const pressure_spans = subType?.pressure_spans["Region " + windRegion];
            const pressure_spans_values = subType?.pressure_spans["SpanValues"];

            const { pressureValue: pressure_value_up, spanMm: up_span_mm } = processSpanTable(
                pressure_spans,
                pressure_spans_values,
                "Single Span Out",
                wu
            );
            const { pressureValue: pressure_value_up_double, spanMm: up_span_mm_double } = processSpanTable(
                pressure_spans,
                pressure_spans_values,
                "Double Span Out",
                wu
            );
            const { pressureValue: pressure_value_down, spanMm: down_span_mm } = processSpanTable(
                pressure_spans,
                pressure_spans_values,
                "Single Span In",
                wd
            );
            const { pressureValue: pressure_value_down_double, spanMm: down_span_mm_double } = processSpanTable(
                pressure_spans,
                pressure_spans_values,
                "Double Span In",
                wd
            );

            let max_span_pressure_table_result = 0;
            if (up_span_mm > 0 && down_span_mm > 0) {
                max_span_pressure_table_result = Math.min(up_span_mm, down_span_mm);
            }
            let max_span_pressure_table_double_result = 0;
            if (up_span_mm_double > 0 && down_span_mm_double > 0) {
                max_span_pressure_table_double_result = Math.min(up_span_mm_double, down_span_mm_double);
            }

            // Add Designed Boolean
            roof_sheet_data.RoofSheetData["PressureTableMaxSpanSingle"] = max_span_pressure_table_result;
            roof_sheet_data.RoofSheetData["PressureTableMaxSpanDouble"] = max_span_pressure_table_double_result;

            let pt_max_end_span = max_end_span;
            if (max_span_pressure_table_result > pt_max_end_span) pt_max_end_span = max_span_pressure_table_result;

            if (this_area.META.RoofSheetSpan > pt_max_end_span) {
                // is multi span;
                this_area.BEAMS_AND_POSTS.NumPurlins = 1;
                roof_sheet_data.RoofSheetData["InsulatedMultispan"] = true;
                roof_sheet_data.MaxEndSheetSpan = max_span_pressure_table_double_result;
                roof_sheet_data.MaxInternalSheetSpan = max_span_pressure_table_double_result;
                if (this_area.META.RoofSheetSpan > max_span_pressure_table_double_result * 2)
                    roof_sheet_data.RoofSheetData["InsulatedOverspan"] = true;
                else roof_sheet_data.RoofSheetData["InsulatedOverspan"] = false;
            } else {
                roof_sheet_data.RoofSheetData["InsulatedOverspan"] = false;
                roof_sheet_data.RoofSheetData["InsulatedMultispan"] = false;
                this_area.BEAMS_AND_POSTS.NumPurlins = 0;
                roof_sheet_data.MaxEndSheetSpan = pt_max_end_span;
                roof_sheet_data.MaxInternalSheetSpan = pt_max_end_span;
            }
        } else {
            this_area.BEAMS_AND_POSTS.NumPurlins = -1;
            roof_sheet_data.RoofSheetData["PressureTableMaxSpanSingle"] = 0;
            roof_sheet_data.RoofSheetData["PressureTableMaxSpanDouble"] = 0;
        }
    }

    if (this_area.SKYLIGHTS.length > 0 && this_area.ROOF_SHEETING.RoofType.includes("TL5") && window.FIELDERS) {
        let pLength =
            this_area.SHAPE.SheetDirection === "Front" || this_area.SHAPE.SheetDirection === "Back"
                ? this_area.SHAPE.Depth
                : this_area.SHAPE.Length;

        let min = parseInt(pLength / 950) - 1;
        this_area.BEAMS_AND_POSTS.NumPurlins = min + this_area.BEAMS_AND_POSTS.NumExtraPurlins;
    }

    let overhang_ratio = backspan_ratio / (1 + backspan_ratio);
    let is_flat = false;
    let is_pitched = false;
    let is_portal = false;

    if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) is_flat = true;
    if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) is_pitched = true;
    if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) is_portal = true;

    let max_overhang_based_on_width = 999999;
    let roof_span_width = this_area_data.SHAPE.Depth;

    if (is_flat) {
        if (this_area.SHAPE.SheetDirection === "Left" || this_area.SHAPE.SheetDirection === "Right") {
            roof_span_width = this_area_data.SHAPE.Length;
            if (
                this_area.SHAPE.OH_Front > 50 &&
                (this_area.SHAPE.OH_Back > 50) & !roof_sheet_data.RoofGroupType.toUpperCase().includes("BONDOR")
            )
                roof_span_width -= Math.max(this_area.SHAPE.OH_Front, this_area.SHAPE.OH_Back);
        } else {
            roof_span_width = this_area_data.SHAPE.Depth;
            if (
                this_area.SHAPE.OH_Front > 50 &&
                (this_area.SHAPE.OH_Back > 50) & !roof_sheet_data.RoofGroupType.toUpperCase().includes("BONDOR")
            )
                roof_span_width -= Math.max(this_area.SHAPE.OH_Front, this_area.SHAPE.OH_Back);
        }
    } else if (is_pitched) {
        roof_span_width = this_area_data.SHAPE.Length / 2;
    } else if (is_portal) {
        roof_span_width = this_area_data.SHAPE.Depth / 2;
    }

    if (is_pitched || is_portal) {
        let this_max_span = max_end_span;
        if (roof_sheet_data.MaxEndSheetSpan !== 0) this_max_span = roof_sheet_data.MaxEndSheetSpan;

        if (roofsheetgroup.gable_end_span_override && this_max_span > roofsheetgroup.gable_end_span_override) {
            max_end_span = roofsheetgroup.gable_end_span_override;
            roof_sheet_data.MaxEndSheetSpan = max_end_span; // override the sheet span in cad system
            roof_sheet_data.MaxEndSheetSpanOverride = max_end_span; // override the sheet span in cad system
        } else {
            roof_sheet_data.MaxEndSheetSpanOverride = null; // override the sheet span in cad system
        }

        this_max_span = max_internal_span;
        if (roof_sheet_data.MaxInternalSheetSpan !== 0) this_max_span = roof_sheet_data.MaxInternalSheetSpan;
        if (
            roofsheetgroup.gable_internal_span_override &&
            this_max_span > roofsheetgroup.gable_internal_span_override
        ) {
            max_internal_span = roofsheetgroup.gable_internal_span_override;
            roof_sheet_data.MaxInternalSheetSpan = max_internal_span; // override the sheet span in cad system
            roof_sheet_data.MaxInternalSheetSpanOverride = max_internal_span;
        } else {
            roof_sheet_data.MaxInternalSheetSpanOverride = 0;
        }
    } else if (!roof_sheet_data?.RoofSheetData?.PressureTableMaxSpanSingle) {
        roof_sheet_data.MaxEndSheetSpan = 0;
        roof_sheet_data.MaxEndSheetSpanOverride = null;
        roof_sheet_data.MaxInternalSheetSpan = 0;
    }

    max_overhang_based_on_width =
        (roof_span_width / Math.cos(DegreesToRadians(this_area_data.SHAPE.RoofPitch))) * overhang_ratio;

    roof_sheet_data.RoofSheetData.max_overhang = Math.trunc(Math.min(max_overhang, max_overhang_based_on_width));
    roof_sheet_data.RoofSheetData.max_overhang_xy = Math.trunc(
        roof_sheet_data.RoofSheetData.max_overhang * Math.cos(DegreesToRadians(this_area_data.SHAPE.RoofPitch))
    );
    roof_sheet_data.RoofSheetData.min_front_overhang =
        roofsheetgroup?.min_front_overhang !== undefined ? toNumber(roofsheetgroup?.min_front_overhang) : 0;
    roof_sheet_data.RoofSheetData.min_side_overhang =
        roofsheetgroup?.min_side_overhang !== undefined
            ? toNumber(roofsheetgroup?.min_side_overhang)
            : design_option?.overhang_right_range?.min
            ? design_option.overhang_right_range.min
            : 0;
    roof_sheet_data.RoofSheetData.max_side_overhang =
        roofsheetgroup?.max_side_overhang !== undefined
            ? toNumber(roofsheetgroup?.max_side_overhang)
            : design_option?.overhang_right_range?.max
            ? design_option.overhang_right_range.max
            : 0;

    roof_sheet_data.RoofSheetData.max_internal_span = max_internal_span;
    roof_sheet_data.RoofSheetData.max_end_span = max_end_span;

    const isSpecialRoofGroupType =
        roof_sheet_data.RoofGroupType.includes("Bondor") || roof_sheet_data.RoofGroupType.includes("Apollo");

    roof_sheet_data.RoofSheetData.max_frontback_end_span =
        is_flat || isSpecialRoofGroupType ? roof_sheet_data.RoofSheetData.max_overhang : 0; // Gable no overhang front or back

    // Enforce max
    const maxSpan = roof_sheet_data.RoofSheetData.max_frontback_end_span;
    if (this_area_data.SHAPE.OH_Front_Sheet > maxSpan) {
        this_area_data.SHAPE.OH_Front_Sheet = maxSpan;
    }
    if (this_area_data.SHAPE.OH_Back_Sheet > maxSpan) {
        this_area_data.SHAPE.OH_Back_Sheet = maxSpan;
    }

    roof_sheet_data.RoofSheetData.double_beam_hip_required = roofsheetgroup?.double_beam_hip_required ? true : false;
    roof_sheet_data.RoofSheetData.roofsheet_fan_bracket = roofsheetgroup?.fan_bracket
        ? roofsheetgroup?.fan_bracket
        : "";
    roof_sheet_data.RoofSheetData.downlight_code = roofsheetgroup?.downlight_code ? roofsheetgroup?.downlight_code : "";
    roof_sheet_data.RoofSheetData.insulated_panel = roofsheetgroup?.insulated_panel
        ? roofsheetgroup?.insulated_panel
        : false;

    roof_sheet_data.RoofSheetData.coverage = subType?.coverage
        ? Number(subType?.coverage)
        : roofsheetgroup?.coverage
        ? Number(roofsheetgroup?.coverage)
        : 760;
    roof_sheet_data.RoofSheetData.sheet_height = subType?.sheet_height
        ? Number(subType?.sheet_height)
        : roofsheetgroup?.sheet_height
        ? Number(roofsheetgroup?.sheet_height)
        : 45;

    roof_sheet_data.RoofSheetData.skylight_spacing = subType?.skylight_spacing
        ? subType?.skylight_spacing
        : roofsheetgroup?.skylight_spacing
        ? roofsheetgroup?.skylight_spacing
        : 0;
    roof_sheet_data.RoofSheetData.gutter_return_not_required =
        roofsheetgroup?.gutter_return_not_required !== undefined ? roofsheetgroup?.gutter_return_not_required : false;
    roof_sheet_data.RoofSheetData.single_span_only = subType?.single_span_only
        ? subType?.single_span_only
        : roofsheetgroup?.single_span_only
        ? roofsheetgroup?.single_span_only
        : false;
    roof_sheet_data.RoofSheetData.allow_cyclonic = subType?.allow_cyclonic
        ? subType?.allow_cyclonic
        : roofsheetgroup?.allow_cyclonic
        ? roofsheetgroup?.allow_cyclonic
        : false;
    roof_sheet_data.RoofSheetData.skylight_coverage = skylight_sheet?.coverage
        ? Number(skylight_sheet?.coverage)
        : roofsheetgroup?.skylight_coverage
        ? Number(roofsheetgroup?.skylight_coverage)
        : 0;

    // Set the skylight coverage to the cyclonic coverage if exists
    if (is_cyclonic && roofsheetgroup?.skylight_cyclonic_coverage != null) {
        roof_sheet_data.RoofSheetData.skylight_coverage = roofsheetgroup?.skylight_cyclonic_coverage;
    }

    roof_sheet_data.RoofSheetData.wall_fixing_spacing =
        roofsheetgroup?.wall_fixing_spacing != undefined ? roofsheetgroup?.wall_fixing_spacing : 600;

    if (!roofsheetgroup.skylights) {
    }

    if (roof_sheet_data.RoofSheetData.single_span_only && job.QuoteParameters?.ENGINEERING?.EngineeringResults) {
        let AreaMaxResults = job.QuoteParameters?.ENGINEERING?.EngineeringResults?.AreaMaxResults?.[areaIndex];

        if (is_flat && AreaMaxResults?.NumPurlins > 0) {
            AreaMaxResults.PurlinMax = 9.99;
            AreaMaxResults.MaxResult = 9.99;
        }
    }

    /// type 3 side purlin numbe force
    if (is_flat) {
        if (this_area.SHAPE.SheetDirection === "Left" || this_area.SHAPE.SheetDirection === "Right") {
            let max_end_span = roof_sheet_data.RoofSheetData.max_end_span;
            let max_span = roof_sheet_data.RoofSheetData.max_internal_span;
            let num_purlins = 2;
            if (this_area.META.RoofSheetSpan <= max_end_span) num_purlins = 2;
            else if (this_area.META.RoofSheetSpan <= 2 * max_end_span) num_purlins = 3;
            else
                num_purlins =
                    Math.trunc((this_area.META.RoofSheetSpan - 2 * max_end_span) / max_span + 0.999999) + 1 + 2;
            num_purlins = num_purlins + this_area.BEAMS_AND_POSTS.NumExtraPurlins;
            this_area.BEAMS_AND_POSTS.NumPurlins = num_purlins - 2;
        }
    }

    // downlights & fan brackets
    let allow_downlights = false;
    if (
        roof_sheet_data.RoofGroupType.toUpperCase().includes("BONDOR") ||
        roof_sheet_data.RoofGroupType.toUpperCase().includes("VERSICLAD") ||
        roof_sheet_data.RoofGroupType.toUpperCase().includes("APOLLO") ||
        roof_sheet_data.RoofSheetData.insulated_panel
    ) {
        allow_downlights = true;
    }

    // Add fan bracket
    if (roofsheetgroup?.fan_bracket && roofsheetgroup?.fan_bracket !== "") {
        roof_sheet_data.FanBracketSelection = roofsheetgroup.fan_bracket;
        roof_sheet_data.FanBrackets = 0; // no longer used, forced to 0
    }

    if (roofsheetgroup?.pitched_fascia_screw_flashing_code) {
        roof_sheet_data.PitchedFasciaScrewFlashingCode = roofsheetgroup.pitched_fascia_screw_flashing_code;
    } else {
        roof_sheet_data.PitchedFasciaScrewFlashingCode = "";
    }

    if (!allow_downlights || !design_option?.downlight_options) {
        roof_sheet_data.DownlightData = null;
    } else {
        let downlight_data = roof_sheet_data?.DownlightData;
        if (!downlight_data) downlight_data = {};

        // Update default downlight
        if (!downlight_data?.DownlightSelection) downlight_data.DownlightSelection = design_option?.downlight_default;

        // Set default downlight to next available downlight from downlight menu if default doesn't exist
        if (!design_option?.downlight_options.includes(downlight_data.DownlightSelection)) {
            downlight_data.DownlightSelection = "None";
        }

        // Update control type to automatic if not set
        if (!downlight_data?.ControlType) downlight_data.ControlType = "Automatic";

        if (downlight_data.DownlightSelection === "None") {
            downlight_data.Amount = 0;
        } else if (downlight_data?.ControlType === "Automatic" || !downlight_data.Amount) {
            // Update amount for design
            let width = this_area_data.SHAPE.Depth;
            let length = this_area_data.SHAPE.Length;

            width = width - 200;
            length = length - 200;

            let totalDownlights = length / 2000;

            if (totalDownlights < 1) totalDownlights = 1;
            if (width > 3000) totalDownlights *= 2;

            downlight_data.Amount = Math.floor(totalDownlights);
        }

        if (downlight_data.DownlightSelection !== "None") {
            if (roof_sheet_data.RoofGroupType.toUpperCase().includes("VERSICLAD")) {
                downlight_data.DownlightSelection = "DLKITV";
                downlight_data.DownlightColour = "Tri-Colour (Cool/Neutral/Warm)";
            } else if (roof_sheet_data.RoofGroupType.toUpperCase().includes("BONDOR")) {
                downlight_data.DownlightSelection = "DLKIT9W";
                let dl_bondor_colours = ["Cool White", "Warm White"];
                if (!dl_bondor_colours.includes(downlight_data.DownlightColour))
                    downlight_data.DownlightColour = dl_bondor_colours[0];
            }
        }

        roof_sheet_data.DownlightData = downlight_data;
    }

    return roof_sheet_data;
};

export const validateGutterDownpipeData = (config, job, areaIndex) => {
    let this_area_data = job.AreaSpecifications[areaIndex];
    let this_area_data_META = this_area_data?.META;
    let gutter_downpipe_data = { ...this_area_data[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES] };
    let gutter_types = config.gutter_types;
    let downpipe_types = config.downpipe_types;
    let design_option = config?.design_options?.[this_area_data.SHAPE.DesignType];

    let fascia_colour = this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamCol1;
    let edge_beam_colour = this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.BeamCol3;

    // Update job state with gutter and downpipe selections
    gutter_downpipe_data.GutterIsSelected =
        gutter_downpipe_data.GutterB === 1 ||
        gutter_downpipe_data.GutterF === 1 ||
        gutter_downpipe_data.GutterL === 1 ||
        gutter_downpipe_data.GutterR === 1;

    gutter_downpipe_data.DownpipeIsSelected =
        !!gutter_downpipe_data.Downpipes?.length || gutter_downpipe_data.AddAutomaticDownpipes === 1;

    // Update Obsolete References

    if (gutter_downpipe_data?.DownpipeType === "65mm Round Downpipe")
        gutter_downpipe_data.DownpipeType = "65mm Round PVC Downpipe";
    if (gutter_downpipe_data?.DownpipeType === "75mm Round Downpipe")
        gutter_downpipe_data.DownpipeType = "75mm Round PVC Downpipe";
    if (gutter_downpipe_data?.DownpipeType === "80mm Round Downpipe")
        gutter_downpipe_data.DownpipeType = "80mm Round PVC Downpipe";
    if (gutter_downpipe_data?.DownpipeType === "90mm Round Downpipe")
        gutter_downpipe_data.DownpipeType = "90mm Round PVC Downpipe";
    if (gutter_downpipe_data?.DownpipeType === "65mm Square Downpipe")
        gutter_downpipe_data.DownpipeType = "65mm x 65mm Square Downpipe";

    let this_downpipe = downpipe_types?.[gutter_downpipe_data.DownpipeType];
    if (!this_downpipe && design_option?.downpipe_default) {
        gutter_downpipe_data.DownpipeType = design_option?.downpipe_default;
        this_downpipe = downpipe_types?.[gutter_downpipe_data.DownpipeType];
    }

    if (design_option?.gutter_options && !design_option?.gutter_options.includes(gutter_downpipe_data.GutterType)) {
        gutter_downpipe_data.GutterType = design_option?.gutter_default;
    }

    if (!gutter_downpipe_data.GutterType) gutter_downpipe_data.GutterType = "";

    let this_gutter = gutter_types[gutter_downpipe_data.GutterType];
    if (!this_gutter && design_option?.gutter_default) {
        gutter_downpipe_data.GutterType = design_option?.gutter_default;
        this_gutter = gutter_types?.[gutter_downpipe_data.GutterType];
    }

    gutter_downpipe_data.EasyFixMitres = 0;
    gutter_downpipe_data.HandmadeMitres = 0; // coopted for special corners
    gutter_downpipe_data.GutterWithReturn = 0;
    gutter_downpipe_data.SlottedGutter = 0;

    let GutterReturnNotRequired =
        this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.gutter_return_not_required;

    if (gutter_downpipe_data.GutterType.includes("Return")) GutterReturnNotRequired = true;

    if (GutterReturnNotRequired) {
        gutter_downpipe_data.GutterReturnNotRequired = 1;
    } else {
        gutter_downpipe_data.GutterReturnNotRequired = "";
    }

    // gutter colours
    let gutter_colours = COMMON.GetColourArray(this_gutter?.colours, config.colour_arrays);
    if (!gutter_colours.includes(gutter_downpipe_data.GutterCol)) {
        gutter_downpipe_data["GutterColourSelectionMade"] = false;
        if (gutter_colours.length === 1) {
            gutter_downpipe_data["GutterColourSelectionMade"] = true;
            gutter_downpipe_data.GutterCol = gutter_colours[0];
        } else if (!gutter_colours.includes(gutter_downpipe_data.DownpipeCol)) gutter_downpipe_data.GutterCol = "TBA";
    } else if (gutter_downpipe_data.GutterCol !== "TBA") {
        gutter_downpipe_data.GutterColourSelectionMade = true;
    }

    let gutter_colour = gutter_downpipe_data.GutterCol;
    let colourMatch = {
        "Match Fascia": fascia_colour,
        "Match Gutter": gutter_colour,
        "Match Edge Beam": edge_beam_colour,
    };

    if (!gutter_downpipe_data.BoxGutterColourMatchBeam)
        gutter_downpipe_data.BoxGutterColourMatchBeam = gutter_downpipe_data.BoxGutterColour;

    gutter_downpipe_data.BoxGutterColour = gutter_downpipe_data.BoxGutterColourMatchBeam;
    if (gutter_downpipe_data.BoxGutterColourMatchBeam in colourMatch) {
        gutter_downpipe_data.BoxGutterColour = colourMatch[gutter_downpipe_data.BoxGutterColourMatchBeam];
    }

    // downpipe colours
    if (
        design_option?.downpipe_options &&
        !design_option?.downpipe_options.includes(gutter_downpipe_data.DownpipeType)
    ) {
        gutter_downpipe_data.DownpipeType = design_option?.downpipe_default;
    }

    let downpipe_colours = COMMON.GetColourArray(this_downpipe?.colours, config?.colour_arrays);
    if (!downpipe_colours.includes(gutter_downpipe_data.DownpipeCol)) {
        gutter_downpipe_data["DownpipeColourSelectionMade"] = false;
        if (downpipe_colours.length === 1) {
            gutter_downpipe_data["DownpipeColourSelectionMade"] = true;
            gutter_downpipe_data.DownpipeCol = downpipe_colours[0];
        } else if (!downpipe_colours.includes(gutter_downpipe_data.DownpipeCol))
            gutter_downpipe_data.DownpipeCol = "TBA";
    } else if (gutter_downpipe_data.DownpipeCol !== "TBA") {
        gutter_downpipe_data.DownpipeColourSelectionMade = true;
    }

    if (this_area_data_META) {
        if (this_area_data_META?.HasInsulatedPanel) gutter_downpipe_data.GutterVerticalAlign = 1;
        else gutter_downpipe_data.GutterVerticalAlign = 0;

        if (
            this_area_data_META.FrontState.AttachmentType?.includes("Fascia") &&
            this_area_data_META.FrontState.HasGutter &&
            !this_area_data_META.FrontState.IsWaterShed
        )
            gutter_downpipe_data.GutterF = 0;
        if (
            this_area_data_META.BackState.AttachmentType?.includes("Fascia") &&
            this_area_data_META.BackState.HasGutter &&
            !this_area_data_META.BackState.IsWaterShed
        )
            gutter_downpipe_data.GutterB = 0;
        if (
            this_area_data_META.LeftState.AttachmentType?.includes("Fascia") &&
            this_area_data_META.LeftState.HasGutter &&
            !this_area_data_META.LeftState.IsWaterShed
        )
            gutter_downpipe_data.GutterL = 0;
        if (
            this_area_data_META.RightState.AttachmentType?.includes("Fascia") &&
            this_area_data_META.RightState.HasGutter &&
            !this_area_data_META.RightState.IsWaterShed
        )
            gutter_downpipe_data.GutterR = 0;
    }

    if (gutter_downpipe_data.BoxGutterWidth > 230) gutter_downpipe_data.BoxGutterWidth = 260;
    else if (gutter_downpipe_data.BoxGutterWidth > 200 && gutter_downpipe_data.BoxGutterWidth < 230)
        gutter_downpipe_data.BoxGutterWidth = 230;
    else if (gutter_downpipe_data.BoxGutterWidth < 200) gutter_downpipe_data.BoxGutterWidth = 200;

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
        gutter_downpipe_data.GutterCol = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        gutter_downpipe_data.BoxGutterColour = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        gutter_downpipe_data.GutterColourSelectionMade = true;
        gutter_downpipe_data.GutterColourSelected = true;
    }

    return gutter_downpipe_data;
};

export const validateAreaAttachmentData = (config, job, areaIndex, in_adjusted_length = null) => {
    let last_area_data = job.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job.AreaSpecifications[areaIndex];
    let next_area_data = job.AreaSpecifications?.[areaIndex + 1];
    if (job.DesignParameters.LoopAreas) {
        if (areaIndex === 0) {
            last_area_data = job.AreaSpecifications?.[job.AreaSpecifications.length - 1];
        }
        if (areaIndex === job.AreaSpecifications.length - 1) {
            next_area_data = job.AreaSpecifications?.[0];
        }
    }

    let ATTACHMENT_TYPES = config.attachment_types;

    let rafter_bracket_codes = ATTACHMENT_TYPES["Rafter Brackets supporting Beam"].bracket_type_code;
    let wall_bracket_codes = ATTACHMENT_TYPES["Wall with Offset Brackets Supporting Gutter and Beam"].bracket_type_code;

    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    let attachment_data = { ...this_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS] };

    let is_flat = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT;
    let is_deck = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.DECK;
    let is_gable = this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL;

    // add attachment mods for each side if attached
    if (!is_deck) {
        if (
            !attachment_data?.AttachmentModifications ||
            (attachment_data?.AttachmentModifications && attachment_data?.AttachmentModifications.constructor !== Array)
        ) {
            attachment_data.AttachmentModifications = [];
        }
        let sides = ["AttachmentLeft", "AttachmentRight", "AttachmentTop", "AttachmentBottom"];

        for (let side of sides) {
            if (attachment_data[side]) {
                let ref = "Back 1";
                if (side == "AttachmentLeft") ref = "Left 1";
                if (side == "AttachmentRight") ref = "Right 1";
                if (side == "AttachmentBottom") ref = "Front 1";
                let filtered_mods = attachment_data.AttachmentModifications.filter(function (a) {
                    return a?.Ref === ref || a?.Ref === ref.replace("1", "2");
                });

                if (filtered_mods.length === 0) {
                    //need to add one
                    let area_default_fascia = this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType;
                    let attachment_type = "Fascia with Receiver Channel";
                    let variation = "Timber Fascia";
                    if (area_default_fascia === "Beam") {
                        attachment_type = "Rafter Brackets supporting Beam";
                        variation = "Gutter";
                    }

                    let mod = {
                        Ref: ref,
                        Name: ref,
                        HasFasciaType: 1,
                        HasEaveWidth: 1,
                        EaveWidth: 600,
                        AttachmentType: attachment_type,
                        AttachmentVariation: variation,
                        FasciaType: area_default_fascia,
                    };
                    attachment_data.AttachmentModifications.push(mod);
                }
            }
        }
    }

    if (attachment_data?.AttachmentModifications && attachment_data?.AttachmentModifications.constructor == Array) {
        for (let data_mods of attachment_data?.AttachmentModifications) {
            if (window.LYSAGHT && !job.DesignParameters.USE_ATTACHMENTS_2) {
                data_mods.HasBracketType = 0;
                data_mods.BracketType = "";
                data_mods.BracketSpacing = 0;
                if (data_mods.AttachmentType === "Wall") {
                    if (data_mods.AttachmentSubType === "Timber Wall") {
                        data_mods.HasBracketType = 1;
                        data_mods.HasBracketSpacing = 1;
                        data_mods.BracketType = "R/C w/ Coach Screws";
                        data_mods.BracketTypeCode = "CS7510G";
                        data_mods.BracketSpacing = 600;
                    } else if (data_mods.AttachmentSubType === "Timber Wall On Beam") {
                        data_mods.HasBracketType = 1;
                        data_mods.HasBracketSpacing = 1;
                        data_mods.BracketType = "R/C on Beam w/ Coach Screws";
                        data_mods.BracketTypeCode = "CS7510G";
                        data_mods.BracketSpacing = 600;
                    } else if (data_mods.AttachmentSubType === "Masonry Wall") {
                        data_mods.HasBracketType = 1;
                        data_mods.HasBracketSpacing = 1;
                        data_mods.BracketType = "R/C w/ Masonry Anchors";
                        data_mods.BracketTypeCode = "SA7510G";
                        data_mods.BracketSpacing = 600;
                    } else if (data_mods.AttachmentSubType === "Masonry Wall On Beam") {
                        data_mods.HasBracketType = 1;
                        data_mods.HasBracketSpacing = 1;
                        data_mods.BracketType = "R/C on Beam w/ Masonry Anchors";
                        data_mods.BracketTypeCode = "SA7510G";
                        data_mods.BracketSpacing = 600;
                    }

                    data_mods.WallOnly = 1;
                }
                if (data_mods.AttachmentType === "Timber Fascia Drop") {
                    data_mods.HasBracketType = 1;
                    data_mods.HasBracketSpacing = 1;
                    data_mods.BracketType = "CON110";
                    data_mods.BracketTypeCode = "CON110";
                    data_mods.BracketSpacing = job?.SiteParameters?.ExistingStructure?.RoofType === "Tile" ? 600 : 900;
                }
                if (data_mods.AttachmentType === "Metal Fascia Drop") {
                    data_mods.HasBracketType = 1;
                    data_mods.HasBracketSpacing = 1;
                    data_mods.BracketType = "CON110";
                    data_mods.BracketTypeCode = "CON110";
                    data_mods.BracketSpacing = job?.SiteParameters?.ExistingStructure?.RoofType === "Tile" ? 600 : 900;
                }
            } else {
                data_mods.HasBracketType = 0;
                data_mods.BracketType = "";
                data_mods.BracketSpacing = 0;
            }

            if (job.DesignParameters.USE_ATTACHMENTS_2) {
                let schema = null;

                let attachment_beam = this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1;
                if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                    attachment_beam = this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3;
                } else if (data_mods?.RoofAlignment && data_mods?.RoofAlignment.includes("Side")) {
                    attachment_beam = this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3;
                }

                let is_active_atttachment = false;
                if (data_mods.Ref.includes("Back") && this_area_data.META.BackState.HasAttachment) {
                    is_active_atttachment = true;
                }
                if (data_mods.Ref.includes("Left") && this_area_data.META.LeftState.HasAttachment) {
                    is_active_atttachment = true;
                }
                if (data_mods.Ref.includes("Right") && this_area_data.META.RightState.HasAttachment) {
                    is_active_atttachment = true;
                }
                if (data_mods.Ref.includes("Front") && this_area_data.META.FrontState.HasAttachment) {
                    is_active_atttachment = true;
                }

                if (
                    is_flat &&
                    data_mods.Ref.includes(this_area_data.SHAPE.SheetDirection + " ") &&
                    data_mods.FasciaType.includes("Fascia")
                ) {
                    data_mods.AttachmentType = "Rafter Brackets supporting Beam";
                    data_mods.FasciaType = "Beam";
                    data_mods.HasBeam = 1;
                }

                if (is_gable && data_mods.FasciaType.includes("Fascia")) {
                    data_mods.AttachmentType = "Rafter Brackets supporting Beam";
                    data_mods.FasciaType = "Beam";
                    data_mods.HasBeam = 1;
                }

                if (is_deck) {
                    this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType = "Wall";
                    data_mods.AttachmentType = "Wall";
                    data_mods.FasciaType = "Wall";
                    schema = ATTACHMENT_TYPES[data_mods.AttachmentType];
                    if (data_mods?.AttachmentVariation && schema?.variations?.[data_mods.AttachmentVariation]) {
                        schema = { ...schema, ...schema.variations[data_mods.AttachmentVariation] };
                    } else {
                        data_mods.AttachmentVariation = "Masonry Wall With Beam";
                        if (data_mods?.AttachmentVariation && schema?.variations?.[data_mods.AttachmentVariation]) {
                            schema = { ...schema, ...schema.variations[data_mods.AttachmentVariation] };
                        }
                    }
                    data_mods.HasBeam = schema?.has_beam ? 1 : 0;
                    data_mods.WallType = schema?.wall_type ? schema.wall_type : "";
                    data_mods.WallOnly = schema?.wall_only ? 1 : 0;

                    data_mods.BracketType = schema?.bracket_type_desc ? schema.bracket_type_desc : "";
                    data_mods.HasBracketType = 0;

                    data_mods.RafterBracketTypeCode = "";
                    data_mods.WallBracketTypeCode = "";
                    data_mods.AttachmentBeamType = attachment_beam;
                    data_mods.WallType = schema?.wall_type ? schema?.wall_type : "Brick";
                } else {
                    if (ATTACHMENT_TYPES[data_mods.AttachmentType]) {
                        schema = ATTACHMENT_TYPES[data_mods.AttachmentType];
                        if (data_mods?.AttachmentVariation && schema?.variations?.[data_mods.AttachmentVariation]) {
                            schema = { ...schema, ...schema.variations[data_mods.AttachmentVariation] };
                            if (is_gable && data_mods.AttachmentVariation === "Gutter") {
                                schema.height_offset_max = "Beam_Height-50";
                                schema.height_offset_min = "Beam_Height-50";
                                schema.height_offset_editable_side = false;
                            }
                        }
                        data_mods.HasBeam = schema.has_beam ? 1 : 0;
                        data_mods.WallType = schema.wall_type ? schema.wall_type : "";
                        data_mods.WallOnly = schema.wall_only ? 1 : 0;
                        if (schema?.old_key) data_mods.FasciaType = schema.old_key;

                        if (schema?.old_key == "Wall" && schema.has_beam) {
                            if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
                                attachment_beam = this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType3; // attached to edge beam
                            } else {
                                attachment_beam = this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1; // in this case the added beam is the same a fascia beam, not rafter;
                            }
                            // Function to normalize rafterBeam by stripping everything after 'M' if present
                            function normalizeBeam(beam) {
                                return beam?.split("M")[0]; // Split on 'M' and take the part before it
                            }
                            attachment_beam = normalizeBeam(attachment_beam);
                        }

                        if (schema.has_gutter) {
                            if (is_active_atttachment) {
                                if (
                                    data_mods.Ref.includes("Back") &&
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterB === 0
                                )
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterB = 1;
                                if (
                                    data_mods.Ref.includes("Left") &&
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterL === 0
                                )
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterL = 1;
                                if (
                                    data_mods.Ref.includes("Right") &&
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterR === 0
                                )
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterR = 1;
                                if (
                                    data_mods.Ref.includes("Front") &&
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterF === 0
                                )
                                    this_area_data.GUTTERS_AND_DOWNPIPES.GutterF = 1;
                            }
                            data_mods.gutter = 1;
                        } else if (schema.has_gutter === false) {
                            if (is_active_atttachment) {
                                if (data_mods.Ref.includes("Back")) this_area_data.GUTTERS_AND_DOWNPIPES.GutterB = 0;
                                if (data_mods.Ref.includes("Left")) this_area_data.GUTTERS_AND_DOWNPIPES.GutterL = 0;
                                if (data_mods.Ref.includes("Right")) this_area_data.GUTTERS_AND_DOWNPIPES.GutterR = 0;
                                if (data_mods.Ref.includes("Front")) this_area_data.GUTTERS_AND_DOWNPIPES.GutterF = 0;
                            }
                            data_mods.gutter = 0;
                        } else {
                            data_mods.gutter = 0;
                        }

                        if (schema.has_beam && data_mods.AttachmentType.includes("Offset") && is_active_atttachment) {
                            if (data_mods.Ref.includes("Left")) this_area_data.BEAMS_AND_POSTS.OmitLeftBeam = 0;
                            if (data_mods.Ref.includes("Right")) this_area_data.BEAMS_AND_POSTS.OmitRightBeam = 0;
                        }

                        if (schema.bracket_type_code) {
                            let bracket = schema.bracket_type_code?.default;

                            if (schema.bracket_type_code?.[attachment_beam])
                                bracket = schema.bracket_type_code?.[attachment_beam];

                            if (region === "C" || region === "D") {
                                if (schema.bracket_type_code?.cyclonic) bracket = schema.bracket_type_code?.cyclonic;
                                if (schema.bracket_type_code?.[attachment_beam + "_cyclonic"])
                                    bracket = schema.bracket_type_code?.[attachment_beam + "_cyclonic"];
                            }

                            if (bracket) {
                                data_mods.BracketType = schema.bracket_type_desc ? schema.bracket_type_desc : "";
                                data_mods.BracketTypeCode = bracket;
                                data_mods.BracketSpacing =
                                    job?.SiteParameters?.ExistingStructure?.RoofType === "Tile"
                                        ? schema.bracket_spacing_tile
                                        : schema.bracket_spacing_sheet;
                                if (data_mods.BracketSpacing === "FlyoverBracketSpacing")
                                    data_mods.BracketSpacing = job.SiteParameters.FlyoverBracketSpacing;
                                data_mods.HasBracketType = 1;
                                data_mods.HasBracketSpacing = 1;
                                data_mods.SchemaBracketTypeCode = JSON.stringify(schema.bracket_type_code);
                            } else {
                                data_mods.HasBracketType = 0;
                                data_mods.HasBracketSpacing = 0;
                                data_mods.BracketTypeCode = "";
                                data_mods.SchemaBracketTypeCode = "";
                            }
                        } else {
                            data_mods.HasBracketSpacing = 0;
                            data_mods.BracketTypeCode = "";
                        }

                        data_mods.BracketType = schema.bracket_type_desc ? schema.bracket_type_desc : "";
                        data_mods.HasBracketType = data_mods.BracketType ? 1 : 0;

                        let rafter_bracket_code = rafter_bracket_codes?.default;
                        if (rafter_bracket_codes[attachment_beam])
                            rafter_bracket_code = rafter_bracket_codes[attachment_beam];
                        data_mods.RafterBracketTypeCode = rafter_bracket_code;

                        let wall_bracket_code = wall_bracket_codes?.default;
                        if (wall_bracket_codes[attachment_beam])
                            wall_bracket_code = wall_bracket_codes[attachment_beam];
                        data_mods.WallBracketTypeCode = wall_bracket_code;
                        data_mods.AttachmentBeamType = attachment_beam;
                        let default_wall = job.SiteParameters.ExistingStructure.WallType;
                        if (!default_wall || default_wall == "Blank") {
                            default_wall = "Timber";
                            if (
                                job.SiteParameters.ExistingStructure.FrameType.includes("Brick") ||
                                job.SiteParameters.ExistingStructure.FrameType.includes("Masonry")
                            ) {
                                default_wall = "Brick";
                            }
                        }

                        data_mods.WallType = schema?.wall_type ? schema?.wall_type : default_wall;

                        if (schema?.old_key && !schema?.old_key.includes("Beam")) {
                            data_mods.RafterBracketTypeCode = data_mods.BracketTypeCode;
                            data_mods.WallBracketTypeCode = data_mods.BracketTypeCode;
                        }

                        if (schema.wall_thickness)
                            data_mods.CladdingWidth =
                                job.SiteParameters[SITE_PARAMETER_SECTIONS.ExistingStructure].CladdingWidth;
                    }

                    if (
                        data_mods?.FasciaType === "Wall" &&
                        this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.wall_fixing_spacing
                    ) {
                        data_mods.BracketType = data_mods.BracketType.replaceAll(
                            "600 cts",
                            this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.wall_fixing_spacing +
                                "cts"
                        );
                    }

                    if (data_mods.WallOnly) {
                        data_mods.EaveWidth = 0;
                        data_mods.HasEaveWidth = 1;
                    } else {
                        data_mods.EaveWidth = toNumber(data_mods.EaveWidth);
                        data_mods.HasEaveWidth = 1;
                    }
                    if (data_mods.vOffset !== undefined) {
                        let area_height = this_area_data.SHAPE.Height;
                        let roof_sheet_data = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetData;
                        let roof_sheet_height = roof_sheet_data.sheet_height;
                        let eaveWidth = data_mods.HasEaveWidth
                            ? data_mods.EaveWidth
                            : job.SiteParameters.ExistingStructure.EaveDepth;

                        let beam_height = GetBeamHeight(attachment_beam);

                        let roof_alignment = getRoofAlignmentFromRef(data_mods.Ref, this_area_data);

                        let offsets = getOffsets(
                            schema,
                            beam_height,
                            roof_sheet_height,
                            eaveWidth,
                            roof_alignment,
                            data_mods.vOffset,
                            data_mods.hOffset
                        );
                        offsets = adjustOffsetForSide(data_mods.Ref, offsets, roof_alignment, this_area_data);

                        let wall_height = area_height;

                        if (
                            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
                            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
                        ) {
                            wall_height = area_height + 100 - offsets.v;
                        } else {
                            let up_fascia = job.SiteParameters?.ExistingStructure?.FasciaHeight
                                ? job.SiteParameters?.ExistingStructure?.FasciaHeight - 110
                                : 75;

                            wall_height = area_height - offsets.v - up_fascia - roof_sheet_height;

                            if (data_mods.WallOnly) {
                                wall_height = area_height - offsets.v - roof_sheet_height;
                            }
                        }

                        data_mods.WallHeight = isNaN(wall_height) ? "" : Number(wall_height);
                        data_mods.HasWallHeight = isNaN(wall_height) ? 0 : 1;

                        if (is_active_atttachment) {
                            if (data_mods.FasciaType.includes("Flyover")) {
                                this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_FasciaType = "Flyover";

                                if (
                                    wall_height <
                                    this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight
                                ) {
                                    this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight =
                                        wall_height;
                                }
                            } else {
                                if (
                                    wall_height <
                                    this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight
                                ) {
                                    this_area_data[BASIC_SPECS_SECTIONS.EXISTING_STRUCTURE].SITE_WallHeight =
                                        wall_height;
                                }
                            }
                        }
                        if (data_mods.FasciaType.includes("Not Attached")) {
                            data_mods.AttachmentHOffset = data_mods.hOffset;
                        } else {
                            data_mods.AttachmentHOffset = 0;
                        }
                    }
                }
            }
        }
    }
    return attachment_data;
};

export const ReplaceObsoleteReferences = (value_to_validate) => {
    if (value_to_validate === "656508") return "656510";
    if (value_to_validate === "F10015") return "FL10015";
    if (value_to_validate === "F15015") return "FL15015";
    if (value_to_validate === "F20015") return "FL20015";
    return value_to_validate;
};

export const validateRHSPostFooting = (config, job, areaIndex) => {
    const jobColumns = job?.QuoteParameters?.ENGINEERING?.EngineeringResults?.ProcessedLoadData?.Cols;
    const jobAreaData = job?.AreaSpecifications[areaIndex];
    const configPostTypes = config?.post_types;
    const defaultFooting = jobAreaData[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.FootingType;

    // Get all RHS posts available for selection from the config object
    let configRHSPosts = [];
    for (const post in configPostTypes) {
        if (configPostTypes.hasOwnProperty(post)) {
            const element = configPostTypes[post];
            if (element["Product Code"] && element["Product Code"].includes("RHS")) {
                configRHSPosts.push(post);
            }
        }
    }

    // Search engineering for RHS columns with anything other than a 'concrete in slab' footing. These are invalid
    let invalidFootings = [];
    if (jobColumns != null) {
        for (const [key, value] of Object.entries(jobColumns)) {
            if (configRHSPosts.includes(value.ColumnType) && value.GroundConnection !== "Concrete In") {
                invalidFootings.push({
                    ...value,
                    isDefault: value.GroundConnection === defaultFooting,
                });
            }
        }
    }

    return invalidFootings;
};

export const validateRHSBeamLength = (config, job, areaIndex, newBeamSelection = null) => {
    const jobAreaData = job?.AreaSpecifications[areaIndex];
    const designType = jobAreaData?.SHAPE?.DesignType;
    const hasRidgeBeam = jobAreaData?.BEAMS_AND_POSTS?.HasRidgeBeam === 1;
    const jobBeams = job?.QuoteParameters?.ENGINEERING?.EngineeringResults?.ProcessedLoadData?.Beams;
    const areaConfig = config?.design_options[designType];

    const maxLengthRHS = 8000;
    const rhs = "Box with RHS Insert";

    const configRHSBeamType1 = areaConfig?.beam_1?.options[rhs];
    const configRHSBeamType2 = hasRidgeBeam ? areaConfig?.beam_2_inset?.options[rhs] : areaConfig?.beam_2?.options[rhs];
    const configRHSBeamType3 = areaConfig?.beam_3?.options[rhs];
    const configRHSBeamType4 = areaConfig?.beam_4?.options[rhs];

    let resultSet = new Set();

    if (!jobBeams) return resultSet;

    // Search engineering results for beams over the RHS limit
    const longBeams = Object.values(jobBeams).reduce((acc, { Name, BeamType, Length }) => {
        if (Length > maxLengthRHS) {
            const cleanedName = Name.replace(/[0-9]/g, "");
            const entry = { Name: cleanedName, BeamType, BeamTypeID: 0 };
            acc.push(entry);
        }
        return acc;
    }, []);

    for (let i = longBeams.length - 1; i >= 0; i--) {
        // Determine the beam type ID (1, 2, 3 or 4)
        switch (designType) {
            case CONFIG.DESIGN_TYPES.FLAT:
                if (longBeams[i].Name === "FB") {
                    longBeams[i].BeamTypeID = 1;
                } else if (longBeams[i].Name === "P") {
                    longBeams[i].BeamTypeID = 2;
                } else if (longBeams[i].Name === "R") {
                    longBeams[i].BeamTypeID = 3;
                }
                break;
            case CONFIG.DESIGN_TYPES.PITCHED:
                if (longBeams[i].Name === "PR" || longBeams[i].Name === "FP") {
                    longBeams[i].BeamTypeID = 1;
                } else if (longBeams[i].Name === "P") {
                    longBeams[i].BeamTypeID = 2;
                } else if (longBeams[i].Name === "CB" || longBeams[i].Name === "FB") {
                    longBeams[i].BeamTypeID = 3;
                } else if (longBeams[i].Name === "PB") {
                    longBeams[i].BeamTypeID = 4;
                }
                break;
            case CONFIG.DESIGN_TYPES.GABLE_PORTAL:
                if (longBeams[i].Name === "PR" || longBeams[i].Name === "HB" || longBeams[i].Name === "PO") {
                    longBeams[i].BeamTypeID = 1;
                } else if (longBeams[i].Name === "P" || longBeams[i].Name === "DG" || longBeams[i].Name === "JR") {
                    longBeams[i].BeamTypeID = 2;
                } else if (longBeams[i].Name === "EB") {
                    longBeams[i].BeamTypeID = 3;
                } else if (longBeams[i].Name === "HR") {
                    longBeams[i].BeamTypeID = 4;
                }
                break;
        }

        const beam = newBeamSelection ? newBeamSelection : longBeams[i].BeamType;

        // Add to set if long beam is also RHS
        if (longBeams[i].BeamTypeID != 0) {
            if (longBeams[i].BeamTypeID === 1 && configRHSBeamType1?.includes(beam)) {
                resultSet.add("BeamType1");
            } else if (longBeams[i].BeamTypeID === 2 && configRHSBeamType2?.includes(beam)) {
                resultSet.add("BeamType2");
            } else if (longBeams[i].BeamTypeID === 3 && configRHSBeamType3?.includes(beam)) {
                resultSet.add("BeamType3");
            } else if (longBeams[i].BeamTypeID === 4 && configRHSBeamType4?.includes(beam)) {
                resultSet.add("BeamType4");
            }
        }
    }

    return resultSet;
};

export const validateBeamPostData = (config, job, areaIndex, in_adjusted_length = null) => {
    let last_area_data = job?.AreaSpecifications?.[areaIndex - 1];
    let this_area_data = job?.AreaSpecifications?.[areaIndex];
    let next_area_data = job?.AreaSpecifications?.[areaIndex + 1];
    if (job.DesignParameters.LoopAreas) {
        if (areaIndex === 0) {
            last_area_data = job.AreaSpecifications?.[job.AreaSpecifications.length - 1];
        }
        if (areaIndex === job.AreaSpecifications.length - 1) {
            next_area_data = job.AreaSpecifications?.[0];
        }
    }

    let area1_post_colour = job.AreaSpecifications[0][BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostCol;
    let beam_and_post_data = { ...this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS] };

    const post_types = config.post_types;
    const BeamPostParameters = this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS];
    const designTemplate = this_area_data?.SHAPE?.DesignTemplateType ?? null; // e.g. National Carport
    const designTemplateName = this_area_data?.SHAPE?.DesignTemplateName ?? null; // e.g. Double Cyclonic Colorbond
    const fixedDesignConfig =
        designTemplate && designTemplateName
            ? config?.design_options?.[designTemplate]?.design_templates?.[designTemplateName]?.[
                  BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS
              ]
            : undefined;

    // Obsolete Name REferences
    beam_and_post_data.BeamType1 = ReplaceObsoleteReferences(beam_and_post_data.BeamType1);
    beam_and_post_data.BeamType2 = ReplaceObsoleteReferences(beam_and_post_data.BeamType2);
    beam_and_post_data.BeamType3 = ReplaceObsoleteReferences(beam_and_post_data.BeamType3);
    beam_and_post_data.BeamType4 = ReplaceObsoleteReferences(beam_and_post_data.BeamType4);
    beam_and_post_data.PostType = ReplaceObsoleteReferences(beam_and_post_data.PostType);

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
        const length = job?.QuoteParameters?.AREA_DATA?.[areaIndex]?.ActualStructureLength;
        if (length && length > 1000) beam_and_post_data.AdjustedLength = length;
    }

    if (
        (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) &&
        job.DesignParameters.Freestanding
    ) {
        if (
            !this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType.includes("P/C") &&
            !this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType.includes("SHS")
        ) {
            beam_and_post_data.PostType = "65mm x 65mm x 3mm P/C";
        }
        beam_and_post_data.FootingType = "Concrete In";
    }

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
        beam_and_post_data.BeamCol1 = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.BeamColMatchBeam = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.BeamCol2 = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.BeamCol2MatchBeam = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.BeamCol3 = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.BeamCol3MatchBeam = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.PostCol = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;
        beam_and_post_data.PostColMatchBeam = this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour;

        beam_and_post_data.BeamType1 = "Alspec WideSpan 250";
        if (this_area_data.SHAPE.Length > 6000) {
            beam_and_post_data.BeamType1 = "Alspec Widespan 250 with Insert";
        }
    }

    in_adjusted_length = in_adjusted_length ? in_adjusted_length : AdjustedLengthForMultipleAreas(job, areaIndex);

    let colourMatch = {
        "Match Area 1 Post": area1_post_colour,
    };

    if (!beam_and_post_data.PostColMatchBeam) beam_and_post_data.PostColMatchBeam = beam_and_post_data.PostCol;
    beam_and_post_data.PostCol = beam_and_post_data.PostColMatchBeam;
    if (beam_and_post_data.PostColMatchBeam in colourMatch) {
        beam_and_post_data.PostCol = colourMatch[beam_and_post_data.PostColMatchBeam];
    }

    beam_and_post_data.HipJackRafter1 = beam_and_post_data?.JackRafters ? 1 : 0;
    beam_and_post_data.HipJackRafter2 = beam_and_post_data?.JackRafters ? 1 : 0;

    if (beam_and_post_data.PostCol === "TBA") beam_and_post_data.PostColourSelectionMade = false;
    else beam_and_post_data.PostColourSelectionMade = true;

    // Check if colour is applicable to design before adding , else change colour back to TBA
    const beam = config?.design_options?.[designTemplate || this_area_data.SHAPE.DesignType]?.beam_1;
    let colours = GetColourArray(
        areaIndex > 0 ? ["Match Area 1 Post", beam?.colours] : [beam?.colours],
        config.colour_arrays
    );

    // If post colour is in beam 1 colour list then colour match , else set to TBA
    if (colours.includes(beam_and_post_data.PostCol)) colourMatch["Match Post"] = beam_and_post_data.PostCol;
    else if (beam_and_post_data.PostCol === "Galvanised" && colours.includes("Zincalume"))
        colourMatch["Match Post"] = "Zincalume";
    else colourMatch["Match Post"] = "TBA";

    if (!beam_and_post_data.BeamColMatchBeam) beam_and_post_data.BeamColMatchBeam = beam_and_post_data.BeamCol1;
    beam_and_post_data.BeamCol1 = beam_and_post_data.BeamColMatchBeam;
    if (beam_and_post_data.BeamColMatchBeam in colourMatch) {
        beam_and_post_data.BeamCol1 = colourMatch[beam_and_post_data.BeamColMatchBeam];
    }

    if (!beam_and_post_data.BeamCol2MatchBeam) beam_and_post_data.BeamCol2MatchBeam = beam_and_post_data.BeamCol2;
    beam_and_post_data.BeamCol2 = beam_and_post_data.BeamCol2MatchBeam;
    if (beam_and_post_data.BeamCol2MatchBeam in colourMatch) {
        beam_and_post_data.BeamCol2 = colourMatch[beam_and_post_data.BeamCol2MatchBeam];
    }

    if (!beam_and_post_data.BeamCol3MatchBeam) beam_and_post_data.BeamCol3MatchBeam = beam_and_post_data.BeamCol3;
    beam_and_post_data.BeamCol3 = beam_and_post_data.BeamCol3MatchBeam;
    if (beam_and_post_data.BeamCol3MatchBeam in colourMatch) {
        beam_and_post_data.BeamCol3 = colourMatch[beam_and_post_data.BeamCol3MatchBeam];
    }

    if (!beam_and_post_data.BeamCol4MatchBeam) beam_and_post_data.BeamCol4MatchBeam = beam_and_post_data.BeamCol4;
    beam_and_post_data.BeamCol4 = beam_and_post_data.BeamCol4MatchBeam;
    if (beam_and_post_data.BeamCol4MatchBeam in colourMatch) {
        beam_and_post_data.BeamCol4 = colourMatch[beam_and_post_data.BeamCol4MatchBeam];
    }

    if (!beam_and_post_data.PostColMatchBeam) beam_and_post_data.PostColMatchBeam = beam_and_post_data.PostCol;
    beam_and_post_data.PostCol = beam_and_post_data.PostColMatchBeam;
    if (beam_and_post_data.PostColMatchBeam in colourMatch) {
        beam_and_post_data.PostCol = colourMatch[beam_and_post_data.PostColMatchBeam];
    }

    if (window.LYSAGHT) {
        if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
            beam_and_post_data.PortalPostType = 1;
        } else {
            beam_and_post_data.PortalPostType = 0;
        }
    } else {
        if (beam_and_post_data.PortalPostType === 1) {
            if (BeamPostParameters.CornerPostsFullHeight < 1) {
                BeamPostParameters.CornerPostsFullHeight = 1;
            }
            if (BeamPostParameters.IntermediatePostsFullHeight < 1) {
                BeamPostParameters.IntermediatePostsFullHeight = 1;
            }
        }
    }

    if (
        this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
        beam_and_post_data.PortalPostType === 0
    ) {
        beam_and_post_data.BeamType1 = beam_and_post_data.PostType;
        if (beam_and_post_data.BeamType1.startsWith("100mm")) beam_and_post_data.BeamType1 = "1086510";
        if (beam_and_post_data.BeamType1.startsWith("150mm")) beam_and_post_data.BeamType1 = "1586510";
    }

    let area_config = config?.design_options?.[designTemplate || this_area_data.SHAPE.DesignType];
    let area_freestanding = this_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].Freestanding;

    if (area_config) {
        let options = area_config?.post?.options;

        if (area_freestanding && area_config?.post?.freestanding_options)
            options = area_config?.post?.freestanding_options;

        if (beam_and_post_data.PortalPostType == 1) {
            if (area_config?.post?.non_portal_options) {
                options = area_config?.post?.non_portal_options;
            }
        }

        let replaced_RHS = beam_and_post_data.PostType.replace(" x 2mm", " x 3mm").replace(" x 2.5mm", " x 3mm");

        let post_valid = false;
        if (fixedDesignConfig?.PostType) {
            post_valid = true;
            beam_and_post_data.PostType = fixedDesignConfig?.PostType;
        }

        if (!post_valid && options) {
            for (const group in options) {
                if (options[group].includes(beam_and_post_data.PostType)) post_valid = true;
                else if (options[group].includes(replaced_RHS)) {
                    beam_and_post_data.PostType = replaced_RHS;
                    post_valid = true;
                }
                if (post_valid) break;
            }

            let corner_post_must_be_90_for_hip = Check_corner_post_must_be_90_for_hip(this_area_data);
            if (corner_post_must_be_90_for_hip && !beam_and_post_data.PostType.includes("90")) {
                for (const group in options) {
                    for (const group_post of options[group]) {
                        if (group_post.includes("90")) {
                            beam_and_post_data.PostType = group_post;
                            post_valid = true;
                            break;
                        }
                    }
                    if (post_valid) break;
                }
            }
        }

        if (!post_valid && area_config?.post) {
            if (beam_and_post_data.PortalPostType == 1 && area_config?.post?.non_portal_section_default)
                beam_and_post_data.PostType = area_config.post.non_portal_section_default;
            else if (area_freestanding && area_config?.post?.section_freestanding_default)
                beam_and_post_data.PostType = area_config.post.section_freestanding_default;
            else beam_and_post_data.PostType = area_config.post.section_default;
        }

        if (post_types?.[beam_and_post_data.PostType]) {
            let post_type = post_types?.[beam_and_post_data.PostType];

            const design_post_options =
                config?.design_options?.[designTemplate || this_area_data.SHAPE.DesignType]?.post;
            let post_colours = GetColourArray(
                post_type?.colours ? post_type?.colours : design_post_options.colours,
                config.colour_arrays
            );

            if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
                post_colours = GetColourArray(design_post_options.colours, config.colour_arrays);
            }

            if (post_colours.length === 1) {
                beam_and_post_data.PostColMatchBeam = post_colours[0];
                beam_and_post_data.PostCol = post_colours[0];
            } else if (
                beam_and_post_data.PostColMatchBeam != "TBA" &&
                !post_colours.includes(beam_and_post_data.PostColMatchBeam)
            ) {
                beam_and_post_data.PostColMatchBeam = "TBA";
                beam_and_post_data.PostCol = "TBA";
            }
            if (beam_and_post_data.PostCol === "TBA") beam_and_post_data.PostColourSelectionMade = false;
            else beam_and_post_data.PostColourSelectionMade = true;

            if (window.LYSAGHT && post_type?.allow_flanged === false) {
                beam_and_post_data.PostExternalConnectors = 0;

                if (this_area_data?.Footings) {
                    this_area_data.Footings = this_area_data.Footings.filter(function (a) {
                        return a?.Connector !== 2;
                    });
                }

                beam_and_post_data.FootingType = "Concrete In";
            }
        }

        let beam1_valid = false;
        if (fixedDesignConfig?.BeamType1) {
            beam1_valid = true;
            beam_and_post_data.BeamType1 = fixedDesignConfig?.BeamType1;
        }

        if (!beam1_valid && beam_and_post_data?.BeamType1 && area_config?.beam_1?.options)
            for (const group in area_config?.beam_1?.options) {
                if (area_config.beam_1.options?.[group]) {
                    if (area_config.beam_1.options[group].includes(beam_and_post_data.BeamType1)) beam1_valid = true;
                    else if (
                        area_config.beam_1.options[group].includes(
                            beam_and_post_data.BeamType1.replace(" x 2mm", " x 3mm").replace(" x 2.5mm", " x 3mm")
                        )
                    ) {
                        beam_and_post_data.BeamType1 = beam_and_post_data.BeamType1.replace(" x 2mm", " x 3mm").replace(
                            " x 2.5mm",
                            " x 3mm"
                        );
                        beam1_valid = true;
                    }
                }
                if (beam1_valid) break;
            }

        if (!beam1_valid && area_config?.beam_1) beam_and_post_data.BeamType1 = area_config.beam_1.section_default;

        let beam2 = area_config?.beam_2;
        if (
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
            this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
        ) {
            if (this_area_data.BEAMS_AND_POSTS.HasRidgeBeam === 1 && area_config?.beam_2_inset)
                beam2 = area_config.beam_2_inset;
        }

        let beam2_valid = false;
        if (fixedDesignConfig?.BeamType2) {
            beam2_valid = true;
            beam_and_post_data.BeamType2 = fixedDesignConfig?.BeamType2;
        }

        if (!beam2_valid && beam_and_post_data?.BeamType2 && beam2?.options)
            for (const group in beam2.options) {
                if (beam2.options?.[group]) {
                    if (beam2.options[group].includes(beam_and_post_data.BeamType2)) beam2_valid = true;
                    else if (
                        beam2.options[group].includes(
                            beam_and_post_data.BeamType2.replace(" x 2mm", " x 3mm").replace(" x 2.5mm", " x 3mm")
                        )
                    ) {
                        beam_and_post_data.BeamType2 = beam_and_post_data.BeamType2.replace(" x 2mm", " x 3mm").replace(
                            " x 2.5mm",
                            " x 3mm"
                        );
                        beam2_valid = true;
                    }
                }
                if (beam2_valid) break;
            }

        if (!beam2_valid && beam2) beam_and_post_data.BeamType2 = beam2.section_default;

        let beam3_valid = false;
        if (fixedDesignConfig?.BeamType3) {
            beam3_valid = true;
            beam_and_post_data.BeamType3 = fixedDesignConfig?.BeamType3;
        }

        if (!beam3_valid && beam_and_post_data?.BeamType3 && area_config?.beam_3?.options)
            for (const group in area_config?.beam_3?.options) {
                if (area_config.beam_3.options?.[group]) {
                    if (area_config.beam_3.options[group].includes(beam_and_post_data.BeamType3)) beam3_valid = true;
                    else if (
                        area_config.beam_3.options[group].includes(
                            beam_and_post_data.BeamType3.replace(" x 2mm", " x 3mm").replace(" x 2.5mm", " x 3mm")
                        )
                    ) {
                        beam_and_post_data.BeamType3 = beam_and_post_data.BeamType3.replace(" x 2mm", " x 3mm").replace(
                            " x 2.5mm",
                            " x 3mm"
                        );
                        beam3_valid = true;
                    }
                }
                if (beam3_valid) break;
            }

        if (!beam3_valid && area_config?.beam_3) beam_and_post_data.BeamType3 = area_config.beam_3.section_default;

        let beam4_valid = false;
        if (fixedDesignConfig?.BeamType4) {
            beam4_valid = true;
            beam_and_post_data.BeamType4 = fixedDesignConfig?.BeamType4;
        }

        if (!beam4_valid && beam_and_post_data?.BeamType4 && area_config?.beam_4?.options)
            for (const group in area_config?.beam_4?.options) {
                if (area_config.beam_4.options?.[group]) {
                    if (area_config.beam_4.options[group].includes(beam_and_post_data.BeamType4)) beam4_valid = true;
                    else if (
                        area_config.beam_4.options[group].includes(
                            beam_and_post_data.BeamType4.replace(" x 2mm", " x 3mm").replace(" x 2.5mm", " x 3mm")
                        )
                    ) {
                        beam_and_post_data.BeamType4 = beam_and_post_data.BeamType4.replace(" x 2mm", " x 3mm").replace(
                            " x 2.5mm",
                            " x 3mm"
                        );
                        beam4_valid = true;
                    }
                }
                if (beam4_valid) break;
            }

        if (!beam4_valid && area_config?.beam_4) beam_and_post_data.BeamType4 = area_config.beam_4.section_default;

        if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
            beam_and_post_data.MultipleAreaBeamType = beam_and_post_data.BeamType3;
        } else {
            beam_and_post_data.MultipleAreaBeamType = beam_and_post_data.BeamType1;
            if (this_area_data.SHAPE.AREAJOIN.JoinType === "L1")
                beam_and_post_data.MultipleAreaBeamType = beam_and_post_data.BeamType3;
            if (this_area_data.SHAPE.AREAJOIN.JoinType === "Angle")
                beam_and_post_data.MultipleAreaBeamType = beam_and_post_data.BeamType3;
        }
    }

    if (window.FIELDERS) {
        if (
            next_area_data &&
            (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip" ||
                this_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Gable")
        ) {
            beam_and_post_data.BeamType2 = "656510";
            beam_and_post_data.HasRidgeBeam = 1;
        }

        if (
            last_area_data &&
            (last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Hip" ||
                last_area_data[BASIC_SPECS_SECTIONS.SHAPE].AREAJOIN.JoinType === "Gable")
        ) {
            beam_and_post_data.BeamType2 = "656510";
            beam_and_post_data.HasRidgeBeam = 1;
        }
    }

    //min beam spacings
    if (beam_and_post_data?.AdjustedLength || in_adjusted_length) {
        let min_int_rafters = 0;

        let max_length = 8000;
        if (beam_and_post_data.BeamType2 === "656510") {
            max_length = 5500;
        } else if (beam_and_post_data.BeamType2 === "1086510") {
            max_length = 7000;
        }
        if (window.LYSAGHT) {
            max_length = 99999;
        }

        if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) {
            if (this_area_data[BASIC_SPECS_SECTIONS.SHAPE].DesignSubType === "Type 3") {
                min_int_rafters = Math.trunc((this_area_data[BASIC_SPECS_SECTIONS.SHAPE].Depth - 1) / max_length);
            } else {
                min_int_rafters = Math.trunc((beam_and_post_data.AdjustedLength - 1) / max_length);
            }
        }

        if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.PITCHED) {
            min_int_rafters = Math.trunc((this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.Depth - 1) / max_length);

            if (
                beam_and_post_data.NumExtraPortals &&
                beam_and_post_data.NumExtraPortals === beam_and_post_data.MinInternalRafters
            )
                beam_and_post_data.NumExtraPortals = min_int_rafters;
            if (beam_and_post_data.NumExtraPortals < min_int_rafters)
                beam_and_post_data.NumExtraPortals = min_int_rafters;

            beam_and_post_data.MinInternalRafters = min_int_rafters;
        } else if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
            let base_min = 2;

            let adjusted_length = job?.QuoteParameters?.AREA_DATA?.[areaIndex]?.ActualStructureLength;

            if (!adjusted_length) {
                adjusted_length = beam_and_post_data.AdjustedLength;
            }
            if (
                !adjusted_length &&
                this_area_data.ActualStructureLength &&
                adjusted_length < this_area_data.ActualStructureLength
            )
                adjusted_length = this_area_data.ActualStructureLength;

            if (last_area_data) {
                //has a last area
                if (last_area_data.SHAPE.AREAJOIN.JoinType === "Hip") {
                    base_min += 2;
                    adjusted_length -= last_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth;
                }

                if (last_area_data.SHAPE.AREAJOIN.JoinType === "Gable") {
                    base_min++;
                    adjusted_length -= last_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth;
                }
            } else if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.RoofType1 !== "Gable") {
                base_min++;
                if (
                    this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.RoofType1 === "Hip" &&
                    this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.HipAngle1 === 60
                )
                    adjusted_length -= this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth / 4;
                else adjusted_length -= this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth / 2;
            }
            if (next_area_data) {
                //has a next area
                if (this_area_data.SHAPE.AREAJOIN.JoinType === "Hip") {
                    base_min += 2;
                    adjusted_length -= next_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth;
                }

                if (this_area_data.SHAPE.AREAJOIN.JoinType === "Gable") {
                    base_min++;
                    adjusted_length -= next_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth;
                }
            } else if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.RoofType2 !== "Gable") {
                base_min++;
                if (
                    this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.RoofType2 === "Hip" &&
                    this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.HipAngle2 === 60
                )
                    adjusted_length -= this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth / 4;
                else adjusted_length -= this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Depth / 2;
            }

            min_int_rafters = base_min + Math.trunc((adjusted_length - 1) / max_length);

            if (
                beam_and_post_data.MinInternalRafters &&
                beam_and_post_data.NumPortals === beam_and_post_data.MinInternalRafters
            )
                beam_and_post_data.NumPortals = min_int_rafters;
            if (beam_and_post_data.NumPortals < min_int_rafters) beam_and_post_data.NumPortals = min_int_rafters;

            beam_and_post_data.NumInternalPortals = 0;
            beam_and_post_data.MinInternalRafters = min_int_rafters;
            beam_and_post_data.NumExtraPortals = 0;
        } else {
            if (
                beam_and_post_data.MinInternalRafters &&
                beam_and_post_data.NumInternalRafters === beam_and_post_data.MinInternalRafters
            )
                beam_and_post_data.NumInternalRafters = min_int_rafters;
            if (beam_and_post_data.NumInternalRafters < min_int_rafters)
                beam_and_post_data.NumInternalRafters = min_int_rafters;

            beam_and_post_data.MinInternalRafters = min_int_rafters;
        }

        if (beam_and_post_data.NumInternalRafter < beam_and_post_data.MinInternalRafters) {
            beam_and_post_data.NumInternalRafter = beam_and_post_data.MinInternalRafters;
        }
    }

    if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
        beam_and_post_data.NumExtraPortals = 0;

        if (beam_and_post_data.BeamType1.includes("FL10011")) {
            if (beam_and_post_data.BeamType2.includes("FL20020") || beam_and_post_data.BeamType2.includes("FL15015")) {
                beam_and_post_data.BeamType2 = "FL10011";
            }
        } else if (beam_and_post_data.BeamType1.includes("FL15015")) {
            if (beam_and_post_data.BeamType2.includes("FL20020")) {
                beam_and_post_data.BeamType2 = "FL15015";
            }
        }
    }

    if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.DECK) {
        let maxPostSpacing = 4000;
        if (maxPostSpacing && beam_and_post_data.PostSpacing > maxPostSpacing)
            beam_and_post_data.PostSpacing = maxPostSpacing;

        let maxBeamSpacing = 5000;
        if (maxBeamSpacing && beam_and_post_data.BeamSpacing > maxBeamSpacing)
            beam_and_post_data.BeamSpacing = maxBeamSpacing;

        if (window.FIELDERS) {
            beam_and_post_data.PostCol = "Galvanised";
            beam_and_post_data.BeamCol1 = "Galvanised";
            beam_and_post_data.BeamCol2 = "Galvanised";
        }
        beam_and_post_data.PostColMatchBeam = beam_and_post_data.PostCol;
    } else {
        if (window.LYSAGHT) {
            beam_and_post_data.BeamSpacing = job.DesignParameters.SplicingLength;
            beam_and_post_data.PostSpacing = 30000;
        } else {
            if (
                this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
                beam_and_post_data.PortalPostType === 1
            ) {
                beam_and_post_data.PostSpacing = 30000;
                beam_and_post_data.HasRidgeBeam = 1;
            }
        }
    }

    if (this_area_data?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData.single_span_only) {
        beam_and_post_data.NumInternalRafters = 0;
    } else {
    }

    if (post_types && window.FIELDERS) {
        if (post_types?.[BeamPostParameters.PostType]?.allow_under === false) {
            beam_and_post_data.CornerPostsFullHeight = 1;
            beam_and_post_data.IntermediatePostsFullHeight = 1;
        }
    }

    // LYSAGHT SPECIFIC VALIDATIONS
    if (job?.Distributor?.Brand === "Lysaght") {
        if (beam_and_post_data?.CornerPostsFullHeight === 0) beam_and_post_data.CornerPostsFullHeight = 1;
        if (beam_and_post_data?.IntermediatePostsFullHeight === 0) beam_and_post_data.IntermediatePostsFullHeight = 1;

        // check is notch is valid for post
        if (post_types) {
            if (
                post_types?.[BeamPostParameters.PostType]?.allow_notched === false &&
                post_types?.[BeamPostParameters.PostType]?.allow_side === false
            ) {
                beam_and_post_data.CornerPostsFullHeight = 3;
                beam_and_post_data.IntermediatePostsFullHeight = 3;
            } else if (
                post_types?.[BeamPostParameters.PostType]?.allow_notched === false &&
                post_types?.[BeamPostParameters.PostType]?.allow_behind === false
            ) {
                beam_and_post_data.CornerPostsFullHeight = 1;
                beam_and_post_data.IntermediatePostsFullHeight = 1;
            } else if (
                post_types?.[BeamPostParameters.PostType]?.allow_side === false &&
                post_types?.[BeamPostParameters.PostType]?.allow_behind === false
            ) {
                beam_and_post_data.CornerPostsFullHeight = 2;
                beam_and_post_data.IntermediatePostsFullHeight = 2;
            } else if (post_types?.[BeamPostParameters.PostType]?.allow_notched === false) {
                if (beam_and_post_data.CornerPostsFullHeight === 2) beam_and_post_data.CornerPostsFullHeight = 3;
                if (beam_and_post_data.IntermediatePostsFullHeight === 2)
                    beam_and_post_data.IntermediatePostsFullHeight = 3;
            } else if (post_types?.[BeamPostParameters.PostType]?.allow_side === false) {
                if (beam_and_post_data.CornerPostsFullHeight === 1) beam_and_post_data.CornerPostsFullHeight = 3;
                if (beam_and_post_data.CornerPostsFullHeight === 1) beam_and_post_data.IntermediatePostsFullHeight = 3;
            } else if (post_types?.[BeamPostParameters.PostType]?.allow_behind === false) {
                if (beam_and_post_data.CornerPostsFullHeight === 3) beam_and_post_data.CornerPostsFullHeight = 1;
                if (beam_and_post_data.CornerPostsFullHeight === 3) beam_and_post_data.IntermediatePostsFullHeight = 1;
            }
        }

        beam_and_post_data.AutoAddBeamBreakPost = job.DesignParameters.AutoAddBeamBreakPost;
        beam_and_post_data.HasRidgeBeam = 1;
        beam_and_post_data.IntRafterBracketClearance = 0;

        if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
            delete beam_and_post_data.InfillEndAlign1;
            delete beam_and_post_data.InfillEndAlign2;

            if (beam_and_post_data.CollarTieBeam && beam_and_post_data.CollarTieBeam.includes("FL15015")) {
                beam_and_post_data.CollarTieBracket = "CTC15";
            } else {
                beam_and_post_data.RidgePurlinsNoBrackets = 1;
                beam_and_post_data.CollarTieBracket = "CTC10";
            }

            if (beam_and_post_data.BeamType1.includes("FL10011")) {
                beam_and_post_data.ApexBracketInternal = "CCD10";
                beam_and_post_data.ApexBracketEnd = "CC10";
                beam_and_post_data.DoubleIntermediateRafters = 0;
                beam_and_post_data.CollarTie = 1;
            } else if (beam_and_post_data.BeamType1.includes("FL15015")) {
                beam_and_post_data.ApexBracketInternal = "CCD15";
                beam_and_post_data.ApexBracketEnd = "CC15";
            } else if (beam_and_post_data.BeamType1.includes("FL20020")) {
                beam_and_post_data.CollarTie = 0;
            }

            if (beam_and_post_data.BeamType1.includes("FL20020")) {
                if (beam_and_post_data.BeamType2.includes("FL10011")) beam_and_post_data.BeamType2 = "FL15015";
                if (beam_and_post_data.BeamType3.includes("FL10011")) beam_and_post_data.BeamType3 = "FL20020";
                if (beam_and_post_data.BeamType3.includes("FL15015")) beam_and_post_data.BeamType3 = "FL20020";
            }

            if (beam_and_post_data.BeamType1.includes("FL15015")) {
                if (beam_and_post_data.BeamType2.includes("FL20020")) beam_and_post_data.BeamType2 = "FL15015";
                if (beam_and_post_data.BeamType3.includes("FL10011")) beam_and_post_data.BeamType3 = "FL15015";
            }

            if (beam_and_post_data.BeamType1.includes("FL10011")) {
                if (!beam_and_post_data.BeamType2.includes("FL10011")) beam_and_post_data.BeamType2 = "FL10011";
            }

            if (
                beam_and_post_data.BeamType1.includes("FL15015") &&
                beam_and_post_data.BeamType2.includes("FL15015") &&
                beam_and_post_data.CollarTie === 1 &&
                beam_and_post_data.BeamType4.includes("FL10011")
            ) {
                beam_and_post_data.BeamType4 = "FL15015"; // Set Hip to 100mm (caused by collar tie)
            }

            beam_and_post_data.GableRafterBaseFlushCut = 1;

            if (beam_and_post_data.CollarTie === 1) {
                beam_and_post_data.GableTopPurlinOffset = -1;
                beam_and_post_data.GableRafterApexFlushCut = 1;
                beam_and_post_data.CollarTiePosition = 0.7;
                beam_and_post_data.DoubleIntermediateRafters = 0;
                beam_and_post_data.RidgePurlinsNoBrackets = 1;

                if (this_area_data?.[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS]?.HasInfillBeam1 === 0)
                    beam_and_post_data.CollarTieEnd1 = 1;
                else beam_and_post_data.CollarTieEnd1 = 0;

                if (this_area_data?.[BASIC_SPECS_SECTIONS.GABLE_PARAMETERS]?.HasInfillBeam2 === 0)
                    beam_and_post_data.CollarTieEnd2 = 1;
                else beam_and_post_data.CollarTieEnd2 = 0;

                beam_and_post_data.BeamType2 = beam_and_post_data.BeamType1.split("M")[0];

                if (this_area_data.META.HasHips && beam_and_post_data.CollarTie === 1) {
                    beam_and_post_data.BeamType4 = beam_and_post_data.BeamType1;
                }

                // Function to normalize rafterBeam by stripping everything after 'M' if present
                function normalizeBeam(beam) {
                    return beam?.split("M")[0]; // Split on 'M' and take the part before it
                }

                beam_and_post_data.BeamType1 = normalizeBeam(beam_and_post_data.BeamType1);
                beam_and_post_data.BeamType2 = normalizeBeam(beam_and_post_data.BeamType2);
                beam_and_post_data.BeamType3 = normalizeBeam(beam_and_post_data.BeamType3);
                beam_and_post_data.BeamType4 = normalizeBeam(beam_and_post_data.BeamType4);
            } else {
                beam_and_post_data.CollarTieBeam = beam_and_post_data.BeamType1;
                beam_and_post_data.RidgePurlinsNoBrackets = 0;
                beam_and_post_data.GableTopPurlinOffset = 75;
                beam_and_post_data.GableRafterApexFlushCut = 0;
                beam_and_post_data.ApexBracketInternal = "";
                beam_and_post_data.ApexBracketEnd = "";
            }
        } else {
            beam_and_post_data.RidgePurlinsNoBrackets = 0;
            beam_and_post_data.GableTopPurlinOffset = 75;
            beam_and_post_data.GableRafterApexFlushCut = 0;
            beam_and_post_data.ApexBracketInternal = "";
            beam_and_post_data.ApexBracketEnd = "";
        }
    } else {
        beam_and_post_data.IntRafterBracketClearance = 0;
        beam_and_post_data.RidgePurlinsNoBrackets = 0;
        beam_and_post_data.GableTopPurlinOffset = 75;
        beam_and_post_data.AutoAddBeamBreakPost = job.DesignParameters.AutoAddBeamBreakPost;
        beam_and_post_data.GableRafterApexFlushCut = 0;
        beam_and_post_data.GableRafterBaseFlushCut = 0;
        beam_and_post_data.ApexBracketInternal = "";
        beam_and_post_data.ApexBracketEnd = "";
        beam_and_post_data.DoubleIntermediateRafters = 0;
        beam_and_post_data.CornerPostsFullHeightOffset = 0;
    }

    if (this_area_data.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
        beam_and_post_data.CornerPostsFullHeight = 1;
        beam_and_post_data.IntermediatePostsFullHeight = 1;
        beam_and_post_data.BeamType2 = "Alspec WideSpan 250";
        beam_and_post_data.BeamCol2 = beam_and_post_data.BeamCol1;
        beam_and_post_data.BeamType3 = "Alspec WideSpan 250";
        beam_and_post_data.BeamCol3 = beam_and_post_data.BeamCol1;
        beam_and_post_data.FootingType = "Bolt to Slab";
        beam_and_post_data.PostExternalConnectors = 1;
    }

    if (designTemplate === "National Carport") {
        const needsExtra = carportNeedsExtraPurlin(job, designTemplateName);
        beam_and_post_data.NumExtraPurlins = needsExtra ? 1 : 0;
    }

    // Special requirement for Job Summary & Quote Page
    const engineeringMaxResults = job?.QuoteParameters?.ENGINEERING?.EngineeringResults?.AreaMaxResults?.[areaIndex];
    if (engineeringMaxResults) {
        const result = {};
        for (const key in engineeringMaxResults) {
            if (key.startsWith("Num")) {
                const newKey = "Eng" + key;
                result[newKey] = engineeringMaxResults[key];
            }
        }
        beam_and_post_data.CountsFromEngineering = result;
    }

    return beam_and_post_data;
};

export const validateEngineeringAndDesign = (config, job, areaIndex) => {
    let this_area_data = job.AreaSpecifications[areaIndex];

    if (job.SiteParameters?.ExistingStructure?.RoofType === "Tile") {
        this_area_data.ENGINEERING_AND_DESIGN.RiserBracketSpacing = 1200;
        this_area_data.ENGINEERING_AND_DESIGN.CarportRiserBracketSpacing = 1200;
    } else {
        this_area_data.ENGINEERING_AND_DESIGN.RiserBracketSpacing = 900;
        this_area_data.ENGINEERING_AND_DESIGN.CarportRiserBracketSpacing = 900;
    }

    return job;
};

export const majorityOfPostsBoltToSlab = (footingMods = [], defaultFooting = "", numberOfPosts = 0) => {
    if (numberOfPosts === 0) {
        return false;
    }

    const totalFootingModsCount = footingMods.length;

    if (totalFootingModsCount === 0) {
        return defaultFooting?.includes("Bolt");
    }

    const boltToSlabModCount = footingMods.filter((footing) => footing?.Kind?.includes("Bolt")).length;

    if (defaultFooting?.includes("Bolt")) {
        return (totalFootingModsCount - boltToSlabModCount) / numberOfPosts < 0.5;
    } else {
        return boltToSlabModCount / numberOfPosts > 0.5;
    }
};

export const validateOptions = (config, job, areaIndex) => {
    let this_area_data = job.AreaSpecifications[areaIndex];
    let roofsheet_types = config.roofsheet_types;
    let roof_sheet_data = { ...this_area_data[BASIC_SPECS_SECTIONS.ROOF_SHEETING] };

    const designTemplate = this_area_data?.SHAPE?.DesignTemplateType ?? null; // e.g. National Carport
    let area_config = config?.design_options?.[designTemplate || this_area_data.SHAPE.DesignType];

    const roofsheetgroup = roofsheet_types[roof_sheet_data["RoofGroupType"]];

    if (!roofsheetgroup?.skylights || Object.keys(roofsheetgroup.skylights).length === 0) {
        this_area_data.SKYLIGHTS = [];
    }

    this_area_data.OPTIONS.SlatColour = "Monument";

    // BEAM MODIFICATIONS
    if (areaIndex > 0) {
        this_area_data[BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS] = [];
    } else if (areaIndex === 0) {
        let numAreas = job?.AreaSpecifications?.length;
        let beam_mods = this_area_data[BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS];
        this_area_data[BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS] = beam_mods.filter((obj) => {
            return obj.Area < numAreas;
        });
    }

    let is_cyclonic = false;
    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;

    if (region === "C" || region === "D") {
        is_cyclonic = true;
    }

    if (this_area_data[BASIC_SPECS_SECTIONS.POSTMODIFICATIONS] && config.post_types) {
        let area_freestanding = this_area_data[BASIC_SPECS_SECTIONS.ATTACHMENTS].Freestanding;

        let options = area_config?.post?.options;

        if (area_freestanding && area_config?.post?.freestanding_options)
            options = area_config?.post?.freestanding_options;

        if (this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PortalPostType == 1) {
            if (area_config?.post?.non_portal_options) {
                options = area_config?.post?.non_portal_options;
            }
        }

        for (let post_mod of this_area_data[BASIC_SPECS_SECTIONS.POSTMODIFICATIONS]) {
            let post_section = this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType;
            if (post_mod.Section) {
                post_section = post_mod.Section;
            }

            if (options) {
                let post_valid = false;
                for (const group in options) {
                    if (options[group].includes(post_section)) post_valid = true;
                }
                if (!post_valid) {
                    post_mod.Section = "";
                }
            }

            if (post_section && post_mod.TopConnection != null && post_mod.TopConnection !== "") {
                let post_top_connection_allowed = PostTypeTopConnectionAllowed(
                    config.post_types,
                    post_section,
                    post_mod.Colour ? post_mod.Colour : this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostCol,
                    is_cyclonic
                );
                if (post_mod.TopConnection === 0 && !post_top_connection_allowed.post_under_allowed) {
                    post_mod.TopConnection = 1;
                }
                if (post_mod.TopConnection === 2 && !post_top_connection_allowed.post_notch_allowed) {
                    post_mod.TopConnection = 1;
                }
                if (post_mod.TopConnection === 3 && !post_top_connection_allowed.post_behind_allowed) {
                    post_mod.TopConnection = 1;
                }
            }
        }
    }

    const numberOfPosts =
        this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.CountsFromEngineering?.EngNumColumns ?? 0;
    const defaultFooting = this_area_data?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.FootingType;
    const footingModifications = this_area_data?.[BASIC_SPECS_SECTIONS.FOOTINGS] ?? [];

    if (
        is_cyclonic &&
        job.DesignParameters.Freestanding &&
        numberOfPosts > 0 &&
        majorityOfPostsBoltToSlab(footingModifications, defaultFooting, numberOfPosts)
    ) {
        this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].FootingType = "Concrete In";
        this_area_data[BASIC_SPECS_SECTIONS.FOOTINGS] = [];
    }

    if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Left = this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Frame_OH_Left;
        this_area_data[BASIC_SPECS_SECTIONS.SHAPE].OH_Right =
            this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Frame_OH_Right;
        let beam_mod_template = {
            Ref: "(0.00/2975.00/2359.99);(8000.00/2975.00/2359.99)",
            Ref2: "Back/0",
            Area: 0,
            Overhang1: this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Frame_OH_Left,
            Overhang2: this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE].Frame_OH_Right,
            NumInternalPost: 0,
            EventSpacePosts: true,
            SetPost1: -1,
            SetPost2: -1,
            InternalPostOffset: "",
        };
        this_area_data[BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS] = [];
        let front_mod = {
            ...beam_mod_template,
            Ref2: "Front/0",
        };
        this_area_data[BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS].push(front_mod);
        let back_mod = {
            ...beam_mod_template,
            Ref2: "Back/0",
        };
        this_area_data[BASIC_SPECS_SECTIONS.BEAMMODIFICATIONS].push(back_mod);
    }

    return job;
};

export const validateDecks = (config, job, areaIndex) => {
    let this_area_data = job.AreaSpecifications[areaIndex];
    if (this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType === CONFIG.DESIGN_TYPES.DECK) {
        let beam_and_post_data = { ...this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS] };
        let area_design_options = config?.design_options?.[this_area_data?.[BASIC_SPECS_SECTIONS.SHAPE]?.DesignType];
        let engineeringResult = EngineerDeckv2(beam_and_post_data);

        if (!job?.QuoteParameters?.ENGINEERING) job.QuoteParameters.ENGINEERING = { Data: [] };
        if (!job?.QuoteParameters?.ENGINEERING?.Data) job.QuoteParameters.ENGINEERING.Data = [];
        job.QuoteParameters.ENGINEERING.Data[areaIndex] = engineeringResult;

        if (area_design_options) {
            if (area_design_options?.beam_1?.Name)
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName1 = area_design_options?.beam_1?.Name;
            else this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName1 = "";
            if (area_design_options?.beam_2?.Name)
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName2 = area_design_options?.beam_2?.Name;
            else this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName2 = "";
            if (area_design_options?.beam_3?.Name)
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName3 = area_design_options?.beam_3?.Name;
            else this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName3 = "";
            if (area_design_options?.beam_4?.Name)
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName4 = area_design_options?.beam_4?.Name;
            else this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamName4 = "";
        }

        if (this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1 === "SB15865") {
            if (this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 === "SB20865") {
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "SB15865";
            }
        }
        if (this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType1 === "SB10865") {
            if (
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 === "SB20865" ||
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 === "SB15865"
            ) {
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamType2 = "SB10865";
            }
        }

        if (window.LYSAGHT) {
            this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight =
                this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight;
        } else {
            this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight = 1;
            this_area_data[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].IntermediatePostsFullHeight = 1;
        }

        if (area_design_options) {
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].StrapBraceCode =
                area_design_options?.bracing?.strap_brace_code;
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].StrapBraceRollLength =
                area_design_options?.bracing?.strap_brace_roll_length;
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].WireBraceCode =
                area_design_options?.bracing?.wire_brace_code;
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].WireBraceRollLength =
                area_design_options?.bracing?.wire_brace_roll_length;
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].RodBraceCode =
                area_design_options?.bracing?.rod_brace_code;
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].FloorBraceCode =
                area_design_options?.bracing?.floor_brace_code;
            this_area_data[BASIC_SPECS_SECTIONS.DECK_PARAMETERS].FloorBraceArea =
                area_design_options?.bracing?.floor_brace_area;
        }
    }
    //validate height
    // ** "Minimum height from the ground to the steel floor system is generally recommended to be 450 mm, to allow sufficient ventilation. This may be reduced to a minimum of 50mm only in cases where existing adjacent structure wall ventilation openings are not restricted by the framing & Local Authorities permit a reduced termite clearance and underfloor ventilation. Refer to NCC – BCA Vol 2, clause 3.4.1."

    return job;
};

export function PostTypeTopConnectionAllowed(post_types, post_type_section, post_colour, is_cyclonic) {
    let post_notch_allowed = post_types?.[post_type_section]?.allow_notched === true;

    let post_notch_disabled_helpertext = "";

    if (!post_notch_allowed) {
        post_notch_disabled_helpertext = "Not allowed for this post type";
    }

    if (post_colour === "Merbau") {
        post_notch_allowed = false;
        post_notch_disabled_helpertext = "Not allowed in Merbau";
    }

    let post_side_allowed = true;
    let post_side_disabled_helpertext = "";
    if (is_cyclonic && window.brand === "Lysaght") {
        post_side_allowed = false;
        post_side_disabled_helpertext = "Not allowed in cyclonic";
    }

    let post_behind_allowed = post_types?.[post_type_section]?.allow_behind ?? true;
    let post_behind_allowed_helpertext = "";
    if (!post_behind_allowed) {
        post_behind_allowed_helpertext = "Not allowed for this post type";
    }

    if (post_side_allowed && post_types?.[post_type_section]?.allow_side === false) {
        post_side_allowed = false;
        post_side_disabled_helpertext = "Not allowed for this post type";
    }

    let post_under_allowed = post_types?.[post_type_section]?.allow_under === false ? false : true;
    let post_under_allowed_helpertext = "";
    if (!post_under_allowed) {
        post_under_allowed_helpertext = "Post Under not allowed for this post type";
    }
    if (is_cyclonic) {
        post_under_allowed = false;
        post_under_allowed_helpertext = "Post Under not allowed in cyclonic";
    }

    return {
        post_under_allowed: post_under_allowed,
        post_under_allowed_helpertext: post_under_allowed_helpertext,
        post_side_allowed: post_side_allowed,
        post_side_disabled_helpertext: post_side_disabled_helpertext,
        post_notch_allowed: post_notch_allowed,
        post_notch_disabled_helpertext: post_notch_disabled_helpertext,
        post_behind_allowed: post_behind_allowed,
        post_behind_allowed_helpertext: post_behind_allowed_helpertext,
    };
}

export function Check_corner_post_must_be_90_for_hip(area_design_specs) {
    if (
        area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL &&
        (area_design_specs.SHAPE.RoofType1 !== "Gable" || area_design_specs.SHAPE.RoofType2 !== "Gable") &&
        area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].CornerPostsFullHeight === 1 &&
        area_design_specs[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PortalPostType == 1
    ) {
        return true;
    }
    return false;
}

export function AdjustedLengthForMultipleAreas(job, areaIndex, in_length = null) {
    if (job.AreaSpecifications.length === 0) return -1;
    if (job.AreaSpecifications.length === 1) {
        if (job.AreaSpecifications[0].SHAPE.DesignType === "Pitched Roof") return job.AreaSpecifications[0].SHAPE.Depth;
        return job.AreaSpecifications[0].SHAPE.Length;
    }
    if (job.AreaSpecifications[areaIndex].SHAPE.DesignType === "Pitched Roof")
        return job.AreaSpecifications[areaIndex].SHAPE.Depth;

    let extension1 = 0;
    let extension2 = 0;

    // copy from opal
    let area = job.AreaSpecifications[0];
    if (areaIndex <= job.AreaSpecifications.length) area = job.AreaSpecifications[areaIndex];

    let modified_length = in_length ? in_length : area.SHAPE.Length;

    let areaNext = job.AreaSpecifications[areaIndex + 1];
    if (areaIndex <= job.AreaSpecifications.length - 1 && areaNext) {
        // has next area
        if (area.SHAPE.AREAJOIN.JoinType === "Offset") {
            //none
        }
        if (["Angle", "Hip", "Gable"].includes(area.SHAPE.AREAJOIN.JoinType)) {
            let ext_results = find_join_angle_extension(
                area.SHAPE.AREAJOIN.JoinAngle,
                area.SHAPE.Depth,
                areaNext.SHAPE.Depth
            );

            if (ext_results.ext_this > 0) modified_length += ext_results.ext_this;
        } else if (area.SHAPE.AREAJOIN.JoinType === "L1") {
            if (area.SHAPE.AREAJOIN.JoinAngle > 0) {
                modified_length = modified_length + areaNext.SHAPE.Depth;
                if (area.SHAPE.CUTOUTS["BackLeft-CutoutType"] !== "None") {
                    modified_length = modified_length + area.SHAPE.CUTOUTS["BackLeft-WidthX"];
                }
                if (areaNext.SHAPE.CUTOUTS["FrontLeft-CutoutType"] !== "None") {
                    modified_length -= areaNext.SHAPE.CUTOUTS["FrontLeft-WidthY"];
                }
                if (areaNext.SHAPE.CUTOUTS["BackLeft-CutoutType"] !== "None") {
                    modified_length -= areaNext.SHAPE.CUTOUTS["BackLeft-WidthY"];
                }
            }
        }
    }

    let lastArea = job.AreaSpecifications[areaIndex - 1];
    if (areaIndex > 0 && lastArea) {
        if (lastArea.SHAPE.AREAJOIN.JoinType === "Offset") {
            //none
        }
        if (["Angle", "Hip", "Gable"].includes(lastArea.SHAPE.AREAJOIN.JoinType)) {
            let ext_results = find_join_angle_extension(
                lastArea.SHAPE.AREAJOIN.JoinAngle,
                lastArea.SHAPE.Depth,
                area.SHAPE.Depth
            );
            if (ext_results.ext_next > 0) modified_length += ext_results.ext_next;
        } else if (lastArea.SHAPE.AREAJOIN.JoinType === "L1") {
        } else if (lastArea.SHAPE.AREAJOIN.JoinType === "L2") {
            if (lastArea.SHAPE.AREAJOIN.JoinAngle > 0) {
                modified_length = modified_length + lastArea.SHAPE.Depth;

                if (area.SHAPE.CUTOUTS["BackRight-CutoutType"] !== "None") {
                    modified_length = modified_length + area.SHAPE.CUTOUTS["BackRight-WidthX"];
                }
                if (lastArea.SHAPE.CUTOUTS["FrontRight-CutoutType"] !== "None") {
                    modified_length -= lastArea.SHAPE.CUTOUTS["FrontRight-WidthY"];
                }
                if (lastArea.SHAPE.CUTOUTS["BackRight-CutoutType"] !== "None") {
                    modified_length -= lastArea.SHAPE.CUTOUTS["BackRight-WidthY"];
                }
            }
        }
    }
    return modified_length;
}

export const checkValidationScheme = (regex_scheme, value) => {
    let error = null;

    var isRequired = false;

    if (regex_scheme["IsRequired"] !== null) {
        isRequired = regex_scheme["IsRequired"];
    }

    let value_is_null_or_empty = true;
    if (value && value !== "") value_is_null_or_empty = false;

    if (isRequired && value_is_null_or_empty) {
        error = "value is required";
    } else if (!isRequired && value_is_null_or_empty) {
        error = null;
    } else {
        if (regex_scheme["MaxChars"] && !value_is_null_or_empty) {
            let max_chars = toNumber(regex_scheme["MaxChars"]);

            if (["IntergersOnly", "Decimal"].includes(regex_scheme["Type"])) {
                if (Number(value) > Number(max_chars)) error = "max is " + max_chars;
            } else if (max_chars > -1 && value.length > max_chars) {
                error = "exceeds " + value.length + "/" + max_chars + " max characters";
            }
        }
        if (regex_scheme["MinChars"] && !value_is_null_or_empty) {
            let min_chars = toNumber(regex_scheme["MinChars"]);
            if (["IntergersOnly", "Decimal"].includes(regex_scheme["Type"])) {
                if (Number(value) < Number(min_chars)) error = "min is " + min_chars;
            } else if (min_chars > -1 && value.length < min_chars) {
                error = "under min length of " + min_chars + " characters";
            }
        }

        if (regex_scheme["Regex"]) {
            const regex = RegExp(regex_scheme["Regex"]);
            if (!regex.test(value)) {
                let descriptor = regex_scheme["Descriptor"];
                error = "value '" + value + "' is not valid";
                if (descriptor && descriptor !== "") error = descriptor;
            }
        }
    }
    return error;
};

export const validateNumberRange_old = (value, range) => {
    if (range) {
        if ((value === undefined || value === null) && range?.default) value = toNumber(range?.default);
        else if (range?.min && value < toNumber(range?.min)) {
            value = toNumber(range?.min);
        } else if (range?.max && value > toNumber(range?.max)) {
            value = toNumber(range?.max);
        }
    }
    return value;
};

export const validateNumberRange = (value, errorMap) => {
    errorMap.value = value;
    if (errorMap?.range) {
        if ((value === undefined || value === null) && errorMap.range?.default)
            errorMap.value = toNumber(errorMap.range?.default);
        else if (errorMap.range?.min && value < toNumber(errorMap.range?.min)) {
            errorMap.value = toNumber(errorMap.range?.default ? errorMap.range?.default : errorMap.range?.min);
            if (errorMap.range?.min_reason) errorMap.message = errorMap.range?.min_reason;
            else
                errorMap.message =
                    (errorMap?.name ? errorMap?.name + " " : "value ") +
                    " was under min value. Set to " +
                    (errorMap.range?.default ? "default: " : "min: ") +
                    errorMap.value;
        } else if (errorMap.range?.max && value > toNumber(errorMap.range?.max)) {
            errorMap.value = toNumber(errorMap.range?.default ? errorMap.range?.default : errorMap.range?.max);
            if (errorMap.range?.max_reason) errorMap.message = errorMap.range?.max_reason;
            else
                errorMap.message =
                    (errorMap?.name ? errorMap?.name + " " : "value ") +
                    " was over max value. Set to " +
                    (errorMap.range?.default ? "default: " : "max: ") +
                    errorMap.value;
        }
    }
    return errorMap;
};

export const validateFootingModifications = (job, areaIndex, footingMods) => (dispatch) => {
    if (!Array.isArray(footingMods) || footingMods.length === 0) {
        return [];
    }

    const areaSpecs = job?.AreaSpecifications?.[areaIndex];
    const numberOfPosts = areaSpecs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.CountsFromEngineering?.EngNumColumns ?? 0;

    if (numberOfPosts === 0) {
        return footingMods;
    }

    const defaultFooting = areaSpecs?.[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS]?.FootingType;
    const isFreestanding = job?.DesignParameters?.Freestanding;
    const region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    const isCyclonic = region === "C" || region === "D";

    for (let i = footingMods.length - 1; i >= 0; i--) {
        const footing = footingMods[i];

        if (isFreestanding && footing.Connector !== 2) {
            footing.Kind = "Concrete In";
            footing.Connector = 0;
        }

        if (isCyclonic && isFreestanding && footing.Kind !== "Concrete In") {
            if (majorityOfPostsBoltToSlab(footingMods, defaultFooting, numberOfPosts)) {
                footing.Kind = "Concrete In";
                footing.Connector = 0;
                dispatch(
                    showDialog(
                        "Bolt to slab flange posts exceed 50%",
                        "Freestanding structures in cyclonic regions must have at least half of all posts in ground",
                        "OK"
                    )
                );
            }
        }
    }

    return footingMods;
};

export const CheckSuggestions = (config, job, areaIndex, app) => (dispatch) => {
    let standardErrors = jobStateErrorPopups({ config, job, app, dispatch });
    if (standardErrors) return standardErrors;
    for (let i in job.AreaSpecifications) {
        const areaIndex = Number(i);
        const areaNumber = Number(i + 1);
        const last_area = job?.AreaSpecifications?.[areaIndex - 1];
        const this_area = job.AreaSpecifications[areaIndex];
        const next_area = job?.AreaSpecifications?.[areaIndex + 1];

        let area_META = this_area?.META;

        if (area_META) {
            if (
                area_META?.HasBoxGutterToFascia &&
                area_META.HasBoxGutterToFascia() &&
                !this_area.Acknowledgements?.BoxHouseGutterAcknowledgement
            ) {
                return {
                    error: true,
                    title: "Box Gutter Warning",
                    message: [
                        <>
                            As per the National Construction Code, ABCB Housing Provisions and AS 3500.3 Clause 4.5.4
                            (a) a box gutter requires a minimum fall of 1 in 200 - this cannot be achieved when
                            attaching with standard rafter brackets. By selecting ‘Accept’ you are indemnifying{" "}
                            {window.LYSAGHT ? "Lysaght" : "Fielders"} for any liability arising from this choice.{" "}
                            {window.LYSAGHT ? "Lysaght" : "Fielders"} recommends that you use ‘double gutters’ in this
                            instance
                        </>,
                    ],
                    primaryActionText: "Accept Warning",
                    primaryAction: () => {
                        let new_job = COMMON.deepCopy(job);
                        new_job.AreaSpecifications[areaIndex].Acknowledgements.BoxHouseGutterAcknowledgement = true;
                        //forced compliance/ mass settings, updates
                        new_job = validateFullJob(config, new_job, -1, app);
                        dispatch({
                            type: "NEW_JOB",
                            parameter: new_job,
                        });
                    },
                    secondaryActionText: "Change to 'Double Gutter'",
                    secondaryAction: () => {
                        let new_job = COMMON.deepCopy(job);
                        if (area_META.FrontState.HasBoxGutterToFascia())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterF = 1;
                        if (area_META.BackState.HasBoxGutterToFascia())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterB = 1;
                        if (area_META.LeftState.HasBoxGutterToFascia())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterL = 1;
                        if (area_META.RightState.HasBoxGutterToFascia())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterR = 1;
                        //forced compliance/ mass settings, updates
                        new_job = validateFullJob(config, new_job, -1, app);
                        dispatch({
                            type: "NEW_JOB",
                            parameter: new_job,
                        });
                    },
                };
            }

            if (
                area_META?.HasIsOnlyHouseGutter &&
                area_META.HasIsOnlyHouseGutter() &&
                !this_area.Acknowledgements?.DoubleGutterAcknowledgement
            ) {
                return {
                    error: true,
                    title: "No Gutter (House Gutter Only) Warning",
                    message: [
                        <>
                            {window.LYSAGHT ? "Lysaght Living" : "Fielders Centenary"} do not recommend using the
                            existing house gutter only as this may contravene the stormwater requirements of the
                            National Construction Code. Where there is any doubt please allow for full/double gutters.
                        </>,
                    ],
                    primaryActionText: "Accept Warning",
                    primaryAction: () => {
                        let new_job = COMMON.deepCopy(job);
                        new_job.AreaSpecifications[areaIndex].Acknowledgements.DoubleGutterAcknowledgement = true;
                        //forced compliance/ mass settings, updates
                        new_job = validateFullJob(config, new_job, -1, app);
                        dispatch({
                            type: "NEW_JOB",
                            parameter: new_job,
                        });
                    },
                    secondaryActionText: "Change to 'Full/Double Gutter'",
                    secondaryAction: () => {
                        let new_job = COMMON.deepCopy(job);
                        if (area_META.FrontState.IsOnlyHouseGutter())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterF = 1;
                        if (area_META.BackState.IsOnlyHouseGutter())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterB = 1;
                        if (area_META.LeftState.IsOnlyHouseGutter())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterL = 1;
                        if (area_META.RightState.IsOnlyHouseGutter())
                            new_job.AreaSpecifications[areaIndex].GUTTERS_AND_DOWNPIPES.GutterR = 1;

                        if (new_job.AreaSpecifications[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS.length > 0) {
                            for (let mod of new_job.AreaSpecifications[areaIndex]?.ATTACHMENTS?.PARTIAL_ATTACHMENTS) {
                                if (mod.Ref.includes(new_job.AreaSpecifications[areaIndex].SHAPE.SheetDirection))
                                    mod.HasGutter = 1;
                            }
                        }

                        //forced compliance/ mass settings, updates
                        new_job = validateFullJob(config, new_job, -1, app);
                        dispatch({
                            type: "NEW_JOB",
                            parameter: new_job,
                        });
                    },
                };
            }
        }
    }
};

export const WarningIcon_Orange = <WarningIcon style={{ color: "orange", width: "20px", height: "12px" }} />;
export const ErrorIcon_Red = <ErrorIcon style={{ color: "darkred", width: "20px", height: "12px" }} />;

export const getWarnings = (job, user, config) => {
    let warnings = [];
    window.last_validateFullJob_hash = 0;
    job = validateFullJob(config, job, -1);

    if (jobWarningPopups({ job, user, config })) warnings.push(jobWarningPopups({ job, user, config }));

    let region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    let windzone = job?.SiteParameters?.WindData?.WindZone;

    let roofsheet_types = config.roofsheet_types;

    let errors = false;

    for (let i in job.AreaSpecifications) {
        const areaIndex = Number(i);
        const areaNumber = Number(i + 1);
        const last_area = job?.AreaSpecifications?.[Number(areaIndex) - 1];
        const this_area = job.AreaSpecifications[Number(areaIndex)];
        const next_area = job?.AreaSpecifications?.[Number(areaIndex) + 1];

        let is_flat = false;
        let is_pitched = false;
        let is_portal = false;

        if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) is_flat = true;
        if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) is_pitched = true;
        if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) is_portal = true;
        if (
            this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE &&
            windzone !== "N1" &&
            windzone !== "N2" &&
            windzone !== "N3"
        ) {
            errors = true;
            warnings.push(
                <div>
                    {ErrorIcon_Red} {"Louvres are only availabe in N1-N3"}
                    <br />
                </div>
            );
        }

        let gutter_downpipe_data = this_area[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];
        let roofsheet_data = this_area[BASIC_SPECS_SECTIONS.ROOF_SHEETING];
        let downpipe_types = config.downpipe_types;
        let this_downpipe = downpipe_types?.[gutter_downpipe_data.DownpipeType];

        if (this_downpipe?.max_overhang_offset_span !== null) {
            if (this_area?.SHAPE?.OH_Back > this_downpipe?.max_overhang_offset_span) {
                // Back too long
                warnings.push(
                    <>
                        {WarningIcon_Orange} Back overhang spans too large for elbow on '{this_downpipe.name}'. Max
                        overhang allowed: '{this_downpipe?.max_overhang_offset_span}'. Please change overhang or
                        downpipe.
                        <br />
                    </>
                );
            }

            if (this_area?.SHAPE?.OH_Front > this_downpipe?.max_overhang_offset_span) {
                // Front too long
                warnings.push(
                    <>
                        {WarningIcon_Orange} Front overhang spans too large for elbow on '{this_downpipe.name}'. Max
                        overhang allowed: '{this_downpipe?.max_overhang_offset_span}'. Please change overhang or
                        downpipe.
                        <br />
                    </>
                );
            }
        }
        const roofsheetgroup = roofsheet_types?.[roofsheet_data?.["RoofGroupType"]];
        const subType = roofsheetgroup?.subtypes?.[roofsheet_data?.RoofSubType];

        if (subType?.discontinued) {
            warnings.push(
                <div>
                    {WarningIcon_Orange}'{roofsheet_data?.RoofSubType}' is discontinued as a roof sheet and cannot be
                    supplied. Please change to another type.
                    <br />
                </div>
            );
        }

        if (is_flat) {
            if (this_area.SHAPE.SheetDirection === "Front" && gutter_downpipe_data.GutterF === 0)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter is recommended on Front side of Flat Area {areaNumber}
                        <br />
                    </div>
                );
            if (this_area.SHAPE.SheetDirection === "Back" && gutter_downpipe_data.GutterB === 0)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter is recommended on Back side of Flat Area {areaNumber}
                        <br />
                    </div>
                );
            if (this_area.SHAPE.SheetDirection === "Left" && gutter_downpipe_data.GutterL === 0)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter is recommended on Left side of Flat Area {areaNumber}
                        <br />
                    </div>
                );
            if (this_area.SHAPE.SheetDirection === "Right" && gutter_downpipe_data.GutterR === 0)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter is recommended on Right side of Flat Area {areaNumber}
                        <br />
                    </div>
                );
        }

        if (is_pitched) {
            if (this_area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentLeft === 0 && gutter_downpipe_data.GutterL === 0)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter missing on Left side of Pitched Area {areaNumber}
                        <br />
                    </div>
                );
            if (this_area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentRight === 0 && gutter_downpipe_data.GutterR === 0)
                warnings.push(
                    <>
                        {WarningIcon_Orange}Gutter missing on Right side of Pitched Area {areaNumber}
                        <br />
                    </>
                );
        }

        if (is_portal) {
            if (this_area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentTop === 0 && gutter_downpipe_data.GutterB === 0)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter is recommended on Back side of Portal Area {areaNumber}
                        <br />
                    </div>
                );
            if (
                this_area[BASIC_SPECS_SECTIONS.ATTACHMENTS].AttachmentBottom === 0 &&
                gutter_downpipe_data.GutterF === 0
            )
                warnings.push(
                    <div>
                        {WarningIcon_Orange}Gutter is recommended on Front side of Portal Area {areaNumber}
                        <br />
                    </div>
                );
            if (this_area[BASIC_SPECS_SECTIONS.SHAPE].Depth > 10000)
                warnings.push(
                    <div>
                        {WarningIcon_Orange}As Portal Area {areaNumber} has a width greater than 10m, Supplementary
                        engineering will be required.
                        <br />
                    </div>
                );
        }

        if (region && roofsheet_data?.RoofSheetData && (region === "C" || region === "D")) {
            if (!roofsheet_data?.RoofSheetData?.allow_cyclonic) {
                warnings.push(
                    <div>
                        {WarningIcon_Orange}
                        {roofsheet_data.RoofGroupType} is not suitable for Cyclonic regions. Please change to a suitable
                        roof sheet. <br />
                    </div>
                );
            }
        }
    }

    let one_off_warnings = {};

    for (let i in job.AreaSpecifications) {
        const areaIndex = Number(i);
        const areaNumber = Number(i + 1);
        const this_area = job.AreaSpecifications[Number(areaIndex)];

        let area_META = this_area?.META;

        if (area_META) {
            if (area_META?.HasIsOnlyHouseGutter && area_META.HasIsOnlyHouseGutter())
                one_off_warnings["No Gutter (House Gutter Only) Warning"] =
                    "House Gutter Only is not recommended. Double gutters are recommended instead.";
            if (area_META?.HasBoxGutterToFascia && area_META.HasBoxGutterToFascia())
                one_off_warnings["Box Gutter Warning"] = "Box Gutters are not recommended when attaching to Fascia.";
        }
    }

    for (var warning in one_off_warnings) {
        warnings.push(
            <div>
                {WarningIcon_Orange}
                {one_off_warnings[warning]}
                <br />
            </div>
        );
    }

    if (job.QuoteParameters?.ENGINEERING?.EngineeringLoads) {
        let loads = job.QuoteParameters?.ENGINEERING?.EngineeringLoads;
        var splitted = loads.split(/\r?\n/);
        var headers = splitted[1];
        var headers_split = headers.split("|");
        var extra_data_index = headers_split.indexOf("EXTRA_DATA");
        var name_index = headers_split.indexOf("NAME");
        let brackets = [];

        let col_headers = null;
        let col_headers_split = null;
        let col_name_index = null;
        let height_index = null;
        let embedment_index = null;
        let type_index = null;
        let columns_section = false;
        let columns_over_max = [];

        for (let split of splitted) {
            if (split.includes("***MODIFIED")) break;

            let beam = split.split("|");
            let extra_data = beam?.[extra_data_index];

            if (extra_data) {
                let extra_data_split = extra_data.split(";");
                for (let data_kvp of extra_data_split) {
                    if (data_kvp.startsWith("FA_1=") || data_kvp.startsWith("FA_2=")) {
                        let beam_name = beam[name_index];
                        let angle = Math.abs(toNumber(data_kvp.replace("FA_1=", "").replace("FA_2=", "")));

                        if ((angle > 60 && angle < 120) || (angle > 240 && angle < 300)) {
                            if (beam_name.startsWith("SF") || beam_name.startsWith("FB")) {
                                if (data_kvp.startsWith("FA_1=") && extra_data.includes("END_STATE_1=To Fascia")) {
                                    brackets.push(beam_name);
                                } else if (
                                    data_kvp.startsWith("FA_2=") &&
                                    extra_data.includes("END_STATE_2=To Fascia")
                                ) {
                                    brackets.push(beam_name);
                                }
                            } else {
                                brackets.push(beam_name);
                            }
                        }
                    }
                }
            }
            if (split.includes("***COLUMNS***")) columns_section = true;
            if (columns_section) {
                if (split.startsWith("NAME|")) {
                    col_headers = split;
                    col_headers_split = col_headers.split("|");
                    col_name_index = col_headers_split.indexOf("NAME");
                    height_index = col_headers_split.indexOf("HEIGHT");
                    embedment_index = col_headers_split.indexOf("EMBEDMENT");
                    type_index = col_headers_split.indexOf("COLUMN_TYPE");
                } else if (col_headers_split) {
                    let col_split = split.split("|");
                    let name = col_split[col_name_index];
                    let type = col_split[type_index];
                    let height = Number(col_split[height_index]);
                    let embed = Number(col_split[embedment_index]);
                    let length = height + embed + 100;
                    let max_length = config?.beam_types?.[type]?.max_length;

                    if (max_length && Number(max_length) < length) {
                        columns_over_max.push(
                            <>
                                {name} - {type} @ {length}mm (max:{max_length}mm)
                                <br />
                            </>
                        );
                    }
                }
            }
        }

        if (brackets.length > 0) {
            warnings.push(
                <>
                    {WarningIcon_Orange}This design has a beam to beam/fascia angle of less than 30 degrees (
                    {ConvertListToString(brackets)}). Please redesign to have an angle greater than 30 degrees. <br />
                </>
            );
        }
        if (columns_over_max.length > 0) {
            warnings.push(
                <>
                    {WarningIcon_Orange}This design has columns that are supplied longer than the available max length:{" "}
                    {<br />}
                    {<br />}
                    {columns_over_max}
                    {<br />}If you continue, they may be supplied split which may not work. Please redesign or change
                    column types. <br />
                </>
            );
        }
    }

    if (window?.paper?.project?.getItems) {
        let warning_messages_added = [];

        let warning_and_error_items = window.paper.project.getItems({
            has_warning: true,
        });
        warning_and_error_items.push.apply(
            warning_and_error_items,
            window.paper.project.getItems({
                has_error: true,
            })
        );

        warning_and_error_items.forEach(function (item) {
            if (item?.warning_msg) {
                if (!warning_messages_added.includes(item.warning_msg)) {
                    warnings.push(
                        <div>
                            {WarningIcon_Orange} {item.warning_msg.replaceAll("_", " ")}
                            <br />
                        </div>
                    );
                    warning_messages_added.push(item.warning_msg);
                }
            }
            if (item?.error_msg) {
                if (!warning_messages_added.includes(item.error_msg)) {
                    errors = true;
                    warnings.push(
                        <div>
                            {ErrorIcon_Red} {item.error_msg.replaceAll("_", " ")}
                            <br />
                        </div>
                    );
                    warning_messages_added.push(item.error_msg);
                }
            }
        });
    }

    if (job.SupplementaryEngineering && job.SupplementaryEngineering.length > 0) {
        job.SupplementaryEngineering.forEach(function (item) {
            warnings.push(
                <div>
                    {WarningIcon_Orange} {item}
                    <br />
                </div>
            );
        });
    }

    if (warnings.length > 0) {
        return {
            warning: true,
            errors: errors,
            title: "Design Warnings",
            message: warnings,
        };
    }

    return warnings;
};

export const checkSupplementaryEngineering = (config, job) => {
    let SupplementaryEngineering = [];

    for (let i in job.AreaSpecifications) {
        const areaIndex = Number(i);
        const areaNumber = Number(i) + 1;
        const last_area = job?.AreaSpecifications?.[Number(areaIndex) - 1];
        const this_area = job.AreaSpecifications[Number(areaIndex)];
        const next_area = job?.AreaSpecifications?.[Number(areaIndex) + 1];

        let is_flat = false;
        let is_pitched = false;
        let is_portal = false;

        if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) is_flat = true;
        if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) is_pitched = true;
        if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) is_portal = true;

        let gutter_downpipe_data = this_area[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES];

        if (is_flat) {
        }

        if (is_pitched) {
        }

        if (is_portal) {
            if (this_area[BASIC_SPECS_SECTIONS.SHAPE].Depth > 10000)
                SupplementaryEngineering.push(
                    "Gable 'Area " +
                        areaNumber +
                        "' width greater than 10m. Supplementary Engineering Design Check required."
                );
            else if (this_area[BASIC_SPECS_SECTIONS.SHAPE].Depth > 6000 && job.AreaSpecifications.length > 1)
                SupplementaryEngineering.push(
                    "Gable 'Area " +
                        areaNumber +
                        "' width greater than 6m in a multi area job. Supplementary Engineering Design Check required."
                );
        }
    }

    return SupplementaryEngineering;
};

const engineeringCodes = ({ job }) => {
    const engineeringHashCode = job?.QuoteParameters?.ENGINEERING?.engineeringHashCode;
    const currentHashCode = GetShapeUpdateString(false, true);
    return { engineeringHashCode, currentHashCode };
};

export const engineeringChanged = ({ job }) => {
    const { engineeringHashCode, currentHashCode } = engineeringCodes({ job });
    if (engineeringHashCode !== currentHashCode) return true;
    return false;
};

export const engineeringPassed = ({ job }) => {
    const { engineeringHashCode, currentHashCode } = engineeringCodes({ job });

    const OVERSTRESS_FACTOR = 1.03;
    let MaxResults =
        toNumber(job?.QuoteParameters?.ENGINEERING?.EngineeringResults?.MaxResultOverAll) / OVERSTRESS_FACTOR;
    let MaxResultsText = job?.QuoteParameters?.ENGINEERING?.EngineeringResults?.maxResultOverAllText;

    let engValid = false;
    let engValidNoOverride = false;
    const engOverride = job?.OverrideEngineering ? true : false;

    if (
        engineeringHashCode &&
        currentHashCode &&
        engineeringHashCode === currentHashCode &&
        MaxResults &&
        MaxResults < 1.01
    ) {
        engValid = true;
        engValidNoOverride = true;
    }

    let engUpdated = false;
    if (engineeringHashCode && currentHashCode && engineeringHashCode === currentHashCode) engUpdated = true;

    if (engOverride) engValid = true;

    if (job?.DesignParameters?.DeckMode === 1) {
        engValid = false;
        MaxResults = toNumber(job?.QuoteParameters?.ENGINEERING?.Data?.[0]?.MaxOverallCapacity);
        if (MaxResults && MaxResults < 1.01) {
            engValid = true;
            engValidNoOverride = true;
        }
    }

    if (job?.DesignParameters?.LouvreMode === 1) {
        engValid = true;
        engValidNoOverride = true;
    }

    return { engValid, MaxResultsText, engOverride, engValidNoOverride, engUpdated };
};

// Return actual structure length from engineering based on area index
export const getActualLength = ({ job, areaIndex }) => {
    return job?.QuoteParameters?.AREA_DATA?.[areaIndex]?.ActualStructureWidth;
};

export const validateJobOrderReadiness = async ({
    job,
    config,
    app,
    user,
    overrideEngineeringAction,
    continueEngineeringAction,
    confirmEngineeringAction,
    continueWarningAction,
    forOrder = false,
    dispatch,
    defaultFootingChange,
    defaultPostChange,
    bom_was_open,
}) => {
    let has_flat = false;
    let has_pitched = false;
    let has_portal = false;

    window.last_validateFullJob_hash = 0;
    job = validateFullJob(config, job, -1, app);

    const carportMode = job?.DesignParameters?.CarportMode === 1;

    for (const area of job.AreaSpecifications) {
        if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT) has_flat = true;
        if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) has_pitched = true;
        if (area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) has_portal = true;
    }

    //check piched has a flat next to it
    if (has_pitched) {
        for (const i in job.AreaSpecifications) {
            const areaIndex = Number(i);
            const last_area = job?.AreaSpecifications?.[Number(areaIndex) - 1];
            const this_area = job.AreaSpecifications[Number(areaIndex)];
            const next_area = job?.AreaSpecifications?.[Number(areaIndex) + 1];

            if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) {
                let hasAdjacentFlat = false;
                if (
                    last_area &&
                    last_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
                    last_area.SHAPE.Length > 1999
                )
                    hasAdjacentFlat = true;
                if (
                    next_area &&
                    next_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
                    next_area.SHAPE.Length > 1999
                )
                    hasAdjacentFlat = true;

                if (!hasAdjacentFlat) {
                    return {
                        error: true,
                        title: "Pitched Gable Design Error",
                        message: [
                            <>
                                Pitched Gable Design must have at least one Flat Area adjacent to it with a min of
                                2000mm length.
                            </>,
                        ],
                    };
                }
            }
        }
    }

    for (let i in job.AreaSpecifications) {
        const areaIndex = Number(i);
        const last_area = job?.AreaSpecifications?.[Number(areaIndex) - 1];
        const this_area = job.AreaSpecifications[Number(areaIndex)];
        const next_area = job?.AreaSpecifications?.[Number(areaIndex) + 1];

        // check for freestanding design needing RHS columns
        if (
            this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT ||
            this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED
        ) {
            if (
                job.DesignParameters.Freestanding &&
                !this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType.includes("P/C") &&
                !this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType.includes("SHS")
            ) {
                return {
                    error: true,
                    title: "Freestanding Post Error",
                    message: [<>A Freestanding Flat or Pitched Gable section must has SHS Posts.</>],
                    secondaryActionText: "Change to '65mm SHS x 3mm'?",
                    secondaryAction: () => {
                        this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostType = "65mm x 65mm x 3mm P/C";
                        return {
                            type: UPDATE_AREA_SPECIFICATION,
                            index: areaIndex,
                            section: null,
                            subsection: null,
                            parameter: null,
                            value: this_area,
                            error: null,
                        };
                    },
                };
            }
        }

        if (forOrder) {
            if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.DECK) {
            } else if (this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.LOUVRE) {
                if (this_area[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour === "TBA") {
                    return {
                        error: true,
                        title: "Cannot Submit Order With Undecided Colours",
                        message: [<>{"Kit colour has not been chosen. Please set before proceeding."}</>],
                    };
                }
            } else {
                let TBA = [];
                if (this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].PostCol === "TBA") TBA.push("Post");
                if (
                    this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamCol1 === "TBA" ||
                    this_area[BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS].BeamCol2 === "TBA"
                )
                    TBA.push("Beam");
                if (this_area[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RoofSheetColour === "TBA") TBA.push("Roof Sheet");
                if (this_area[BASIC_SPECS_SECTIONS.ROOF_SHEETING].FlashingColour === "TBA") TBA.push("Flashing");
                if (this_area[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].GutterCol === "TBA") TBA.push("Gutter");
                if (this_area[BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES].DownpipeCol === "TBA") TBA.push("Downpipe");

                if (
                    this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED ||
                    this_area.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL
                ) {
                    if (this_area[BASIC_SPECS_SECTIONS.ROOF_SHEETING].RidgeColour === "TBA") TBA.push("Ridge");
                }

                if (TBA.length > 0) {
                    return {
                        error: true,
                        title: "Cannot Submit Order With Undecided Colours",
                        message: [
                            <>{ConvertListToString(TBA) + " have colour set to TBA. Please set before proceeding."}</>,
                        ],
                    };
                }
            }
        }
    }

    const { engValid, MaxResultsText, engOverride } = engineeringPassed({ job });
    const engChanged = engineeringChanged({ job });

    if (!engValid && !bom_was_open && !engOverride) {
        try {
            await continueEngineeringAction({
                user,
                adminOnly: app?.user?.BusinessDetails?.EngineerOverride !== "ALL USERS",
                MaxResultsText,
                confirmEngineeringAction,
            });
            // Continue with your logic here if the user pressed "Continue"
        } catch {
            return {
                cancel: true,
            };
            // Handle the case where the user pressed "Cancel" or closed the dialog
            // You can either do nothing or add specific handling here
        }
    }

    let jobStateWarnings = jobReadyStateErrorPopups({
        job,
        app,
        user,
        config,
        dispatch,
        continueWarningAction,
        confirmEngineeringAction,
        overrideEngineeringAction,
        engValid: job?.OverrideEngineering,
    });

    if (jobStateWarnings && !engOverride) return jobStateWarnings;

    if (job.QuoteParameters?.ENGINEERING?.EngineeringLoads) {
        let loads = job.QuoteParameters?.ENGINEERING?.EngineeringLoads;
        var splitted = loads.split(/\r?\n/);
        var headers = splitted[1];
        var headers_split = headers.split("|");
        let col_headers = null;
        let col_headers_split = null;
        let col_name_index = null;
        let height_index = null;
        let embedment_index = null;
        let type_index = null;
        let GROUND_CONNECTION_index = null;
        let columns_section = false;
        let columns_over_max = [];
        let num_columns = 0;
        let num_columns_concrete_in = 0;

        for (let split of splitted) {
            if (split.includes("***MODIFIED")) break;
            if (split.includes("***COLUMNS***")) columns_section = true;
            if (columns_section) {
                if (split.startsWith("NAME|")) {
                    col_headers = split;
                    col_headers_split = col_headers.split("|");
                    col_name_index = col_headers_split.indexOf("NAME");
                    height_index = col_headers_split.indexOf("HEIGHT");
                    GROUND_CONNECTION_index = col_headers_split.indexOf("GROUND_CONNECTION");
                    embedment_index = col_headers_split.indexOf("EMBEDMENT");
                    type_index = col_headers_split.indexOf("COLUMN_TYPE");
                } else if (col_headers_split) {
                    let col_split = split.split("|");
                    let name = col_split[col_name_index];
                    let type = col_split[type_index];
                    let height = Number(col_split[height_index]);
                    let embed = Number(col_split[embedment_index]);
                    let GROUND_CONNECTION = col_split[GROUND_CONNECTION_index];
                    let length = height + embed + 100;

                    num_columns++;
                    if (GROUND_CONNECTION === "Concrete In") num_columns_concrete_in++;
                }
            }
        }

        if (job.DesignParameters.Freestanding && num_columns_concrete_in / num_columns < 0.5 && !carportMode) {
            return {
                error: true,
                title: "More embedded posts required",
                message: [
                    <>
                        {
                            "In a freestanding structure, more than 50% of posts must be embedded. Please remove some 'bolt to slab' posts."
                        }
                    </>,
                ],
            };
        }
    }

    return false;
};

export function MaxDeckJoistSpans(joist_section, joist_spacing, structure_width, bearer_spacing, joist_spans) {
    let span_config = 1;

    let joist_spacing_data = {
        1: {
            SB10865: {
                300: 3300,
                450: 2890,
                600: 2620,
            },
            SB15865: {
                300: 4450,
                450: 3870,
                600: 3530,
            },
            SB20865: {
                300: 5500,
                450: 4800,
                600: 4380,
            },
        },
        2: {
            SB10865: {
                300: 3740,
                450: 3260,
                600: 2960,
            },
            SB15865: {
                300: 5020,
                450: 4390,
                600: 3990,
            },
            SB20865: {
                300: 6170,
                450: 5450,
                600: 4940,
            },
        },
        3: {
            SB10865: {
                300: 3610,
                450: 3160,
                600: 2870,
            },
            SB15865: {
                300: 4860,
                450: 4250,
                600: 3860,
            },
            SB20865: {
                300: 6030,
                450: 5270,
                600: 4800,
            },
        },
    };
    if (joist_spans) joist_spacing_data = joist_spans;

    return joist_spacing_data[span_config][joist_section][joist_spacing];
}

export function MaxDeckBearerSpans(
    bearer_section,
    structure_width,
    structure_length,
    bearer_spacing,
    post_spacing,
    bearer_spans = null
) {
    let span_config = 1;
    if (structure_length > post_spacing) span_config = 2;
    if (structure_length > post_spacing * 2) span_config = 3;

    let num_bearers = 2 + Math.trunc((structure_width - 65) / bearer_spacing);
    let FLW = structure_width / (num_bearers - 1);

    if (FLW <= 900) FLW = 900;
    else if (FLW <= 1200) FLW = 1200;
    else if (FLW <= 1500) FLW = 1500;
    else if (FLW <= 1800) FLW = 1800;
    else if (FLW <= 2100) FLW = 2100;
    else if (FLW <= 2400) FLW = 2400;
    else if (FLW <= 3000) FLW = 3000;
    else if (FLW <= 3600) FLW = 3600;
    else FLW = 4000;

    let bearer_span_data = {
        1: {
            SB10865: {
                900: 2780,
                1200: 2530,
                1500: 2340,
                1800: 2200,
                2100: 2100,
                2400: 2000,
                3000: 1860,
                3600: 1750,
                4000: 1690,
            },
            SB15865: {
                900: 3740,
                1200: 3320,
                1500: 3150,
                1800: 2980,
                2100: 2660,
                2400: 2340,
                3000: 1880,
                3600: 1570,
                4000: 1420,
            },
            SB20865: {
                900: 4380,
                1200: 3350,
                1500: 2710,
                1800: 2280,
                2100: 1970,
                2400: 1730,
                3000: 1390,
                3600: 1160,
                4000: 1050,
            },
        },
        2: {
            SB10865: {
                900: 3150,
                1200: 2850,
                1500: 2650,
                1800: 2390,
                2100: 2180,
                2400: 2000,
                3000: 1730,
                3600: 1520,
                4000: 1410,
            },
            SB15865: {
                900: 3800,
                1200: 3100,
                1500: 2610,
                1800: 2260,
                2100: 1980,
                2400: 1770,
                3000: 1450,
                3600: 1220,
                4000: 1110,
            },
            SB20865: {
                900: 3330,
                1200: 2600,
                1500: 2120,
                1800: 1800,
                2100: 1550,
                2400: 1370,
                3000: 1100,
                3600: 930,
                4000: 840,
            },
        },
        3: {
            SB10865: {
                900: 3050,
                1200: 2780,
                1500: 2580,
                1800: 2410,
                2100: 2300,
                2400: 2170,
                3000: 1870,
                3600: 1630,
                4000: 1510,
            },
            SB15865: {
                900: 4080,
                1200: 3300,
                1500: 2760,
                1800: 2370,
                2100: 2080,
                2400: 1840,
                3000: 1500,
                3600: 1270,
                4000: 1150,
            },
            SB20865: {
                900: 3470,
                1200: 2700,
                1500: 2200,
                1800: 1860,
                2100: 1610,
                2400: 1410,
                3000: 1140,
                3600: 950,
                4000: 860,
            },
        },
    };

    if (bearer_spans) bearer_span_data = bearer_spans;
    return bearer_span_data[span_config][bearer_section][FLW];
}

export function MaxDeckPostHeights(RHS_size, post_spans = null) {
    let spans = {
        "65mm x 65mm x 2mm P/C": 2095,
        "65mm x 65mm x 2.5mm P/C": 2070,
        "65mm x 65mm x 3mm P/C": 2070,
        "75mm x 75mm x 2.5mm P/C": 2405,
        "75mm x 75mm x 3mm P/C": 2390,
        "100mm x 100mm x 3mm P/C": 3225,
        default: 2070,
    };
    if (post_spans) spans = post_spans;

    let default_height = spans?.["default"] ? spans?.["default"] : 2070;

    if (spans[RHS_size]) return spans[RHS_size];
    return default_height;
}

export function EngineerDeckv2(beam_and_post_data) {
    let JoistActual = 0;
    let JoistCapacity = 0;
    let BearerActual = 0;
    let BearerCapacity = 0;
    let PostCapacity = 0;

    let BracingSummary = {};
    let FootingSummary = {};

    if (window.paper && window.svg) {
        let beams = GetItems({ sel_type: "beam" });

        for (let beam of beams) {
            if (beam?.beamName === "Joist") {
                if (beam.eng_capacity && toNumber(beam.eng_capacity) > JoistCapacity) {
                    JoistCapacity = toNumber(beam.eng_capacity);
                }
                if (beam.lengthQQ && beam.lengthQQ > JoistActual) {
                    JoistActual = beam.lengthQQ;
                }
            }
            if (beam?.beamName?.includes && beam?.beamName.includes("Bearer")) {
                if (beam.eng_capacity && toNumber(beam.eng_capacity) > BearerCapacity) {
                    BearerCapacity = toNumber(beam.eng_capacity);
                }
                if (beam.lengthQQ && beam.lengthQQ > BearerActual) {
                    BearerActual = beam.lengthQQ;
                }
            }
        }

        let posts = GetItems({ sel_type: "post" });

        for (let post of posts) {
            if (post.eng_capacity && toNumber(post.eng_capacity) > PostCapacity) {
                PostCapacity = toNumber(post.eng_capacity);
            }
        }

        let origin = GetItems({ typeQQ: "origin" });

        if (origin[0] && origin[0]?.deck_bracing) {
            let bracing_summary_split = origin[0]?.deck_bracing.split("/");
            if (bracing_summary_split.length > 0) {
                BracingSummary.bracing_ns_actual = toNumber(bracing_summary_split[0]);
            }
            if (bracing_summary_split.length > 1) {
                BracingSummary.bracing_ns_required = bracing_summary_split[1];
            }
            if (bracing_summary_split.length > 2) {
                BracingSummary.bracing_ew_actual = toNumber(bracing_summary_split[2]);
            }
            if (bracing_summary_split.length > 3) {
                BracingSummary.bracing_ew_required = bracing_summary_split[3];
            }
        }

        if (origin[0] && origin[0]?.deck_footing) {
            let footing_summary_split = origin[0]?.deck_footing.split("/");
            if (footing_summary_split.length > 0) {
                FootingSummary.clay_passed = COMMON.toBool(footing_summary_split[0]);
            }
            if (footing_summary_split.length > 1) {
                FootingSummary.clay_passed_width = toNumber(footing_summary_split[1]);
            }
            if (footing_summary_split.length > 2) {
                FootingSummary.clay_passed_depth = toNumber(footing_summary_split[2]);
            }
            if (footing_summary_split.length > 3) {
                FootingSummary.sand_passed = COMMON.toBool(footing_summary_split[3]);
            }
            if (footing_summary_split.length > 4) {
                FootingSummary.sand_passed_width = toNumber(footing_summary_split[4]);
            }
            if (footing_summary_split.length > 5) {
                FootingSummary.sand_passed_depth = toNumber(footing_summary_split[5]);
            }
        }
    }

    let bracing_capacity_ratio_NS = 0;
    if (BracingSummary.bracing_ns_required > 0) {
        if (BracingSummary.bracing_ns_actual === 0) {
            bracing_capacity_ratio_NS = 9.99;
        } else {
            bracing_capacity_ratio_NS = BracingSummary.bracing_ns_required / BracingSummary.bracing_ns_actual;
        }
    }
    let bracing_capacity_ratio_EW = 0;
    if (BracingSummary.bracing_ew_required > 0) {
        if (BracingSummary.bracing_ew_actual === 0) {
            bracing_capacity_ratio_EW = 9.99;
        } else {
            bracing_capacity_ratio_EW = BracingSummary.bracing_ew_required / BracingSummary.bracing_ew_actual;
        }
    }

    return {
        JoistMaxSpacing: beam_and_post_data.PurlinSpacing,
        JoistMaxSpan: null,
        JoistActual: JoistActual,
        JoistCapacity: JoistCapacity,
        BearerMaxSpacing: null,
        BearerMaxSpan: null,
        BearerActual: BearerActual,
        BearerCapacity: BearerCapacity,
        PostMaxHeight: null,
        PostCapacity: PostCapacity,
        MaxOverallCapacity: Math.max(
            JoistCapacity,
            BearerCapacity,
            PostCapacity,
            bracing_capacity_ratio_EW,
            bracing_capacity_ratio_NS
        ),
        BracingSummary: BracingSummary,
        FootingSummary: FootingSummary,
    };
}

export function EngineerDeck(
    post_section,
    joist_section,
    joist_spacing,
    bearer_section,
    structure_width,
    structure_length,
    structure_height,
    bearer_spacing,
    post_spacing,
    post_spans = null,
    bearer_spans = null,
    joist_spans = null
) {
    let span_config = 1;
    if (structure_width - 65 > bearer_spacing) span_config = 2;
    if (structure_width - 65 > bearer_spacing * 2) span_config = 3;
    if (structure_width - 65 > bearer_spacing * 3) span_config = 4;

    let JoistMaxSpan = MaxDeckJoistSpans(joist_section, joist_spacing, structure_width, bearer_spacing, joist_spans);
    let JoistActual = (structure_width - 65) / span_config;
    let JoistCapacity = JoistActual / JoistMaxSpan;
    let BearerMaxSpan = MaxDeckBearerSpans(
        bearer_section,
        structure_width,
        structure_length,
        bearer_spacing,
        post_spacing,
        bearer_spans
    );
    let BearerActual = post_spacing;
    let BearerCapacity = BearerActual / BearerMaxSpan;
    let PostMaxHeight = MaxDeckPostHeights(post_section, post_spans);
    let PostCapacity = structure_height / PostMaxHeight;

    return {
        JoistMaxSpacing: joist_spacing,
        JoistMaxSpan: JoistMaxSpan,
        JoistActual: JoistActual,
        JoistCapacity: JoistCapacity,
        BearerMaxSpacing: bearer_spacing,
        BearerMaxSpan: BearerMaxSpan,
        BearerActual: BearerActual,
        BearerCapacity: BearerCapacity,
        PostMaxHeight: PostMaxHeight,
        PostCapacity: PostCapacity,
        MaxOverallCapacity: Math.max(JoistCapacity, BearerCapacity, PostCapacity),
    };
}

const carportNeedsExtraPurlin = (job, designTemplateName) => {
    const region = job?.SiteParameters?.WindData?.WindZoneAS1170?.region;
    const isCyclonicRegion = region === "C" || region === "D";

    const isCyclonicDesign =
        designTemplateName === "Double Cyclonic Colorbond" || designTemplateName === "Single Cyclonic Colorbond";

    return !isCyclonicRegion && isCyclonicDesign;
};
